(() => {
  if (document.body.classList.contains("is-505")) return;

  const DRIVE = "C";
  const SERIAL = "0505-2018";
  const VOLUME = "HEARTS";
  const BORN = { date: "05/05/2018", time: "05:05a" };
  const BINARIES = /\.(exe|com|sys|dll|bin|avi|mov|mp3|wav|jpg|jpeg|png|gif)$/i;

  const ENV0 = {
    COMSPEC: "C:\\FIVEHEARTS\\SYSTEM\\CMD.EXE",
    PATH: "C:\\FIVEHEARTS\\SYSTEM;C:\\FIVEHEARTS\\WINDOWS",
    PROMPT: "$P$G",
    USERNAME: "GUEST",
    USERDOMAIN: "FIVEHEARTS",
    COMPUTERNAME: "FIVEHEARTS",
    OS: "FIVEHEARTS_OS",
    WINDIR: "C:\\FIVEHEARTS\\WINDOWS",
    TEMP: "C:\\FIVEHEARTS\\TEMP",
    TMP: "C:\\FIVEHEARTS\\TEMP",
    SYSTEMDRIVE: "C:",
    SYSTEMROOT: "C:\\FIVEHEARTS\\WINDOWS",
    HOMEDRIVE: "C:",
    HOMEPATH: "\\FIVEHEARTS",
    NUMBER_OF_PROCESSORS: "1",
    PROCESSOR_ARCHITECTURE: "x86",
    PROMPT_VER: "5.05"
  };

  const ASSOC0 = {
    ".txt": "txtfile",
    ".bat": "batfile",
    ".cmd": "cmdfile",
    ".com": "comfile",
    ".exe": "exefile",
    ".sys": "sysfile",
    ".ini": "inifile",
    ".wav": "wavfile",
    ".mp3": "mp3file",
    ".avi": "avifile",
    ".mov": "movfile",
    ".jpg": "jpegfile",
    ".jpeg": "jpegfile",
    ".png": "pngfile"
  };

  const file = (body, extra) => Object.assign({
    kind: "file",
    body: String(body),
    ro: false,
    hidden: false,
    stamp: BORN
  }, extra || {});
  const dir = (children, extra) => Object.assign({
    kind: "dir",
    children: children || {},
    ro: false,
    hidden: false,
    stamp: BORN
  }, extra || {});

  const INFO = [
    "WHAT IS FIVEHEARTS?",
    "",
    "A UK house of drawing, records, and a camera.",
    "The shop is one surface.",
    "",
    "Art   — Scumboy / Blackwater",
    "Music — Joedotwhy",
    "Video — Rarenugly"
  ].join("\r\n");

  const makeFs = () => dir({
    FIVEHEARTS: dir({
      "INFO.TXT": file(INFO),
      "README.TXT": file("House notes.\r\nLeave an address if you want restocks and tapes.\r\nThe desk is the index.\r\nType HELP in CMD."),
      "WELCOME.TXT": file("Welcome to FIVEHEARTS CMD 5.05\r\n\r\nThe shop is one surface.\r\nThe desk is the index.\r\n\r\nType HELP\r\nType DIR\r\nType TREE /F\r\nType TYPE INFO.TXT\r\nType TYPE CREDITS.TXT\r\nType TYPE LOGS\\BOOTLOG.TXT\r\nType VOL\r\nType VER"),
      "CREDITS.TXT": file("FIVEHEARTS\r\nUK artist collective\r\n\r\nArt   — Scumboy / Blackwater\r\nMusic — Joedotwhy\r\nVideo — Rarenugly\r\n\r\nInstagram @fiveheartsuk\r\nThe shop is one surface."),
      "HISTORY.TXT": file("05/05/2018  desk assembled\r\n05/05/2018  volume HEARTS formatted\r\n2018–2026   tapes, stills, objects\r\nnow         the house is open\r\n\r\nDo not crop the wings.\r\nDo not squash the seal."),
      "ZORK.EXE": file("MZ", { bin: true, bytes: 86016, ro: true }),
      "AUTOEXEC.BAT": file("@ECHO OFF\r\nSET PATH=C:\\FIVEHEARTS\\SYSTEM;C:\\FIVEHEARTS\\WINDOWS\r\nPROMPT $P$G\r\nECHO FIVEHEARTS CMD 5.05\r\nECHO The shop is one surface.\r\nECHO Type HELP"),
      "CONFIG.SYS": file("FILES=40\r\nBUFFERS=20\r\nDEVICE=C:\\FIVEHEARTS\\SYSTEM\\HIMEM.SYS\r\nDOS=HIGH,UMB\r\nSTACKS=9,256"),
      LOGS: dir({
        "BOOTLOG.TXT": file("[001] BIOS HOUSE 5.05\r\n[002] HIMEM.SYS loaded\r\n[003] KERNEL.SYS resident\r\n[004] CMD.EXE start\r\n[005] Desk mounted\r\n[006] Tape idle\r\n[007] Shop till online\r\n[008] Wings OK"),
        "DESK.LOG": file("file drag enabled\r\nwindows stack=layer\r\nrail=right\r\ndock=thumb\r\nshop=leaves the os"),
        "TAPE.LOG": file("Rarenugly archive indexed\r\n2018–2026\r\nno autoplay")
      }),
      DESK: dir({
        "WINGS.TXT": file("WINGS.PNG\r\n3000 x 2073\r\nobject-fit: contain\r\nnever crop\r\nnever squash\r\nred / black / white\r\ngold is lining only."),
        "CLOCK.TXT": file("The desk keeps local time.\r\nThe tape keeps its own.")
      }),
      MUSIC_VIDEOS: dir({
        "WHERE_IM_AT.AVI": file("", { bin: true, bytes: 482110 }),
        "60_SECONDS.AVI": file("", { bin: true, bytes: 301004 }),
        "ONAROLL.AVI": file("", { bin: true, bytes: 512998 }),
        "PAINLESS.AVI": file("", { bin: true, bytes: 448120 }),
        "TWITCHING.AVI": file("", { bin: true, bytes: 390441 }),
        "BUSY_CUT_SOUND.AVI": file("", { bin: true, bytes: 277300 }),
        "OXY.AVI": file("", { bin: true, bytes: 410882 }),
        "THE_GARDEN.AVI": file("", { bin: true, bytes: 529441 }),
        "BACK2BACK.AVI": file("", { bin: true, bytes: 366010 }),
        "YKWII.AVI": file("", { bin: true, bytes: 401552 }),
        "YELLOW_TAPE.AVI": file("", { bin: true, bytes: 388201 }),
        "CURSE_MARK.AVI": file("", { bin: true, bytes: 455900 })
      }),
      PHOTOS: dir({
        "DSC00344.JPG": file("", { bin: true, bytes: 210448 }),
        "IMG-2446.JPG": file("", { bin: true, bytes: 188220 }),
        "CHAINIMAGE.PNG": file("", { bin: true, bytes: 96440 })
      }),
      AUDIO: dir({
        "emptiness.mp3": file("", { bin: true, bytes: 4200112 }),
        "NEON_LIGHTS.mp3": file("", { bin: true, bytes: 3810044 }),
        "no_intervening.mp3": file("", { bin: true, bytes: 2994410 }),
        "PAINLESS.mp3": file("", { bin: true, bytes: 3502201 }),
        "TWITCHING.mp3": file("", { bin: true, bytes: 3330088 }),
        "PLAYLIST.M3U": file("#EXTM3U\r\n#EXTINF:-1,emptiness\r\nemptiness.mp3\r\n#EXTINF:-1,NEON LIGHTS\r\nNEON_LIGHTS.mp3\r\n#EXTINF:-1,no intervening\r\nno_intervening.mp3\r\n#EXTINF:-1,PAINLESS\r\nPAINLESS.mp3\r\n#EXTINF:-1,TWITCHING\r\nTWITCHING.mp3")
      }),
      SHOP: dir({
        "CATALOG.TXT": file("The shop is one surface.\r\nOpen SHOP on the desk to walk the floor.")
      }),
      BIN: dir({
        "UNRELEASED_01.WAV": file("", { bin: true, bytes: 880120 }),
        "UNRELEASED_02.WAV": file("", { bin: true, bytes: 904441 }),
        "VX_CUT_UNUSED.MOV": file("", { bin: true, bytes: 1200441 }),
        "DRAFT_STILL.JPG": file("", { bin: true, bytes: 77120 }),
        "VIRUS.exe": file("MZ", { bin: true, bytes: 5050, ro: true })
      }),
      SYSTEM: dir({
        "COMMAND.COM": file("MZ", { bin: true, bytes: 92870, ro: true }),
        "CMD.EXE": file("MZ", { bin: true, bytes: 136192, ro: true }),
        "ZORK.EXE": file("MZ", { bin: true, bytes: 86016, ro: true }),
        "HIMEM.SYS": file("", { bin: true, bytes: 14112, ro: true }),
        "KERNEL.SYS": file("", { bin: true, bytes: 220440, ro: true, hidden: true }),
        "IO.SYS": file("", { bin: true, bytes: 40566, ro: true, hidden: true }),
        "MSDOS.SYS": file("", { bin: true, bytes: 38308, ro: true, hidden: true }),
        "ANSI.SYS": file("", { bin: true, bytes: 9064, ro: true }),
        "COUNTRY.SYS": file("", { bin: true, bytes: 17054, ro: true }),
        "MOUSE.COM": file("MZ", { bin: true, bytes: 56480, ro: true })
      }),
      WINDOWS: dir({
        "WIN.COM": file("MZ", { bin: true, bytes: 50512, ro: true }),
        "NOTEPAD.EXE": file("MZ", { bin: true, bytes: 33792 }),
        "CALC.EXE": file("MZ", { bin: true, bytes: 58880 }),
        "EXPLORER.EXE": file("MZ", { bin: true, bytes: 184320 }),
        "WINAMP.EXE": file("MZ", { bin: true, bytes: 220160 }),
        "IEXPLORE.EXE": file("MZ", { bin: true, bytes: 312000 }),
        "WINVER.EXE": file("MZ", { bin: true, bytes: 12288 }),
        "WIN.INI": file("[windows]\r\nspooler=yes\r\nload=\r\nrun=\r\nBeep=yes\r\nBorderWidth=3\r\n[desktop]\r\nWallpaper=WINGS.PNG\r\nTileWallpaper=0"),
        "SYSTEM.INI": file("[boot]\r\nshell=explorer.exe\r\n[386Enh]\r\nwoafont=dosapp.fon\r\nEGA80WOA.FON=EGA80WOA.FON\r\n[drivers]\r\nwave=fhdesk.drv"),
        "CONTROL.INI": file("[current]\r\ncolor schemes=House Red\r\n[color schemes]\r\nHouse Red=0,0,0 244,241,236 204,30,30"),
        "PROGMAN.INI": file("[Settings]\r\nWindow=0 0 640 480\r\n[Groups]\r\nGroup1=C:\\FIVEHEARTS\\DESK")
      }),
      TEMP: dir({})
    })
  });

  const sessions = new Map();
  const pad = (n, z = 2) => String(n).padStart(z, "0");
  const clone = (v) => JSON.parse(JSON.stringify(v));

  const stampNow = () => {
    const d = new Date();
    let h = d.getHours();
    const ap = h >= 12 ? "p" : "a";
    h = h % 12 || 12;
    return {
      date: `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`,
      time: `${pad(h)}:${pad(d.getMinutes())}${ap}`
    };
  };

  const sizeOf = (node) => {
    if (!node) return 0;
    if (node.kind === "file") return node.bytes != null ? node.bytes : (node.body || "").length;
    return Object.keys(node.children || {}).reduce((n, k) => n + sizeOf(node.children[k]), 0);
  };

  const joinPath = (parts) => (DRIVE + ":\\" + parts.join("\\")).replace(/\\+$/, "") || (DRIVE + ":\\");
  const showPath = (parts) => {
    const p = joinPath(parts);
    return p.endsWith("\\") ? p : p;
  };

  const globRe = (g) => {
    const s = String(g).replace(/[.+^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*").replace(/\?/g, ".");
    return new RegExp("^" + s + "$", "i");
  };
  const isGlob = (s) => /[*?]/.test(s);

  const findUnquoted = (s, test) => {
    let q = null;
    for (let i = 0; i < s.length; i++) {
      const c = s[i];
      if (q) {
        if (c === q) q = null;
        continue;
      }
      if (c === '"' || c === "'") {
        q = c;
        continue;
      }
      if (test(s, i)) return i;
    }
    return -1;
  };

  const tokenize = (line) => {
    const out = [];
    let cur = "";
    let q = null;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (q) {
        if (c === q) q = null;
        else cur += c;
        continue;
      }
      if (c === '"' || c === "'") {
        q = c;
        continue;
      }
      if (/\s/.test(c)) {
        if (cur) {
          out.push(cur);
          cur = "";
        }
        continue;
      }
      cur += c;
    }
    if (cur) out.push(cur);
    return out;
  };

  const splitMeta = (line) => {
    let rest = line;
    let redir = null;
    let mode = null;
    let pipe = null;
    const pi = findUnquoted(rest, (s, i) => s[i] === "|");
    if (pi >= 0) {
      pipe = rest.slice(pi + 1).trim();
      rest = rest.slice(0, pi).trim();
    }
    const di = findUnquoted(rest, (s, i) => s[i] === ">" && s[i + 1] === ">");
    const si = findUnquoted(rest, (s, i) => s[i] === ">" && s[i + 1] !== ">");
    const idx = di >= 0 ? di : si;
    if (idx >= 0) {
      mode = di >= 0 ? "append" : "write";
      redir = rest.slice(idx + (mode === "append" ? 2 : 1)).trim().replace(/^["']|["']$/g, "");
      rest = rest.slice(0, idx).trim();
    }
    return { rest, pipe, redir, mode };
  };

  const parsePath = (raw, cwd) => {
    const t = String(raw || "").trim();
    if (!t || t === ".") return { ok: true, parts: cwd.slice() };
    if (/^[a-zA-Z]:$/.test(t)) {
      if (t[0].toUpperCase() !== DRIVE) return { ok: false, err: "The system cannot find the drive specified." };
      return { ok: true, parts: [] };
    }
    let s = t.replace(/\//g, "\\");
    let parts;
    if (/^[a-zA-Z]:\\?/.test(s)) {
      if (s[0].toUpperCase() !== DRIVE) return { ok: false, err: "The system cannot find the drive specified." };
      s = s.slice(2);
      if (s.startsWith("\\")) s = s.slice(1);
      parts = [];
    } else if (s.startsWith("\\")) {
      parts = [];
      s = s.slice(1);
    } else {
      parts = cwd.slice();
    }
    s.split("\\").filter(Boolean).forEach((bit) => {
      if (bit === "." ) return;
      if (bit === "..") parts.pop();
      else parts.push(bit);
    });
    return { ok: true, parts };
  };

  const walk = (root, parts) => {
    let node = root;
    const trail = [];
    for (const raw of parts) {
      if (!node || node.kind !== "dir") return { node: null, trail, missing: raw };
      const name = Object.keys(node.children).find((k) => k.toLowerCase() === raw.toLowerCase());
      if (!name) return { node: null, trail, missing: raw };
      trail.push(name);
      node = node.children[name];
    }
    return { node, trail };
  };

  const resolve = (state, raw) => {
    const parsed = parsePath(raw, state.cwd);
    if (!parsed.ok) return parsed;
    const hit = walk(state.root, parsed.parts);
    if (!hit.node) return { ok: false, err: "The system cannot find the path specified." };
    return { ok: true, node: hit.node, parts: hit.trail };
  };

  const parentOf = (state, parts) => {
    if (!parts.length) return { ok: true, parent: state.root, key: null, parts: [] };
    const head = parts.slice(0, -1);
    const hit = walk(state.root, head);
    if (!hit.node || hit.node.kind !== "dir") return { ok: false, err: "The system cannot find the path specified." };
    const key = Object.keys(hit.node.children).find((k) => k.toLowerCase() === parts[parts.length - 1].toLowerCase());
    return { ok: true, parent: hit.node, key, parts: hit.trail };
  };

  const expand = (state, spec) => {
    const raw = spec.replace(/\//g, "\\");
    const slash = Math.max(raw.lastIndexOf("\\"), raw.lastIndexOf("/"));
    const hasDir = slash >= 0 || /^[a-zA-Z]:/.test(raw);
    let dirSpec = ".";
    let name = raw;
    if (hasDir && slash >= 0) {
      dirSpec = raw.slice(0, slash + 1);
      name = raw.slice(slash + 1) || "*";
    } else if (/^[a-zA-Z]:\\?$/.test(raw)) {
      dirSpec = raw;
      name = "*";
    }
    const parsed = parsePath(dirSpec, state.cwd);
    if (!parsed.ok) return parsed;
    const hit = walk(state.root, parsed.parts);
    if (!hit.node || hit.node.kind !== "dir") return { ok: false, err: "The system cannot find the path specified." };
    const re = globRe(name || "*");
    const names = Object.keys(hit.node.children).filter((k) => re.test(k));
    return { ok: true, parent: hit.node, parts: hit.trail, names, pattern: name };
  };

  const ensureDeskFiles = (state) => {
    const house = walk(state.root, ["FIVEHEARTS"]).node;
    if (!house || house.kind !== "dir") return;
    const put = (name, bytes) => {
      if (Object.keys(house.children).some((k) => k.toLowerCase() === name.toLowerCase())) return;
      house.children[name] = file("MZ", { bin: true, bytes, ro: true });
    };
    if (document.querySelector('[data-file="virus"]')) put("VIRUS.exe", 5050);
    if (document.querySelector('[data-file="enter"]')) put("ENTER.exe", 5050);
  };

  const bootText = () => [
    "FIVEHEARTS OS [Version 5.05.0]",
    "(C) Copyright 2018–2026 FIVEHEARTS.",
    "",
    "FIVEHEARTS CMD  5.05",
    "",
    "Type HELP for a list of commands.",
    "Type TYPE INFO.TXT or TYPE CREDITS.TXT",
    "Type TREE /F  ·  DIR  ·  NET START"
  ].join("\n");

  const formatPrompt = (state) => {
    if (state.zork) return ">";
    const p = state.env.PROMPT || "$P$G";
    const d = new Date();
    return p
      .replace(/\$\$/g, "\0")
      .replace(/\$P/gi, showPath(state.cwd))
      .replace(/\$N/gi, DRIVE + ":")
      .replace(/\$G/gi, ">")
      .replace(/\$L/gi, "<")
      .replace(/\$B/gi, "|")
      .replace(/\$Q/gi, "=")
      .replace(/\$T/gi, `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`)
      .replace(/\$D/gi, `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`)
      .replace(/\$_/g, "\n")
      .replace(/\0/g, "$");
  };

  const syncPrompt = (form, state) => {
    const lab = form && form.querySelector("[data-cmd-prompt], label");
    if (lab) lab.textContent = formatPrompt(state);
  };

  const stateFor = (form) => {
    if (sessions.has(form)) return sessions.get(form);
    const cons = !!(form && form.hasAttribute("data-cons-form"));
    const state = {
      cwd: ["FIVEHEARTS"],
      root: makeFs(),
      env: Object.assign({}, ENV0, cons ? { PROMPT: "$G" } : {}),
      history: [],
      histI: 0,
      wait: null,
      dstack: [],
      assoc: Object.assign({}, ASSOC0),
      zork: null
    };
    sessions.set(form, state);
    return state;
  };

  const expandEnv = (state, s) => String(s || "").replace(/%([^%]+)%/g, (_, k) => {
    const hit = Object.keys(state.env).find((n) => n.toLowerCase() === k.toLowerCase());
    return hit ? state.env[hit] : "%" + k + "%";
  });

  const switches = (args) => {
    const flags = {};
    const rest = [];
    args.forEach((a) => {
      if (a.startsWith("/") || (a.startsWith("-") && a.length > 1 && !/^[0-9]/.test(a.slice(1)))) {
        flags[a.replace(/^[/]+/, "").toLowerCase()] = true;
      } else rest.push(a);
    });
    return { flags, rest };
  };

  const helpAll = () => [
    "FIVEHEARTS CMD  5.05",
    "",
    "For more information on a specific command, type HELP command-name",
    "",
    "CD             Displays the name of or changes the current directory.",
    "CLS            Clears the screen.",
    "CMD            Starts FIVEHEARTS CMD (reprints the sign-on banner).",
    "COLOR          Sets the default console foreground and background colors.",
    "COPY           Copies one or more files to another location.",
    "DATE           Displays or sets the date.",
    "DEL            Deletes one or more files.",
    "DIR            Displays a list of files and subdirectories in a directory.",
    "ECHO           Displays messages, or turns command echoing on or off.",
    "EXIT           Quits the CMD.EXE program (command interpreter).",
    "FIND           Searches for a text string in a file or files.",
    "FOR            Runs a specified command for each file in a set of files.",
    "HELP           Provides Help information for FIVEHEARTS commands.",
    "HISTORY        Displays the command history.",
    "IF             Performs conditional processing in batch programs.",
    "IPCONFIG       Displays all current TCP/IP network configuration values.",
    "MD             Creates a directory.",
    "MEM            Displays the amount of used and free memory in your system.",
    "NET            Displays and modifies network settings.",
    "PING           Sends ICMP echo requests to a network host.",
    "PROMPT         Changes the CMD.EXE command prompt.",
    "SET            Displays, sets, or removes environment variables.",
    "SHUTDOWN       Allows proper local or remote shutdown of the machine.",
    "START          Starts a separate window to run a specified program or command.",
    "SYSTEMINFO     Displays machine specific properties and configuration.",
    "TASKLIST       Displays all currently running tasks including services.",
    "TIME           Displays or sets the system time.",
    "TREE           Graphically displays the directory structure of a drive or path.",
    "TYPE           Displays the contents of a text file.",
    "VER            Displays the FIVEHEARTS OS version.",
    "VOL            Displays a disk volume label and serial number.",
    "WHOAMI         Displays user name.",
    "",
    "The shop is one surface."
  ].join("\n");

  const HELP = {
    assoc: "Displays or modifies file name extension associations.\n\nASSOC [.ext[=[fileType]]]\n\nType ASSOC without parameters to display current associations.",
    attrib: "Displays or changes file attributes.\n\nATTRIB [+R | -R] [+H | -H] [pathname]\n\n  +   Sets an attribute.\n  -   Clears an attribute.\n  R   Read-only file attribute.\n  H   Hidden file attribute.",
    cd: "Displays the name of or changes the current directory.\n\nCD [/D] [drive:][path]\nCD [..]\n\n  ..   Specifies that you want to change to the parent directory.\n\nType CD drive: to display the current directory in the specified drive.\nType CD without parameters to display the current drive and directory.",
    chkdsk: "Checks a disk and displays a status report.\n\nCHKDSK [volume:]",
    cls: "Clears the screen.",
    cmd: "Starts a new instance of FIVEHEARTS CMD.\n\nCMD\nCOMMAND\n\nType CMD with no arguments to reprint the sign-on banner.",
    color: "Sets the default console foreground and background colors.\n\nCOLOR [attr]\n\n  attr        Specifies color attribute of console output.\n\nColor attributes are specified by TWO hex digits: first background, then foreground.\n0 = Black  7 = White  8 = Grey  C = Red  F = Bright white\n\nCOLOR without arguments restores the default.",
    copy: "Copies one or more files to another location.\n\nCOPY [/Y] source [destination]\n\n  source       Specifies the file or files to be copied.\n  destination  Specifies the directory or file name for the new file(s).\n  /Y           Suppresses prompting to confirm overwrite.",
    date: "Displays or sets the date.\n\nDATE [date]",
    del: "Deletes one or more files.\n\nDEL [/P] [/Q] names\n\n  names  Specifies a list of one or more files or directories.\n  /P     Prompts for confirmation before deleting each file.\n  /Q     Quiet mode, do not ask if ok to delete on global wildcard.",
    dir: "Displays a list of files and subdirectories in a directory.\n\nDIR [drive:][path][filename] [/W] [/P] [/A] [/B] [/S]\n\n  /W  Uses wide list format.\n  /P  Pauses after each screenful of information.\n  /A  Displays files with hidden attributes.\n  /B  Uses bare format (no heading, file info or summary).\n  /S  Displays files in specified directory and all subdirectories.",
    doskey: "Edits command lines, recalls Windows commands, and creates macros.\n\nDOSKEY [/HISTORY]\n\n  /HISTORY     Displays all commands stored in memory.\n\nUse UP and DOWN arrows to recall commands. TAB completes names.",
    echo: "Displays messages, or turns command echoing on or off.\n\n  ECHO [ON | OFF]\n  ECHO [message]\n\nType ECHO without parameters to display the current echo setting.\nUse ECHO. to print a blank line.\nRedirect with > or >> to write a file.",
    exit: "Quits the CMD.EXE program (command interpreter).",
    find: "Searches for a text string in a file or files.\n\nFIND [/V] [/C] [/N] [/I] \"string\" [pathname]\n\n  /V  Displays all lines NOT containing the specified string.\n  /C  Displays only the count of lines containing the string.\n  /N  Displays line numbers with the displayed lines.\n  /I  Ignores the case of characters when searching.",
    findstr: "Searches for strings in files.\n\nFINDSTR [/I] [/N] [/V] strings [drive:][path]filename[...]",
    format: "Formats a disk for use with FIVEHEARTS OS.\n\nFORMAT volume",
    help: "Provides help information for FIVEHEARTS CMD.\n\nHELP [command]\n\n  command - displays help information on that command.\n\nType HELP without parameters to list commands.",
    hostname: "Prints the name of the current host.",
    ipconfig: "Displays all current TCP/IP network configuration values.\n\nIPCONFIG [/ALL]",
    label: "Creates, changes, or deletes the volume label of a disk.\n\nLABEL [drive:][label]",
    md: "Creates a directory.\n\nMKDIR [drive:]path\nMD [drive:]path",
    mem: "Displays the amount of used and free memory in your system.",
    more: "Displays output one screen at a time.\n\nMORE [filename]\ncommand-name | MORE",
    move: "Moves files and renames files and directories.\n\nMOVE [drive:][path]filename1[,...] destination",
    net: "The syntax of this command is:\n\nNET [ VIEW | USER | USE | SHARE | START | STOP | HELP ]",
    netstat: "Displays protocol statistics and current TCP/IP network connections.",
    nslookup: "DNS lookup. Usage: NSLOOKUP [host]",
    path: "Displays or sets a search path for executable files.\n\nPATH [[drive:]path[;...][;%PATH%]\nPATH ;\n\nType PATH ; to clear all search-path settings.\nType PATH without parameters to display the current path.",
    pause: "Suspends processing of a batch program and displays the message:\n    Press any key to continue . . .",
    ping: "Usage: ping [-n count] target_name",
    popd: "Changes to the directory stored by PUSHD.",
    print: "Prints a text file.\n\nPRINT [/D:device] [filename]",
    prompt: "Changes the CMD.EXE command prompt.\n\nPROMPT [text]\n\n  $P  Current drive and path\n  $N  Current drive\n  $G  >\n  $L  <\n  $B  |\n  $T  Current time\n  $D  Current date\n  $_  Carriage return\n  $$  $\n\nType PROMPT without parameters to reset the prompt to C:\\path>.",
    pushd: "Stores the current directory for use by POPD, then changes to the specified directory.\n\nPUSHD [path]",
    rd: "Removes (deletes) a directory.\n\nRMDIR [/S] [/Q] [drive:]path\nRD [/S] [/Q] [drive:]path\n\n  /S  Removes all directories and files in the specified directory.\n  /Q  Quiet mode.",
    ren: "Renames a file or files.\n\nRENAME [drive:][path]filename1 filename2\nREN [drive:][path]filename1 filename2",
    set: "Displays, sets, or removes environment variables.\n\nSET [variable=[string]]\n\nType SET without parameters to display all environment variables.",
    shutdown: "Usage: shutdown [/s] [/r] [/a] [/t xxx]\n\n  /s  Shutdown the computer.\n  /r  Restart the computer.\n  /a  Abort a system shutdown.\n  /t  Time-out period before shutdown.",
    restart: "Restarts FIVEHEARTS OS.\n\nRESTART\nREBOOT\nSHUTDOWN /R",
    reboot: "Restarts FIVEHEARTS OS.\n\nRESTART\nREBOOT\nSHUTDOWN /R",
    sort: "SORT [filename]\ncommand | SORT",
    start: "Starts a separate window to run a specified program or command.\n\nSTART [program] [parameters]",
    subst: "Associates a path with a drive letter.\n\nSUBST [drive1: [drive2:]path]\nSUBST drive1: /D",
    systeminfo: "Displays machine specific properties and configuration.",
    taskkill: "TASKKILL [/IM imagename | /PID pid] [/F]\n\n  /IM  Image name of the process to be terminated.\n  /PID Process ID.\n  /F   Specifies to forcefully terminate.",
    tasklist: "TASKLIST [/M] [/V]",
    time: "Displays or sets the system time.\n\nTIME [time]",
    title: "Sets the window title for the CMD window.\n\nTITLE [string]",
    tracert: "Usage: tracert [-d] [-h maximum_hops] target_name",
    tree: "Graphically displays the folder structure of a drive or path.\n\nTREE [drive:][path] [/F] [/A]\n\n  /F   Display the names of the files in each folder.\n  /A   Use ASCII instead of extended characters.",
    type: "Displays the contents of a text file or files.\n\nTYPE [drive:][path]filename",
    call: "Calls one batch program from another.\n\nCALL [drive:][path]filename\n\nAlso: run AUTOEXEC.BAT",
    clip: "Copies input to the clipboard.\n\ncommand | CLIP\nCLIP [text]",
    debug: "Hex dump of a text file.\n\nDEBUG [filename]",
    defrag: "Reports fragmentation on drive C:.",
    driverquery: "Displays installed device drivers.",
    for: "Runs a command for each file in a set.\n\nFOR %f IN (*) DO ECHO %f\nFOR %f IN (*.TXT) DO TYPE %f",
    history: "Displays commands stored in memory.\n\nHISTORY\nDOSKEY /HISTORY",
    if: "IF [NOT] EXIST filename command",
    pwd: "Prints the current directory. Same as CD.",
    reg: "REG QUERY keyname\n\nWrites are denied.",
    sc: "SC QUERY [service]",
    sfc: "SFC [/SCANNOW]",
    uname: "Displays OS name and version.",
    who: "Displays who is logged on.",
    wmic: "WMIC OS GET CAPTION\nWMIC COMPUTERSYSTEM GET NAME\nWMIC PROCESS LIST BRIEF",
    shop: "Opens the shop floor (leaves the OS).",
    logoff: "Logs the guest off the desk.",
    ver: "Displays the FIVEHEARTS OS version and CMD build.",
    winver: "Displays the FIVEHEARTS OS version and CMD build.",
    verify: "Tells cmd whether to verify that your files are written correctly.\n\nVERIFY [ON | OFF]",
    vol: "Displays the disk volume label and serial number, if they exist.\n\nVOL [drive:]",
    where: "Displays the location of files that match the given search pattern.\n\nWHERE [/R dir] pattern",
    whoami: "Displays user name.",
    xcopy: "Copies files and directory trees.\n\nXCOPY source [destination] [/E] [/Y]"
  };
  HELP.chdir = HELP.cd;
  HELP.mkdir = HELP.md;
  HELP.erase = HELP.del;
  HELP.rename = HELP.ren;
  HELP.rmdir = HELP.rd;
  HELP.cls = HELP.cls;
  HELP.command = HELP.cmd;

  const ZORK_DIR = {
    n: "north",
    s: "south",
    e: "east",
    w: "west",
    u: "up",
    d: "down",
    north: "north",
    south: "south",
    east: "east",
    west: "west",
    up: "up",
    down: "down",
    in: "in",
    inside: "in",
    enter: "in",
    out: "out",
    leave: "out",
    exit: "out"
  };

  const zorkNew = () => ({
    room: "wake",
    seen: { wake: true },
    lampLoc: "drawer",
    keyLoc: "under",
    coinLoc: "desk",
    polaroidLoc: "bin",
    cigaretteLoc: "closet",
    zineLoc: "stockroom",
    stickerLoc: "misc",
    demoLoc: "crawlspace",
    miscOpen: false,
    lampOn: false,
    drawer: false,
    atticOpen: false,
    trunkOpen: false,
    stillMoved: false,
    seenWings: false,
    sat: false,
    played: false,
    cellarLit: false,
    score: 0,
    awarded: {},
    flags: {},
    escaped: false,
    turns: 0,
    grueTalks: 0
  });

  const zorkFlag = (z, key) => {
    if (z.flags[key]) return false;
    z.flags[key] = true;
    return true;
  };

  const zorkBonus = (z) => Object.keys(z.flags).length;

  const zorkAward = (z, key, n) => {
    if (z.awarded[key]) return;
    z.awarded[key] = true;
    z.score = Math.min(10, z.score + n);
  };

  const zorkHas = (z, item) => (item === "lamp" ? z.lampLoc : z.keyLoc) === "inv";

  const zorkScoreDetail = (z) => {
    const lines = ["Your score is " + z.score + " out of 10."];
    const parts = [];
    if (z.awarded.wings) parts.push("wings");
    if (z.awarded.lamp) parts.push("lamp");
    if (z.awarded.key) parts.push("key");
    if (z.awarded.light) parts.push("lit dark");
    if (z.awarded.cellar) parts.push("cellar");
    if (z.awarded.tape) parts.push("tape");
    if (z.awarded.attic) parts.push("attic");
    if (z.awarded.sit) parts.push("sat");
    if (z.awarded.escape) parts.push("escape bonus");
    if (parts.length) lines.push("From: " + parts.join(", ") + ".");
    lines.push("Bonus discoveries: " + zorkBonus(z) + " (not scored — the house remembers anyway).");
    if (!zorkCanEscape(z) && !z.escaped) lines.push("", ...zorkProgress(z));
    return lines;
  };

  const zorkProgress = (z) => {
    const senses = [];
    if (!z.seenWings) senses.push("wings you haven't stood in front of yet");
    if (!z.atticOpen) senses.push("a locked door upstairs");
    if (!z.lampOn) senses.push("dark that wants a light");
    if (!z.cellarLit) senses.push("a room below that eats shadow");
    if (!z.played) senses.push("a voice on a reel that hasn't spoken");
    if (!z.sat) senses.push("a chair that expects you");
    if (!senses.length) return ["The gate might open. North of the garden. You feel ready."];
    return ["The house feels incomplete — " + senses.slice(0, 3).join(", ") + (senses.length > 3 ? "…" : "") + "."];
  };

  const zorkHint = (z) => {
    const nudge = zorkRoomNudge(z);
    const lines = nudge ? [nudge] : zorkProgress(z);
    lines.push(...zorkExitLine(z));
    return lines;
  };

  const zorkCanEscape = (z) => (
    z.seenWings && z.atticOpen && z.lampOn && z.cellarLit && z.played && z.sat
  );

  const zorkWin = (z) => {
    z.escaped = true;
    zorkAward(z, "escape", Math.max(0, 10 - z.score));
    return [
      "",
      "*** You have escaped ***",
      "",
      "The garden gate gives way. Cold air hits your face like a slap of reality.",
      "Behind you, the black house does not chase. It simply waits for the next person",
      "who wakes on that floor without knowing why.",
      "",
      "You still do not know your name. You know the wings on the wall, the voice on",
      "the tape, the red line where the ceiling meets the dark. That will have to do.",
      "",
      "[Your score is " + z.score + " out of 10.]",
      zorkBonus(z) ? "[Bonus discoveries: " + zorkBonus(z) + " — the house remembers you played.]" : "",
      zorkBonus(z) >= 8 ? "You leave knowing more than most. The sigil on the chimney is dry now. Yours isn't." : "",
      zorkBonus(z) >= 4 && zorkBonus(z) < 8 ? "You found secrets in the walls. Good. The house likes witnesses." : "",
      z.stickerLoc === "seal" ? "The sticker stays on the seal. You tagged the house and left anyway." : "",
      zorkBonus(z) >= 18 ? "The house exhales. You saw everything it hid. Perfect witness." : "",
      "",
      "The street lies north. Look around. When you are done, type QUIT."
    ].filter(Boolean);
  };

  const zorkSoftEnding = (z) => {
    const bonus = zorkBonus(z);
    const lines = ["", ZORK_ART.walkaway, "", "You keep walking. The sodium light thins. The city accepts you — or pretends to."];
    if (bonus >= 12) {
      lines.push("You leave knowing everything the house offered. FIVEHEARTS walks beside you like a second pulse.");
    } else if (bonus >= 8) {
      lines.push("You leave with the sigil still on your retina. The wings do not fade. You suspect they were always yours.");
    } else if (bonus >= 4) {
      lines.push("You leave with secrets in your pockets. The house will find another witness. You hope they listen.");
    } else {
      lines.push("You leave. By morning the house will feel like a dream. It wasn't.");
    }
    if (z.flags.answeredCall) lines.push("The operator was right: inward only. You carried something out anyway.");
    if (z.stickerLoc === "seal") lines.push("Your sticker stays on the seal. Tagging the sacred from inside. Respect.");
    if (z.flags.grue) lines.push("Tell the grue union you said hi. They'll deny it.");
    lines.push("", "[Your score was " + z.score + " out of 10.]");
    lines.push("[Bonus discoveries: " + bonus + "]");
    lines.push("", "Type QUIT to return to CMD.");
    return lines;
  };

  const zorkEpilogueGo = (z, dir) => {
    const dest = zorkExits(z)[dir];
    if (!dest) {
      if (z.room === "street" && dir === "north") {
        z.flags.epilogueEnd = true;
        zorkFlag(z, "epilogue_end");
        return zorkSoftEnding(z);
      }
      return zorkBlockedExit(z, dir);
    }
    if (z.escaped && z.room === "outside" && dir === "south") {
      return ["The gate is locked. The house does not take returns."];
    }
    z.room = dest;
    const look = zorkLook(z, true);
    const flavor = zorkEnterFlavor(z, dest);
    if (flavor) look.push("", ...flavor);
    return look;
  };

  const zorkExits = (z) => {
    if (z.escaped) {
      if (z.room === "outside") return { north: "street" };
      if (z.room === "street") return { south: "outside" };
    }
    const map = {
      wake: { north: "hall", east: "closet", south: "bathroom" },
      closet: { west: "wake" },
      bathroom: { north: "wake" },
      hall: { north: "garden", south: "wake", east: "shop", west: "attic", down: "desk" },
      shop: { west: "hall", east: "stockroom" },
      stockroom: { west: "shop" },
      attic: { east: "hall", up: "roof" },
      roof: { down: "attic" },
      garden: { south: "hall", north: "outside", east: "porch" },
      porch: { west: "garden" },
      outside: { south: "garden" },
      desk: { up: "hall", east: "tape", south: "bin", west: "office" },
      office: { east: "desk" },
      tape: { west: "desk", east: "studio", north: "radio" },
      radio: { south: "tape" },
      studio: { west: "tape", south: "darkroom" },
      darkroom: { north: "studio" },
      bin: { north: "desk", down: "cellar" },
      cellar: { up: "bin", west: "vault" },
      vault: { east: "cellar" },
      crawlspace: { out: "hall" }
    };
    let ex = map[z.room] || {};
    if (z.room === "hall" && z.flags.portraitMoved) {
      ex = Object.assign({}, ex, { in: "crawlspace" });
    }
    return ex;
  };

  const ZORK_DIR_SHORT = {
    north: "N",
    south: "S",
    east: "E",
    west: "W",
    up: "U",
    down: "D",
    in: "IN",
    out: "OUT"
  };

  const zorkExitLine = (z) => {
    const ex = zorkExits(z);
    const dirs = Object.keys(ex);
    if (!dirs.length) return [];
    const parts = dirs.map((d) => {
      const short = ZORK_DIR_SHORT[d] || d.slice(0, 1).toUpperCase();
      const name = zorkTitle[ex[d]] || ex[d];
      return short + " · " + name;
    });
    return ["— " + parts.join("  |  ") + " —"];
  };

  const zorkWhere = (z) => [
    "",
    "[" + (zorkTitle[z.room] || z.room) + "]",
    ...zorkExitLine(z)
  ];

  const zorkBlockedExit = (z, dir) => {
    const dirs = Object.keys(zorkExits(z));
    const label = zorkTitle[z.room] || z.room;
    const tried = ZORK_DIR[dir] || dir;
    if (!dirs.length) return ["You can't go " + tried + ". Not from " + label + "."];
    return [
      "You can't go " + tried + ".",
      "From " + label + ": " + dirs.join(", ") + "."
    ];
  };

  const zorkFollow = (z, clean) => {
    const r = z.room;
    if (/draft|cold|chill|air/.test(clean)) {
      if (r === "bin") return ["The draft pulls down — under the floor, something breathes."];
      if (r === "attic") return ["Cold air drifts from above — the hatch, the roof, the open night."];
      return ["The air moves, but not toward a door you can name."];
    }
    if (/drip|water|tap/.test(clean)) {
      if (r === "bathroom") return ["The drip leads nowhere. It is the destination. The sink runs clear and cold."];
      if (r === "wake") return ["South — wet tile smell, cheap soap, a smaller door."];
      return ["No drip to follow here."];
    }
    if (/hum|fridge|buzz/.test(clean)) {
      if (r === "wake") return ["The hum pulls north — through the heavy door, into the rest of the house."];
      if (r === "office") return ["The CRT hum stays here. The OS does not wander."];
      return ["The hum is everywhere. It does not point."];
    }
    if (/hiss|tape|bass|music|beat/.test(clean)) {
      if (r === "hall") return ["Down — stairs to a desk. East through the shop. The house keeps its noise in layers."];
      if (r === "desk") return ["East — tape room. Speakers like veins. Someone wrote play me on a reel."];
      if (r === "tape") return ["The hiss is loudest here. You are standing in it."];
      if (r === "radio") return ["Static on the dial. South back to the deck."];
      return ["Tape hiss from no particular room — or every room at once."];
    }
    if (/light|glow|red/.test(clean)) {
      if (r === "bathroom") return ["Red bulb. Black tile. North back to where you woke."];
      if (r === "darkroom") return ["Red safe-light. The print drips patience."];
      if (r === "hall") return ["Red lining on the stairs — down to the desk, up through the house."];
      return ["The red line at the ceiling is everywhere. It does not lead. It marks."];
    }
    if (/sound|noise|voice/.test(clean) || !clean.replace(/^follow\s*/, "").trim()) {
      return zorkListen(z).concat(zorkExitLine(z));
    }
    return ["You follow nothing. The house lets you."];
  };

  const zorkRoomNudge = (z) => {
    const r = z.room;
    const nudges = {
      bathroom: "The faucet keeps running. Your throat is dry.",
      attic: "The seal on the wall. Heavy. Quiet.",
      roof: "Wind on your face. The chimney sigil is still wet.",
      darkroom: "Chemistry ticks in the tray. The print is still forming.",
      tape: "The reel says play me in marker. The deck's button is worn shiny.",
      radio: "The dial glows red. Static.",
      garden: "The red pot's leaves curl. The soil is dry.",
      porch: "The mailbox rattles when you breathe on the slot.",
      desk: "The phone keypad is worn smooth on 0. The chair faces the wall.",
      bin: "The still leans heavy against whatever it's hiding.",
      cellar: "Something shuffles in the corner. It sounds lonely, not hungry.",
      office: "The CRT cursor blinks. The machine expects input.",
      stockroom: "Fresh tape on the MISC box.",
      closet: "Tally marks climb the wall.",
      wake: "The note on the wall is still wet. The bed is untouched.",
      shop: "The till is silent.",
      studio: "The lens cap is off. The camera waits.",
      hall: "Portrait with no face. Attic door west — locked.",
      vault: "Gold at the edges only.",
      crawlspace: "Demo cassette on the floor. Lyrics on the wall."
    };
    return nudges[r] || null;
  };

  const zorkTitle = {
    wake: "A Room You Do Not Know",
    closet: "The Closet",
    bathroom: "The Bathroom",
    hall: "Black Hall",
    shop: "The Shop",
    stockroom: "Stockroom",
    attic: "Attic",
    roof: "The Roof",
    garden: "Night Garden",
    porch: "The Porch",
    outside: "Outside the Gate",
    street: "The Street",
    desk: "The Desk",
    office: "Side Office",
    tape: "Tape Room",
    radio: "Radio Room",
    studio: "Studio",
    darkroom: "Darkroom",
    bin: "The Bin",
    cellar: "Cellar",
    vault: "The Vault",
    crawlspace: "Behind the Portrait"
  };

  const ZORK_ART = {
    wake: [
      "      +==============================+",
      "      |##############################|",
      "      |#  .----.            (@)     #|",
      "      |#  |    |     [note]         #|",
      "      |#  `----'                    #|",
      "      |#        [N]                 #|",
      "      |#  [E]              [S]     #|",
      "      +==============================+",
      "      =============================="
    ].join("\n"),
    closet: [
      "      +==============================+",
      "      |#  | | | | | | | | | | | |  #|",
      "      |#  | | | | | | | | | | | |  #|",
      "      |#  |~|~|~|     coat rack     #|",
      "      |#  ########################  #|",
      "      +==============W===============+"
    ].join("\n"),
    bathroom: [
      "      +==============================+",
      "      |#  *                          #|",
      "      |#     .----.                  #|",
      "      |#     |    |  drip            #|",
      "      |#     `----'                  #|",
      "      |#  THE GATE KNOWS...         #|",
      "      +==============N===============+"
    ].join("\n"),
    hall: [
      "              +--------+",
      "              | GARDEN |",
      "              +---+----+",
      "                  |",
      "    +--------+---+---+--------+",
      "    | ATTIC  | HALL|  SHOP  |",
      "    +--------+---+---+--------+",
      "                  |",
      "              +---+----+",
      "              |  WAKE  |",
      "              +---+----+",
      "                  |",
      "                  D",
      "               ( desk )"
    ].join("\n"),
    hall_open: [
      "              +--------+",
      "              | GARDEN |",
      "              +---+----+",
      "                  |",
      "    +-[ATTIC]-+ HALL +---+ SHOP",
      "              |  |  |",
      "              +--+--+",
      "                 |",
      "               WAKE",
      "                 |",
      "                 D"
    ].join("\n"),
    hall_crawl: [
      "              +--------+",
      "              | GARDEN |",
      "              +---+----+",
      "                  |",
      "    ATTIC   [P|rt] HALL   SHOP",
      "              |  |in |",
      "              +--+---+",
      "                 |",
      "               WAKE",
      "                 D"
    ].join("\n"),
    shop: [
      "      +==============================+",
      "      |#   $ TILL                    #|",
      "      |# ========================   #|",
      "      |#  | | | | | | | | | | | |   #|",
      "      |#  | | | | | | | | | | | | E>#|",
      "      +==============W===============+"
    ].join("\n"),
    stockroom: [
      "      +==============================+",
      "      |# [UNRELEASED]    [EXTRAS]   #|",
      "      |#                             #|",
      "      |#    [ MISC ]      ~fan~      #|",
      "      |#       zine                  #|",
      "      +==============W===============+"
    ].join("\n"),
    attic: [
      "                 \\     /",
      "                  \\ * /",
      "                   \\|/",
      "                ----+----",
      "                   /|\\",
      "                  / | \\",
      "                 /  |  \\",
      "                /       \\",
      "           [trunk]   [^hatch]"
    ].join("\n"),
    attic_sticker: [
      "                 \\     /",
      "                  \\[*]/",
      "                   \\|/",
      "                ----+----",
      "                   /|\\",
      "                  / | \\",
      "                 /  |  \\",
      "                /       \\",
      "           [trunk]   [^hatch]"
    ].join("\n"),
    roof: [
      "        .   *   .   *   .   *",
      "              /|---\\",
      "             |  #  |  <- sigil",
      "             | /|\\ |",
      "      ~~~~~~~|-----|~~~~~~~",
      "            garden below"
    ].join("\n"),
    garden: [
      "            +---------+",
      "            |  GATE   |",
      "         +--+----+----+-+",
      "         | ~  ~  ~  ~  ~ |",
      "         |      [*]      |",
      "         | ~  ~  ~  ~  ~ |",
      "         +-------+-------+",
      "             |       |",
      "           HALL     PORCH"
    ].join("\n"),
    garden_open: [
      "            +--OPEN--+",
      "            |  GATE   |",
      "         +--+----+----+-+",
      "         | ~  ~  ~  ~  ~ |",
      "         |      [*]      |",
      "         | ~  ~  ~  ~  ~ |",
      "         +-------+-------+",
      "             |       |",
      "           HALL     PORCH"
    ].join("\n"),
    porch: [
      "      +==============================+",
      "      |#    | | |   wind chime      #|",
      "      |#                             #|",
      "      |#        [ mailbox ]          #|",
      "      |#  ########################   #|",
      "      +==============W===============+"
    ].join("\n"),
    outside: [
      "           .     *     .",
      "        .    /|---\\    .",
      "           |  #  |",
      "           | /|\\ |   HOUSE",
      "           |/ | \\|",
      "        +--+-----+-----+",
      "           |  YOU  |",
      "           +-------+"
    ].join("\n"),
    street: [
      "      .___.___.___.___.___.",
      "      |___|___|___|___|___|",
      "      +---[ bus shelter ]---+",
      "      |  FIVEHEARTS  ·  UK   |",
      "      |    \\   |   /         |",
      "      +----------+  (phone)  |",
      "      .___.___.___.___.___.__."
    ].join("\n"),
    desk: [
      "      +==============================+",
      "      |# papers  (o) coin   phone   #|",
      "      |# =========================  #|",
      "      |# LEAVE  LEAVE  LEAVE         #|",
      "      |#  [chair]     [drawer]       #|",
      "      +==U==+==E==+==S==+==W========+",
      "        hall  tape  bin  office"
    ].join("\n"),
    office: [
      "      +==============================+",
      "      |#  +--------------------+    #|",
      "      |#  | FIVEHEARTS OS   >_|    #|",
      "      |#  +--------------------+    #|",
      "      |#  [_] ( ) ( )  floppies     #|",
      "      +==============E===============+"
    ].join("\n"),
    tape: [
      "      +==============================+",
      "      |#    .-----------.            #|",
      "      |#    |  PLAY ME  |  ||  ||    #|",
      "      |#    |  (o)  (o) |  ||  ||    #|",
      "      |#    `-----------'            #|",
      "      +==W==+==E==+==N================+",
      "       desk studio radio"
    ].join("\n"),
    radio: [
      "      +==============================+",
      "      |#       .---------.           #|",
      "      |#   ----(  * 555 * )----      #|",
      "      |#       `---------'           #|",
      "      |#   ( speaker )    ( x )      #|",
      "      +==============S===============+"
    ].join("\n"),
    studio: [
      "      +==============================+",
      "      |#          O                   #|",
      "      |#          |   camera         #|",
      "      |#         [___]                #|",
      "      |#        chair                 #|",
      "      +==W==+==S======================+",
      "       tape   darkroom"
    ].join("\n"),
    darkroom: [
      "      +==============================+",
      "      |#  * safe-light *              #|",
      "      |#                             #|",
      "      |#   [ tray ]  ~~print~~       #|",
      "      |#      . . . dripping         #|",
      "      +==============N===============+"
    ].join("\n"),
    bin: [
      "      +==============================+",
      "      |#  +-----+   polaroid         #|",
      "      |#  |still|                    #|",
      "      |#  +-----+                    #|",
      "      |#       draft  v               #|",
      "      +==N==+==D======================+",
      "       desk  cellar"
    ].join("\n"),
    cellar: [
      "      +==============================+",
      "      |# [tape][tape][tape][tape]    #|",
      "      |# [tape][tape][tape][tape] W> #|",
      "      |#                             #|",
      "      |#        .---.  grue?         #|",
      "      +==============U===============+"
    ].join("\n"),
    cellar_dark: [
      "      +==============================+",
      "      |#                             #|",
      "      |#      +---------------+      #|",
      "      |#      |               |      #|",
      "      |#      |   something   |      #|",
      "      |#      |    breathes    |      #|",
      "      |#      +---------------+      #|",
      "      +==============================+"
    ].join("\n"),
    vault: [
      "      +==============================+",
      "      |##############################|",
      "      |#                            #|",
      "      |#   GOLD IS LINING ONLY      #|",
      "      |#                            #|",
      "      |#          ( empty )         #|",
      "      |##############################|",
      "      +==============E===============+"
    ].join("\n"),
    crawlspace: [
      "      +==============================+",
      "      |##############################|",
      "      |#  ( )  demo cassette         #|",
      "      |#                             #|",
      "      |#  where i'm at               #|",
      "      |#  five hearts in one chest   #|",
      "      |##############################|",
      "      +=============OUT==============+"
    ].join("\n"),
    crawlspace_empty: [
      "      +==============================+",
      "      |##############################|",
      "      |#                             #|",
      "      |#  where i'm at               #|",
      "      |#  five hearts in one chest   #|",
      "      |#              .              #|",
      "      |##############################|",
      "      +=============OUT==============+"
    ].join("\n"),
    win: [
      "                 \\     /",
      "                  \\ * /",
      "                   \\|/",
      "                ----+----",
      "                   /|\\",
      "                  / | \\",
      "                 /       \\",
      "            +----+---+----+",
      "            |    |YOU| GATE |",
      "            +----+---+----+",
      "           ***  ESCAPED  ***"
    ].join("\n"),
    walkaway: [
      "      .___.___.___.___.___.___.",
      "      |___|___|___|___|___|___|",
      "      |___|___ YOU ___|___|___|",
      "      |___|___|___|___|___|___|",
      "      .___.___.___.___.___.___.",
      "         *** WALKED AWAY ***"
    ].join("\n")
  };

  const zorkArtFor = (z, room) => {
    if (room === "attic" && z.stickerLoc === "seal") return ZORK_ART.attic_sticker;
    if (room === "crawlspace" && z.demoLoc !== "crawlspace") return ZORK_ART.crawlspace_empty;
    if (room === "cellar" && !z.lampOn) return ZORK_ART.cellar_dark;
    if (room === "hall" && z.flags.portraitMoved) return ZORK_ART.hall_crawl;
    if (room === "hall" && z.atticOpen) return ZORK_ART.hall_open;
    if (room === "garden" && zorkCanEscape(z)) return ZORK_ART.garden_open;
    return ZORK_ART[room] || "";
  };

  const zorkLook = (z, verbose, showArt) => {
    const lines = [];
    const r = z.room;
    if (showArt) {
      const art = zorkArtFor(z, r);
      if (art) {
        lines.push(art);
        lines.push("");
      }
    }
    lines.push(zorkTitle[r] || r);
    if (verbose || !z.seen[r]) {
      if (r === "wake") {
        lines.push("You are on a cold floor. Your head pounds like a door someone keeps knocking on.");
        lines.push("Black walls. A thin red line runs where the wall meets the ceiling — the only colour.");
        lines.push("A narrow bed, unmade. A cracked mirror. A scrap of paper pinned crooked.");
        lines.push("You do not remember falling asleep here. You are not sure you did.");
        lines.push("A heavy door leads north. A narrow closet door leads east.");
        lines.push("A smaller door south smells like wet tile and cheap soap.");
      } else if (r === "closet") {
        lines.push("Coats that remember shoulders that are not yours. Empty hangers.");
        lines.push("Tally marks scratched into the wall — hundreds, then one more, forever.");
        lines.push("A crushed cigarette pack on the shelf. Moth-eaten black wool.");
        lines.push("The only way out is west, back to the room you woke in.");
      } else if (r === "bathroom") {
        lines.push("Red lightbulb. Black tile. A sink that drips on the beat.");
        lines.push("Cold water beads on the faucet. Your mouth is dry.");
        lines.push("The mirror is clearer than the one in the wake room — uncomfortably so.");
        lines.push("Graffiti on the wall: THE GATE KNOWS WHEN YOU'VE LISTENED.");
        lines.push("North leads back to where you started.");
      } else if (r === "hall") {
        lines.push("A long black hall. Red lining on the stairs like veins under skin.");
        lines.push("Gold glints only at the edges — trim, not decoration.");
        lines.push("A portrait hangs crooked — face scratched out with something sharp.");
        if (z.flags.portraitMoved) lines.push("The portrait hangs open on a hinge. A gap leads in — behind the wall.");
        else lines.push("The frame sits loose on one side.");
        lines.push("The shop is east. A night garden north. The room you woke in lies south.");
        lines.push("Stairs drop down to a desk. West, a door climbs toward the attic.");
        lines.push(z.atticOpen
          ? "The attic door stands open. Dust motes drift in the draft."
          : "The attic door is shut. Something about the lock feels deliberate.");
      } else if (r === "shop") {
        lines.push("A counter. A till. Racks that hold objects, not merchandise.");
        lines.push("Everything has a price tag in your peripheral vision, but when you look directly");
        lines.push("the numbers smear. The shop is one surface. Nothing here wants to leave with you.");
        lines.push("East: a stockroom door, slightly ajar.");
      } else if (r === "stockroom") {
        lines.push("Cardboard boxes stacked to the ceiling. Sharpie labels: UNRELEASED, EXTRAS, MISC.");
        lines.push("A fan circulates dust.");
        lines.push("A photocopied zine sits on a crate — black ink, red staples.");
        if (!z.miscOpen) lines.push("The MISC box is taped shut — fresh tape, recent fingers.");
        else if (z.stickerLoc === "misc") lines.push("Inside MISC: a winged-heart sticker, peeling at one corner.");
      } else if (r === "attic") {
        lines.push("Rafters and heat and old paper. The air tastes like pencil shavings and rain.");
        lines.push("On the far wall: wings. A seal in the centre. It does not flutter. It watches.");
        lines.push("You get the sense it was here before the house was.");
        lines.push("A hatch in the ceiling leads up to the roof. A trunk sits under the eaves.");
      } else if (r === "roof") {
        lines.push("You climb out into night air. The city is not quite visible — only its glow.");
        lines.push("Below: white gravel, black soil, a red pot in the garden.");
        lines.push("Above: no stars, or too many. The WINGS seal is painted on a chimney brick.");
        lines.push("You could shout from here. The house would hear you.");
      } else if (r === "garden") {
        lines.push("Night plants in black soil. White gravel crunches underfoot — too loud in the quiet.");
        lines.push("A red pot by the step. No other colours. The garden breathes slow.");
        lines.push("A tall gate leads north. East, a narrow porch with a wind chime.");
      } else if (r === "porch") {
        lines.push("Wood underfoot. A wind chime made of black metal — no colour except the red string.");
        lines.push("A mailbox nailed crooked. The garden lies west. The house watches from every window.");
      } else if (r === "outside") {
        lines.push("You are outside. The gate is behind you. The house is a silhouette that refuses");
        lines.push("to explain itself. The street is not quite a street — more like a placeholder");
        lines.push("for one. You are free, or as free as this place allows.");
        if (z.escaped) {
          lines.push("The gate will not open again. North, the street waits — real enough to walk.");
        }
      } else if (r === "street") {
        lines.push("A pavement under sodium light. The city glow is closer here but still refuses detail.");
        lines.push("A bus shelter with scratched glass. A payphone with the cord cut — red plastic, black handset.");
        lines.push("Chalk on the kerb: FIVEHEARTS · UK. Someone drew wings and did not crop them.");
        lines.push("South leads back to the gate. North, the pavement thins into city glow.");
      } else if (r === "desk") {
        lines.push("The desk is the index of the house — papers, scratches, the ghost of someone working late.");
        lines.push("A chair faces the wall. A drawer sits under the top.");
        lines.push("Loose papers. A tarnished coin. A phone without a dial tone.");
        lines.push("Someone circled the word LEAVE three times.");
        lines.push("Up: stairs to the hall. East: tape room. South: bin room. West: side office with a CRT.");
        if (z.drawer && z.lampLoc === "drawer") lines.push("The drawer gapes open. A brass lamp sits inside, patient as a cat.");
        else if (z.drawer) lines.push("The drawer is open. Empty, except for the smell of old wood.");
      } else if (r === "office") {
        lines.push("A side office — CRT, beige keyboard, stack of blank floppies.");
        lines.push("The screen glows FIVEHEARTS OS without being plugged into anything.");
        lines.push("The cursor blinks.");
        if (z.flags.operatorCall) lines.push("The phone back at the desk is ringing. Insistent.");
      } else if (r === "tape") {
        lines.push("A tape deck. Two speakers. Cables like veins across the floor.");
        lines.push("Someone wrote on the reel in marker: play me. You hear nothing until you do.");
        lines.push("North: a smaller room with an old radio. East: studio. West: back to the desk.");
      } else if (r === "radio") {
        lines.push("A radio on a crate. Dial glows faint red. No station name — only static and intention.");
        lines.push("Two speakers, one dead. The live one hums.");
        lines.push("South leads back to the tape room.");
      } else if (r === "studio") {
        lines.push("A camera on a stick. A chair without a person. Rarenugly's room, or the idea of it.");
        lines.push("The lens cap is off. Whatever was filmed here is still happening somewhere else.");
        lines.push("South: a darkroom door with a red bulb above the frame.");
      } else if (r === "darkroom") {
        lines.push("Safe light. Chemical smell. Trays of developer that never quite dried.");
        lines.push("A print hangs dripping — the house from outside, shot on grainy 35mm.");
        lines.push("The image is still forming. Chemistry does not rush.");
      } else if (r === "bin") {
        lines.push("Cuts and stills lean against the wall.");
        lines.push("A polaroid curls in the damp. A draft crawls up your ankle from below.");
        lines.push("A still blocks something on the floor — heavy, leaning, in the way.");
        lines.push("North: back to the desk. Down: a draft from somewhere darker.");
        if (z.stillMoved && z.keyLoc === "under") lines.push("The still is shoved aside. A small iron key winks in the dust.");
        else if (z.stillMoved) lines.push("The still is shoved aside. Only dust where something used to hide.");
      } else if (r === "cellar") {
        lines.push("Your lamp throws long shadows. Shelves of tapes without labels — the house's memory.");
        lines.push("The cellar keeps what the shop will not sell. It hums.");
        if (z.lampOn) lines.push("Something shuffles in the far corner. It does not attack. It sighs.");
        lines.push("Up: bin room. West: a passage where gold flickers at the edges.");
      } else if (r === "vault") {
        lines.push("The vault is not a bank. It is a reminder.");
        lines.push("Gold lines every edge — trim only, never fill. Black everywhere else.");
        lines.push("A plaque: GOLD IS LINING ONLY. You understand the house's colour law.");
      } else if (r === "crawlspace") {
        lines.push("Low ceiling. Dust. Tape oxide in the air.");
        lines.push("Lyrics scrawled on the wall in pencil, bar by bar.");
        if (z.demoLoc === "crawlspace") lines.push("A demo cassette on the floor — label half peeled.");
        else lines.push("Dust where the demo cassette used to be.");
        lines.push("The portrait hinge creaks behind you. Out leads back to the hall.");
      }
      if (z.lampLoc === r) lines.push("A brass lamp rests here, waiting to be picked up.");
      if (z.keyLoc === r) lines.push("A small iron key lies in plain sight — almost too plain.");
      if (z.coinLoc === r) lines.push("A tarnished coin glints on the desk.");
      if (z.polaroidLoc === r) lines.push("A polaroid photo lies near your feet.");
      if (z.cigaretteLoc === r) lines.push("A crushed cigarette pack sits on the shelf.");
      if (z.zineLoc === r) lines.push("A photocopied zine rests on a crate.");
      if (z.stickerLoc === r) lines.push("A winged-heart sticker glints on a box flap.");
      if (z.room === "desk" && z.flags.operatorCall) lines.push("The phone is ringing.");
    } else {
      lines.push("You are still in " + (zorkTitle[r] || r) + ".");
    }
    lines.push(...zorkExitLine(z));
    if (verbose && zorkRoomNudge(z) && (z.turns < 40 || z.turns % 15 === 0)) {
      lines.push("", zorkRoomNudge(z));
    }
    z.seen[r] = true;
    return lines;
  };

  const zorkHere = (z, noun) => {
    const r = z.room;
    const n = noun;
    if (/^(lamp|lantern|light)$/.test(n)) {
      if (z.lampLoc === "inv") return "inv";
      if (z.lampLoc === r) return "room";
      if (z.lampLoc === "drawer" && z.drawer && r === "desk") return "drawer";
      return "";
    }
    if (/^(key)$/.test(n)) {
      if (z.keyLoc === "inv") return "inv";
      if (z.keyLoc === r) return "room";
      if (z.keyLoc === "under" && z.stillMoved && r === "bin") return "under";
      return "";
    }
    if (/^(coin|penny)$/.test(n)) {
      if (z.coinLoc === "inv") return "inv";
      if (z.coinLoc === r) return "room";
      return "";
    }
    if (/^(polaroid|photo|picture)$/.test(n)) {
      if (z.polaroidLoc === "inv") return "inv";
      if (z.polaroidLoc === r) return "room";
      return "";
    }
    if (/^(grue|monster|creature|shadow)$/.test(n)) return r === "cellar" && z.lampOn ? "scenery" : "";
    if (/^(papers?|documents?|files?)$/.test(n)) return r === "desk" ? "scenery" : "";
    if (/^(hoodie|shirt|jacket|rack|clothes|merch)$/.test(n)) return r === "shop" ? "scenery" : "";
    if (/^(sky|stars|moon|city|chimney)$/.test(n)) return r === "roof" ? "scenery" : "";
    if (/^(cigarette|cigarettes|pack|smoke)$/.test(n)) {
      if (z.cigaretteLoc === "inv") return "inv";
      if (z.cigaretteLoc === r) return "room";
      return "";
    }
    if (/^(cassette|demo|demo tape)$/.test(n)) {
      if (z.demoLoc === "inv") return "inv";
      if (z.demoLoc === "crawlspace" && r === "crawlspace") return "room";
      return "";
    }
    if (/^(cassette|demo|lyrics|writing)$/.test(n)) return r === "crawlspace" ? "scenery" : "";
    if (/^(portrait|painting|frame)$/.test(n)) return r === "hall" ? "scenery" : "";
    if (/^(phone|telephone|receiver)$/.test(n)) return r === "desk" ? "scenery" : "";
    if (/^(trunk|chest|box)$/.test(n)) return r === "attic" ? "scenery" : "";
    if (/^(radio|dial|static)$/.test(n)) return r === "radio" ? "scenery" : "";
    if (/^(coat|hanger|hangers|marks|tally)$/.test(n)) return r === "closet" ? "scenery" : "";
    if (/^(sketchbook|sketch|book)$/.test(n)) return r === "attic" ? "scenery" : "";
    if (/^(zine|magazine|booklet)$/.test(n)) {
      if (z.zineLoc === "inv") return "inv";
      if (z.zineLoc === r) return "room";
      return "";
    }
    if (/^(sticker|slap)$/.test(n)) {
      if (z.stickerLoc === "inv") return "inv";
      if (z.stickerLoc === "misc" && z.miscOpen && r === "stockroom") return "room";
      if (z.stickerLoc === "seal" && r === "attic") return "scenery";
      return "";
    }
    if (/^(chime|wind chime)$/.test(n)) return r === "porch" ? "scenery" : "";
    if (/^(mailbox|mail|letter|envelope)$/.test(n)) return r === "porch" ? "scenery" : "";
    if (/^(screen|crt|monitor|computer|keyboard|floppy|floppies)$/.test(n)) return r === "office" ? "scenery" : "";
    if (/^(plaque|gold|trim|lining)$/.test(n)) return r === "vault" ? "scenery" : "";
    if (/^(sink|faucet|tap|graffiti|tile)$/.test(n)) return r === "bathroom" ? "scenery" : "";
    if (/^(box|boxes|crate|crates|label)$/.test(n)) return r === "stockroom" ? "scenery" : "";
    if (/^(print|photo|negative|tray|trays)$/.test(n)) return r === "darkroom" ? "scenery" : "";
    if (/^(shelf|shelves|tapes)$/.test(n)) return r === "cellar" ? "scenery" : "";
    if (/^(bench|seat)$/.test(n)) return r === "garden" ? "scenery" : "";
    if (/^(bed)$/.test(n)) return r === "wake" ? "scenery" : "";
    if (/^(mirror|note|paper)$/.test(n)) return r === "wake" || r === "bathroom" ? "scenery" : "";
    if (/^(drawer)$/.test(n)) return r === "desk" ? "scenery" : "";
    if (/^(chair)$/.test(n)) return r === "desk" || r === "studio" ? "scenery" : "";
    if (/^(till|counter)$/.test(n)) return r === "shop" ? "scenery" : "";
    if (/^(tape|deck|tapes|reel|reels|speakers?)$/.test(n)) return r === "tape" || r === "cellar" ? "scenery" : "";
    if (/^(camera|lens|stick)$/.test(n)) return r === "studio" ? "scenery" : "";
    if (/^(still|draft)$/.test(n)) return r === "bin" ? "scenery" : "";
    if (/^(wings|seal)$/.test(n)) return r === "attic" ? "scenery" : "";
    if (/^(gate|fence)$/.test(n)) return r === "garden" ? "scenery" : "";
    if (/^(door)$/.test(n)) return r === "hall" || r === "attic" || r === "wake" ? "scenery" : "";
    if (/^(house)$/.test(n)) return r === "garden" || r === "outside" || r === "street" ? "scenery" : "";
    if (/^(payphone|phone booth|booth|pay phone)$/.test(n)) return r === "street" ? "scenery" : "";
    if (/^(shelter|bus shelter|bench)$/.test(n)) return r === "street" ? "scenery" : "";
    if (/^(chalk|kerb|curb|pavement|sidewalk)$/.test(n)) return r === "street" ? "scenery" : "";
    if (/^(plants?|gravel|pot|garden)$/.test(n)) return r === "garden" ? "scenery" : "";
    if (/^(desk)$/.test(n)) return r === "desk" ? "scenery" : "";
    if (/^(stairs?)$/.test(n)) return r === "hall" || r === "desk" || r === "bin" || r === "cellar" ? "scenery" : "";
    if (/^(floor|wall|walls|ceiling|room)$/.test(n)) return "scenery";
    return "";
  };

  const zorkExamine = (z, noun) => {
    const n = noun;
    const here = zorkHere(z, n);
    if (/^(lamp|lantern|light)$/.test(n)) {
      if (!here) return ["You don't see that here."];
      return [z.lampOn
        ? "The brass lamp burns steady. Your shadow jumps when you breathe."
        : "A brass lamp, cool to the touch. Whoever left it here expected the dark to be a problem."];
    }
    if (/^key$/.test(n)) {
      if (!here) return ["You don't see that here."];
      return ["A small iron key. Teeth worn smooth. It looks like it belongs to a door above you."];
    }
    if (/^bed$/.test(n)) {
      if (z.room !== "wake") return ["You don't see that here."];
      return ["The bed is narrow and untouched on top. You woke on the floor beside it."];
    }
    if (/^(mirror|glass)$/.test(n)) {
      if (z.room !== "wake") return ["You don't see that here."];
      return ["Cracked glass. Your face stares back with the expression of someone who forgot the ending of a film."];
    }
    if (/^(note|paper)$/.test(n)) {
      if (z.room !== "wake") return ["You don't see that here."];
      return [
        "Someone wrote in tight block capitals:",
        "",
        "  WAKE UP.",
        "  THE HOUSE IS LARGER THAN THE ROOM.",
        "  DO NOT CROP. DO NOT SQUASH.",
        "",
        "No signature. The ink is still wet."
      ];
    }
    if (/^drawer$/.test(n)) {
      if (z.room !== "desk") return ["You don't see that here."];
      if (!z.drawer) return ["A drawer, shut. The handle is warm, as if a hand was just here."];
      return [z.lampLoc === "drawer"
        ? "The drawer yawns open. A brass lamp sits inside."
        : "The drawer is open. Empty, except for pencil dust and the smell of old paper."];
    }
    if (/^chair$/.test(n)) {
      if (z.room === "desk") return ["A hard chair. The house wants you to sit."];
      if (z.room === "studio") return ["An empty chair facing the lens. Whoever sits here is always being watched."];
      return ["You don't see that here."];
    }
    if (/^(till|counter)$/.test(n)) {
      if (z.room !== "shop") return ["You don't see that here."];
      return ["The till does not ring. The counter is polished. The shop is one surface — look, do not take."];
    }
    if (/^(tape|deck|tapes|reel|reels|speakers?)$/.test(n)) {
      if (z.room === "cellar") return ["Unlabelled tapes in rows."];
      if (z.room !== "tape") return ["You don't see that here."];
      return ["The deck waits. The button is worn shiny. The reel says play me."];
    }
    if (/^(camera|lens|stick)$/.test(n)) {
      if (z.room !== "studio") return ["You don't see that here."];
      return ["Rarenugly's camera. The lens is clean. The stick is scuffed. Look only — it is not yours to carry."];
    }
    if (/^(still|draft)$/.test(n)) {
      if (z.room !== "bin") return ["You don't see that here."];
      if (!z.stillMoved) return ["A still frame leaning against the wall. Something heavy sits behind it — the kind of thing you move, not take."];
      return [z.keyLoc === "under"
        ? "The still is aside. A small iron key lies in the dust where secrets go to wait."
        : "The still is aside. Only dust remains."];
    }
    if (/^(wings|seal)$/.test(n)) {
      if (z.room !== "attic") return ["You don't see that here."];
      z.seenWings = true;
      zorkAward(z, "wings", 2);
      return [
        "Wings spread across the wall. A seal in the centre — heart and feathers and halo.",
        "It does not move. It does not need to. Do not crop. Do not squash.",
        "You understand, suddenly, why the note said what it said."
      ];
    }
    if (/^gate$/.test(n)) {
      if (z.room === "outside" && z.escaped) return ["The gate is shut. Locked from this side. The house keeps its witnesses."];
      if (z.room !== "garden") return ["You don't see that here."];
      if (zorkCanEscape(z)) return ["The gate is unlocked. North is outside. You can leave whenever you are ready."];
      return ["A tall gate. It will not budge. The house still has something to show you — a light, a tape, a room in the dark."];
    }
    if (/^fence$/.test(n)) {
      if (z.room !== "garden") return ["You don't see that here."];
      return ["White gravel, black fence. The garden is a room with the ceiling off."];
    }
    if (/^door$/.test(n)) {
      if (z.room === "wake") return ["A heavy door north. It is not locked from this side. Beyond it: the hall, and the rest of the house."];
      if (z.room === "attic") return ["The door leads east, back down toward the hall."];
      if (z.room !== "hall") return ["You don't see that here."];
      return [z.atticOpen
        ? "The west door hangs open. Stairs climb into the attic."
        : "The west door is locked. The key in your pocket might fit — if you have found it."];
    }
    if (/^house$/.test(n)) {
      if (z.room === "outside") return ["The black house behind you is silent. You made it out. It does not look surprised."];
      if (z.room === "street") return ["You look south. The house is a smudge of black against black. The chimney sigil is still wet."];
      if (z.room === "garden") return ["The house looms beyond the gravel. Black walls. Red lining. Gold only at the edges."];
      return ["You don't see that here."];
    }
    if (/^(payphone|phone booth|booth|pay phone)$/.test(n)) {
      if (z.room !== "street") return ["You don't see that here."];
      return [
        "A payphone with a severed cord. The keypad still works if you believe in infrastructure.",
        "The 0 is worn down to white plastic."
      ];
    }
    if (/^(shelter|bus shelter)$/.test(n)) {
      if (z.room !== "street") return ["You don't see that here."];
      zorkFlag(z, "shelter_read");
      return [
        "Glass scratched with tags and band names.",
        "",
        "  JOEDOTWHY WAS HERE",
        "  FIVEHEARTS · UK",
        "  DO NOT CROP · DO NOT SQUASH",
        "",
        "The timetable is blank. Buses run on vibes."
      ];
    }
    if (/^(chalk|kerb|curb|pavement)$/.test(n)) {
      if (z.room !== "street") return ["You don't see that here."];
      return [
        "Chalk on the kerb: FIVEHEARTS · UK.",
        "Wings drawn beside it — ratio correct, not squashed.",
        "Someone left art where feet go."
      ];
    }
    if (/^(plants?|gravel|pot|garden)$/.test(n)) {
      if (z.room !== "garden") return ["You don't see that here."];
      return ["Night plants. White gravel. A red pot. The garden is beautiful in the way a trap is beautiful."];
    }
    if (/^desk$/.test(n)) {
      if (z.room !== "desk") return ["You don't see that here."];
      return ["The desk is the index — scratches, papers, the map of someone else's late night. Open the drawer. Sit when you have seen enough."];
    }
    if (/^(floor|ground)$/.test(n)) {
      if (z.room === "wake") return ["Cold floor. You were lying here when you woke. There is no blood. Small mercies."];
      return ["Solid underfoot. The house does not creak the way houses should."];
    }
    if (/^(wall|walls|ceiling)$/.test(n)) return ["Black surfaces. A red line where the wall meets the ceiling. Gold nowhere except the trim."];
    if (/^stairs?$/.test(n)) return ["Stairs that go up and down through the house."];
    if (/^(coin|penny)$/.test(n)) {
      if (!here) return ["You don't see that here."];
      return [
        "A coin stamped with a winged heart. FIVEHEARTS on one side, blank on the other.",
        "Worthless out here. Sentimental anyway."
      ];
    }
    if (/^(polaroid|photo|picture)$/.test(n)) {
      if (!here) return ["You don't see that here."];
      return [
        "A polaroid: Joedotwhy mid-laugh, mouth open, eyes closed.",
        "Scrawled underneath in red marker: DO NOT CROP. DO NOT SQUASH.",
        "You were not in the frame. You wish you had been."
      ];
    }
    if (/^(grue|monster|creature|shadow)$/.test(n)) {
      if (z.room !== "cellar" || !z.lampOn) return ["You don't see that here."];
      return [
        "A grue. Classic dungeon ecology — shaggy, offended, eating a tape label.",
        "It squints at your lamp. 'Finally,' it mutters. 'Some people bring NO light.'"
      ];
    }
    if (/^(papers?|documents?|files?)$/.test(n)) {
      if (z.room !== "desk") return ["You don't see that here."];
      return [
        "Scattered pages — tracklists, phone numbers crossed out, a sketch of the WINGS seal.",
        "One sheet repeats: THE HOUSE IS LARGER THAN THE ROOM.",
        "Another: Art — Scumboy / Blackwater. Music — Joedotwhy. Video — Rarenugly."
      ];
    }
    if (/^(hoodie|shirt|jacket|merch)$/.test(n)) {
      if (z.room !== "shop") return ["You don't see that here."];
      return [
        "Black hoodie. White print. One size fits whoever survives the night."
      ];
    }
    if (/^rack$/.test(n)) {
      if (z.room !== "shop") return ["You don't see that here."];
      return ["Racks of leftovers that earned a body. Nothing wants to be bought. Everything wants to be seen."];
    }
    if (/^pot$/.test(n)) {
      if (z.room !== "garden") return ["You don't see that here."];
      return [z.flags.watered
        ? "The red pot drips. The plant inside looks smug."
        : "A red pot. The plant inside is thirsty — leaves curled, soil cracked."];
    }
    if (/^sky$/.test(n)) {
      if (z.room !== "roof") return ["You don't see that here."];
      return ["No stars. Or a million. The sky cannot commit. The city glow eats the rest."];
    }
    if (/^chimney$/.test(n)) {
      if (z.room !== "roof") return ["You don't see that here."];
      return ["Someone painted the WINGS seal on the brick in red. It is still wet."];
    }
    if (/^(portrait|painting|frame)$/.test(n)) {
      if (z.room !== "hall") return ["You don't see that here."];
      zorkFlag(z, "portrait");
      if (z.flags.portraitMoved) return ["The portrait hangs open. Scratch spirals where a face used to be. NOT FOR SALE on the back."];
      return [
        "Oil on canvas. The face is scratched out in angry spirals.",
        "Gold frame. Red lining on the subject's collar — the only colour left.",
        "On the back, pencilled: NOT FOR SALE.",
        "The frame wobbles. Loose on the left side."
      ];
    }
    if (/^(cassette|demo|demo tape)$/.test(n)) {
      if (z.room !== "crawlspace") return ["You don't see that here."];
      zorkFlag(z, "demo");
      return [
        "Demo cassette — no case, just clear plastic and honesty.",
        "Label: JOEDOTWHY · UNRELEASED · DO NOT CROP",
        "The tape inside is warm. Like it was played recently. By someone not you."
      ];
    }
    if (/^(lyrics|writing|pencil|wall writing)$/.test(n)) {
      if (z.room !== "crawlspace") return ["You don't see that here."];
      zorkFlag(z, "crawl_lyrics");
      return [
        "Pencil on black wall:",
        "",
        "  emptiness emptiness",
        "  neon lights in the cut",
        "  where i'm at where i'm at",
        "  five hearts in one chest",
        "",
        "The handwriting matches the reel in the tape room."
      ];
    }
    if (/^(phone|telephone)$/.test(n)) {
      if (z.room !== "desk") return ["You don't see that here."];
      return [
        "A phone with no dial tone. The keypad works anyway.",
        "The 0 is worn smooth. The 5 is worn smooth. The rest look untouched."
      ];
    }
    if (/^(trunk|chest)$/.test(n)) {
      if (z.room !== "attic") return ["You don't see that here."];
      if (!z.trunkOpen) return ["A wooden trunk, locked with a brass clasp. Warm to the touch."];
      return [
        "The trunk yawns open. Inside: charcoal sticks, a broken halo prop,",
        "and a note — Art is Scumboy / Blackwater. You are not them. You are in their house."
      ];
    }
    if (/^(sketchbook|sketch)$/.test(n)) {
      if (z.room !== "attic") return ["You don't see that here."];
      zorkFlag(z, "sketch");
      return [
        "Pages of wings in pencil — dozens of iterations. Crop marks crossed out violently.",
        "Last page: a heart, perfect ratio 1.447. Caption: NEVER SQUASH."
      ];
    }
    if (/^radio$/.test(n)) {
      if (z.room !== "radio") return ["You don't see that here."];
      return ["Red dial, white numbers smeared. Static."];
    }
    if (/^(coat|hanger)$/.test(n)) {
      if (z.room !== "closet") return ["You don't see that here."];
      return ["A black wool coat, moth-eaten at the cuffs. Empty pockets. Heavy with someone else's winter."];
    }
    if (/^(marks|tally|wall)$/.test(n)) {
      if (z.room !== "closet") return ["You don't see that here."];
      return ["Tally marks in four groups of five, then a sixth group that stops at three.", "Someone lost count. Or stopped on purpose."];
    }
    if (/^(cigarette|pack)$/.test(n)) {
      if (!here && z.cigaretteLoc !== "closet" && z.cigaretteLoc !== z.room && z.cigaretteLoc !== "inv") return ["You don't see that here."];
      if (z.cigaretteLoc === "inv") return ["A crushed pack. One cigarette left. You do not smoke. You might anyway."];
      return ["Crushed soft pack. One cigarette left inside."];
    }
    if (/^(zine|magazine|booklet)$/.test(n)) {
      if (!here && z.zineLoc !== "stockroom" && z.zineLoc !== "inv" && z.zineLoc !== r) return ["You don't see that here."];
      return [
        "Photocopied zine — UK · ART · MUSIC · VIDEO on the cover.",
        "Inside: photos, lyrics, a manifesto that refuses to explain itself.",
        "Last page: 'The shop is one surface.' Underlined twice."
      ];
    }
    if (/^(sink|faucet|tap)$/.test(n)) {
      if (z.room !== "bathroom") return ["You don't see that here."];
      return ["Rust at the edges. Cold water that runs clear. The drip matches your heartbeat."];
    }
    if (/^graffiti$/.test(n)) {
      if (z.room !== "bathroom") return ["You don't see that here."];
      return [
        "Block capitals in red marker:",
        "THE GATE KNOWS WHEN YOU'VE LISTENED.",
        "Below, smaller: art — scumboy / blackwater · music — joedotwhy · video — rarenugly"
      ];
    }
    if (/^(box|boxes|crate)$/.test(n)) {
      if (z.room !== "stockroom") return ["You don't see that here."];
      return [
        "UNRELEASED — tape hiss through cardboard.",
        "EXTRAS — something soft inside, probably fabric.",
        "MISC — you do not want to know. You will look anyway."
      ];
    }
    if (/^(print|photo|negative)$/.test(n)) {
      if (z.room !== "darkroom") return ["You don't see that here."];
      return ["The print drips. The house at night, shot from the garden. Rarenugly's frame. Still forming."];
    }
    if (/^shelf$/.test(n)) {
      if (z.room !== "cellar") return ["You don't see that here."];
      return [
        "Spines without titles. You read the labels anyway:",
        "  PAINLESS · OXY · YKWII · EMPTINESS · NEON LIGHTS",
        "Each one hums when your eyes pass over it."
      ];
    }
    if (/^bench$/.test(n)) {
      if (z.room !== "garden") return ["You don't see that here."];
      return ["White gravel, black seat. You could SIT here and pretend you are not escaping."];
    }
    if (/^(chime|wind chime)$/.test(n)) {
      if (z.room !== "porch") return ["You don't see that here."];
      return ["Black metal tubes on a red string. RING CHIME when you want the house to notice."];
    }
    if (/^(mailbox|mail)$/.test(n)) {
      if (z.room !== "porch") return ["You don't see that here."];
      return [z.flags.mail
        ? "The mailbox is empty. You already took what was yours."
        : "A black mailbox. Something inside has your name on it — if you had one. It shifts when you breathe on the slot."];
    }
    if (/^(screen|crt|monitor|computer)$/.test(n)) {
      if (z.room !== "office") return ["You don't see that here."];
      return ["CRT glow. FIVEHEARTS OS cursor blinks. The keyboard waits."];
    }
    if (/^(plaque|gold|trim)$/.test(n)) {
      if (z.room !== "vault") return ["You don't see that here."];
      return ["GOLD IS LINING ONLY.", "Not decoration. Not fill. A law, not a suggestion."];
    }
    if (/^(sticker|slap)$/.test(n)) {
      if (z.stickerLoc === "seal" && z.room === "attic") return ["Your sticker on the seal. Small vandalism. Large feeling."];
      if (z.stickerLoc === "inv") return ["Winged heart sticker. Sticky back. Ready."];
      if (z.miscOpen && z.stickerLoc === "misc" && z.room === "stockroom") return ["Winged heart sticker on the box flap."];
      return ["You don't see that here."];
    }
    if (!n) return ["What do you want to examine?"];
    return ["You don't see that here."];
  };

  const zorkGo = (z, dir) => {
    const dest = zorkExits(z)[dir];
    if (!dest) return zorkBlockedExit(z, dir);
    if (z.room === "hall" && dir === "west" && !z.atticOpen) {
      return ["The attic door will not open. Something about the lock feels personal."];
    }
    if (dest === "outside") {
      if (!zorkCanEscape(z)) {
        return [
          "The gate will not open.",
          "",
          "The house still holds you. You sense what is missing:",
          z.seenWings ? "" : "  — the wings in the attic",
          z.atticOpen ? "" : "  — the attic door, unlocked",
          z.lampOn ? "" : "  — a light in the dark",
          z.cellarLit ? "" : "  — the cellar, seen by lamplight",
          z.played ? "" : "  — the tape, played",
          z.sat ? "" : "  — a moment in the chair at the desk"
        ].filter(Boolean);
      }
      z.room = dest;
      const win = zorkWin(z);
      win.splice(1, 0, ZORK_ART.win, "");
      return win;
    }
    if (dest === "cellar") {
      const lit = z.lampOn && (z.lampLoc === "inv" || z.lampLoc === "cellar");
      if (!lit) {
        return [
          "You descend two steps and stop.",
          "Pitch black. Something breathes in the dark below — or maybe that is you.",
          "You are likely to be eaten by a grue. You retreat to the bin room."
        ];
      }
      z.cellarLit = true;
      zorkAward(z, "cellar", 1);
    }
    if (dest === "vault") {
      if (!z.lampOn) {
        return ["The passage west is absolute black. Your lamp is not lit. The gold down there stays hidden."];
      }
      zorkFlag(z, "vault");
    }
    z.room = dest;
    if (dest === "attic") {
      z.seenWings = true;
      zorkAward(z, "wings", 2);
    }
    const look = zorkLook(z, true);
    const flavor = zorkEnterFlavor(z, dest);
    if (flavor) look.push("", ...flavor);
    if (z.turns % 9 === 0) look.push("", zorkAmbient(z));
    return look;
  };

  const zorkInv = (z) => {
    const stuff = [];
    if (z.lampLoc === "inv") stuff.push(z.lampOn ? "a lit brass lamp" : "a brass lamp (unlit)");
    if (z.keyLoc === "inv") stuff.push("a small iron key");
    if (z.coinLoc === "inv") stuff.push("a tarnished FIVEHEARTS coin");
    if (z.polaroidLoc === "inv") stuff.push("a polaroid of Joedotwhy laughing");
    if (z.cigaretteLoc === "inv") stuff.push("a cigarette pack (one left)");
    if (z.zineLoc === "inv") stuff.push("a photocopied FIVEHEARTS zine");
    if (z.stickerLoc === "inv") stuff.push("a winged-heart sticker");
    if (z.demoLoc === "inv") stuff.push("a demo cassette — JOEDOTWHY · UNRELEASED");
    if (z.flags.wearCoat) stuff.push("(wearing a moth-eaten black coat)");
    if (!stuff.length) {
      return [
        "You are empty-handed.",
        "Your pockets are as blank as your memory."
      ];
    }
    return ["You are carrying:", "  " + stuff.join("\n  ")];
  };

  const zorkListen = (z) => {
    const r = z.room;
    if (r === "wake") return ["Silence, except your pulse in your ears.", "Far off — maybe north — something hums like a fridge that never stops."];
    if (r === "tape") return ["The speakers pop once. Joedotwhy is not playing yet, but the room remembers him."];
    if (r === "cellar") return ["Tape cases tick as they cool. A sub-bass you feel in your teeth. The house breathing."];
    if (r === "attic") return ["Wind in the rafters. Or wings. Hard to tell."];
    if (r === "garden") return ["Gravel under an invisible foot. Plants rustle. No birds. Of course no birds."];
    if (r === "shop") return ["The till does not ring. Somewhere, a price tag flutters without air."];
    if (r === "studio") return ["The silence of a lens cap off — the sound of being watched."];
    if (r === "bin") return ["A draft under the door. Paper shifting. Something behind the still, waiting."];
    if (r === "hall") return ["The house settles. Stairs creak once, then pretend they did not."];
    if (r === "desk") return ["Scratch of pencil on paper that is not there. A chair leg scraping — also not there."];
    if (r === "outside") return ["Nothing. Freedom sounds like nothing at first.", "Far off — bass from a window that might be the house, might be the city."];
    if (r === "street") return ["Traffic that never arrives. Tape hiss from the payphone shell. Your footsteps, finally loud."];
    if (r === "roof") return ["Wind. Distant tape hiss from a window you cannot see. Your own breath, loud."];
    if (r === "closet") return ["Moth wings. Your own breathing in wool. Tally marks, silent."];
    if (r === "radio") return ["Static like rain on a tin roof. Under it — almost — a voice."];
    if (r === "bathroom") return ["A drip. Your heartbeat. Same tempo. Unsettling."];
    if (r === "stockroom") return ["Fan whir. Cardboard settling. Unreleased things dreaming."];
    if (r === "darkroom") return ["Developer sloshing. A print dripping — tick, tick, tick."];
    if (r === "porch") return ["Wind chime, barely. Gravel through wood. Mail metal, warm."];
    if (r === "office") return ["CRT whine. Keyboard never clicked. OS humming like a hive."];
    if (r === "vault") return ["Silence so clean it rings. Gold does not make a sound. It outlines one."];
    if (r === "crawlspace") return ["Tape hiss from the demo — or memory. Your breathing, close and loud."];
    return ["You listen. The house listens back."];
  };

  const zorkLyrics = (z) => {
    if (z.flags.crawl_lyrics || z.seen.crawlspace) {
      return [
        "Lyrics — wall and reel agree:",
        "",
        "  EMPTINESS · OXY · YKWII",
        "  NEON LIGHTS IN THE CUT",
        "  WHERE I'M AT · WHERE I'M AT",
        "  FIVE HEARTS IN ONE CHEST",
        "",
        "Demo energy. Unreleased heat."
      ];
    }
    if (!z.played) return ["The tape has not spoken yet. The reel waits in the tape room."];
    return [
      "You read the reel label. Marker, shaky hand:",
      "",
      "  EMPTINESS",
      "  OXY",
      "  NEON LIGHTS",
      "  WHERE I'M AT",
      "",
      "Joedotwhy — tired, awake, laughing between bars."
    ];
  };

  const zorkAmbient = (z) => {
    const lines = [
      "For a second the red line at the ceiling pulses.",
      "Tape hiss drifts from no particular room.",
      "A door you did not touch creaks somewhere. Probably nothing.",
      "The house shifts — like a person turning in sleep.",
      "Gold trim catches light that is not there.",
      "Your name almost comes back. Then doesn't.",
      "Joedotwhy laughs in a room you have not entered yet. Maybe."
    ];
    return lines[z.turns % lines.length];
  };

  const zorkCompass = (z) => {
    const label = zorkTitle[z.room] || z.room;
    const ex = zorkExits(z);
    const names = Object.keys(ex);
    if (!names.length) return ["You are at " + label + ". No exits. That cannot be right."];
    return [
      "You are at " + label + ".",
      ...zorkExitLine(z),
      "",
      ...names.map((d) => "  " + d + " → " + (zorkTitle[ex[d]] || ex[d]))
    ];
  };

  const zorkMap = (z) => {
    const seen = Object.keys(z.seen).filter((k) => z.seen[k]);
    if (seen.length < 2) return ["You have not seen enough of the house to draw a map."];
    const rows = [
      "              [garden]—[outside]—[street]",
      "                 |",
      "  [shop]—[stock]—[hall]—[attic]—[roof]",
      "     |            |in     |",
      "  [wake]—[closet] [crawl]  |",
      "     |   [bath]    |      |",
      "  [desk]—[office]  |      |",
      "     |      |",
      "  [tape]—[radio]",
      "     |  [studio]—[dark]",
      "  [bin]              [porch]",
      "     |",
      "  [cellar]—[vault]",
      "",
      "Visited: " + seen.map((k) => zorkTitle[k] || k).join(", ")
    ];
    return rows;
  };

  const zorkJournal = (z) => {
    const entries = [];
    if (z.seen.wake) entries.push("Woke on a cold floor. No name. No reason.");
    if (z.seen.closet) entries.push("Found a closet full of tally marks and someone else's coat.");
    if (z.drawer) entries.push("Opened the desk drawer. Found a lamp.");
    if (z.lampOn) entries.push("Lit the brass lamp. The dark backed off.");
    if (z.stillMoved) entries.push("Moved the still in the bin. Something was hiding.");
    if (z.atticOpen) entries.push("Unlocked the attic. Dust and wings.");
    if (z.seenWings) entries.push("Saw the seal. Do not crop. Do not squash.");
    if (z.played) entries.push("Played the tape. Joedotwhy spoke.");
    if (z.cellarLit) entries.push("Survived the cellar. Met the grue.");
    if (z.sat) entries.push("Sat at the desk. Understood the index.");
    if (z.flags.tuned) entries.push("Tuned the radio. Caught a fragment.");
    if (z.trunkOpen) entries.push("Opened the attic trunk. Charcoal and halo.");
    if (z.seen.bathroom) entries.push("Read the bathroom graffiti. The gate is listening.");
    if (z.flags.developed) entries.push("Developed the print. Saw the house from outside.");
    if (z.flags.ticket) entries.push("Found a gig ticket stub under the bed. Date smudged.");
    if (z.zineLoc === "inv") entries.push("Pocketed the stockroom zine. Canon in photocopy.");
    if (z.flags.vault) entries.push("Saw the vault. Gold is lining only.");
    if (z.seen.crawlspace) entries.push("Found the crawlspace. Unreleased lyrics on the wall.");
    if (z.flags.demo_played) entries.push("Played the demo. Unreleased heat.");
    if (z.flags.wearCoat) entries.push("Wore someone else's coat. It fit wrong.");
    if (z.flags.selfie) entries.push("Photographed yourself. Rarenugly got the shot.");
    if (z.stickerLoc === "seal") entries.push("Left a sticker on the seal. Tagging the sacred.");
    if (z.flags.answeredCall) entries.push("The operator called back. Inward only.");
    if (z.escaped) entries.push("Escaped through the garden gate. The house stayed.");
    if (z.seen.street) entries.push("Found the street. Freedom has a pavement.");
    if (z.flags.epilogueEnd) entries.push("Walked away. The story continues without the house.");
    const bonus = zorkBonus(z);
    if (!entries.length) return ["The journal is blank. Live a little."];
    return ["— journal —", ""].concat(entries.map((e) => "  · " + e)).concat(
      bonus ? ["", "(" + bonus + " bonus discoveries logged.)"] : []
    );
  };

  const zorkDial = (z, num) => {
    const n = String(num || "").replace(/\D/g, "");
    if (!n) return ["Dial what?"];
    zorkFlag(z, "dial_" + n);
    if (n === "0") {
      z.flags.operatorCall = true;
      return [
        "Ring. Ring.",
        "OPERATOR: 'This line only goes inward.'",
        "'Stay on the line. I will call you back.'",
        "Click. A second later the desk phone begins to ring."
      ];
    }
    if (n === "505") {
      return [
        "Ring. Long pause.",
        "VOICE: 'Wrong window.'",
        "Click. The house is not a door. You knew that."
      ];
    }
    if (n === "911" || n === "999") {
      return ["The phone laughs once. 'There are no emergencies here. Only exits.'"];
    }
    if (n === "666" || n === "13") {
      return ["Busy signal. Even hell has voicemail."];
    }
    return [
      "Ring. Static. A voice almost familiar:",
      "'…wrong number… try the house…'",
      "Dead line."
    ];
  };

  const zorkEnterFlavor = (z, room) => {
    const once = (k, lines) => (zorkFlag(z, "enter_" + k) ? lines : null);
    if (room === "hall") return once("hall", ["Your footsteps do not echo. The hall absorbs them."]);
    if (room === "shop") return once("shop", ["A bell should ring. It does not."]);
    if (room === "cellar" && z.lampOn) return once("grue_hi", ["Something in the corner clears its throat. 'Oh. Hello. Ignore me.'"]);
    if (room === "roof") return once("roof", ["The air is colder up here."]);
    if (room === "tape") return once("tape", ["The deck's VU meters twitch though nothing plays."]);
    if (room === "closet") return once("closet", ["The coats smell like rain and cigarettes."]);
    if (room === "radio") return once("radio", ["Static rises to meet you."]);
    if (room === "bathroom") return once("bathroom", ["The drip counts time."]);
    if (room === "stockroom") return once("stockroom", ["Something UNRELEASED shifts inside a box."]);
    if (room === "darkroom") return once("darkroom", ["Red light. Your skin looks wrong-coloured."]);
    if (room === "porch") return once("porch", ["The chime moves though there is no wind."]);
    if (room === "office") return once("office", ["The CRT flickers. FIVEHEARTS OS boots before you touch the keyboard."]);
    if (room === "vault") return once("vault", ["Gold at the edges only."]);
    if (room === "street") return once("street", ["The street smells like rain on hot tarmac."]);
    if (room === "crawlspace") return once("crawlspace", ["Tape oxide and old dust."]);
    return null;
  };

  const zorkAchievements = (z) => {
    const list = [
      ["coin", z.coinLoc === "inv" || z.coinLoc === "till", "Picked up the FIVEHEARTS coin"],
      ["polaroid", z.polaroidLoc === "inv", "Kept Joedotwhy's laugh"],
      ["grue", z.flags.grue, "Befriended the grue"],
      ["tuned", z.flags.tuned, "Caught the radio fragment"],
      ["smoke", z.flags.smoke, "Smoked the last cigarette"],
      ["dance", z.flags.dance, "Danced in the house"],
      ["developed", z.flags.developed, "Developed the darkroom print"],
      ["ticket", z.flags.ticket, "Found the ticket stub"],
      ["zine", z.zineLoc === "inv", "Took the stockroom zine"],
      ["pray", z.flags.pray, "Prayed to the seal"],
      ["sticker", z.stickerLoc === "seal", "Stickered the seal"],
      ["vault", z.flags.vault, "Found the gold vault"],
      ["boot", z.flags.boot, "Booted FIVEHEARTS OS"],
      ["operator", z.flags.answeredCall, "Answered the operator"],
      ["mail", z.flags.mail, "Read the porch mail"],
      ["street", z.seen.street, "Reached the street"],
      ["payphone", z.flags.street_dial, "Used the street payphone"],
      ["epilogue", z.flags.epilogueEnd, "Walked away for good"],
      ["crawlspace", z.seen.crawlspace, "Found the room behind the portrait"],
      ["demo", z.flags.demo, "Found the demo cassette"],
      ["demo_play", z.flags.demo_played, "Played the unreleased demo"],
      ["coat", z.flags.wearCoat, "Wore the closet coat"],
      ["photo", z.flags.selfie, "Photographed yourself"],
      ["sketch_seal", z.flags.sketch_seal, "Sketched the seal"],
      ["escape", z.escaped, "Escaped the house"]
    ];
    const done = list.filter((x) => x[1]);
    const lines = ["— achievements —", ""];
    done.forEach((x) => lines.push("  [x] " + x[2]));
    list.filter((x) => !x[1]).forEach((x) => lines.push("  [ ] " + x[2]));
    lines.push("", done.length + " / " + list.length + " unlocked.");
    return lines;
  };

  const zorkCredits = () => [
    "WAKE — a FIVEHEARTS text escape",
    "",
    "Art — Scumboy / Blackwater",
    "Music — Joedotwhy",
    "Video — Rarenugly",
    "",
    "Built inside CMD.EXE on FIVEHEARTS OS.",
    "Grue union local 404.",
    "",
    "Thank you for playing.",
    "Do not crop. Do not squash."
  ];

  const zorkKnock = (z, target) => {
    const t = zorkNoun(target || "door");
    zorkFlag(z, "knock");
    if (z.room === "wake" && /door/.test(t)) {
      return ["You knock north. The hall answers with silence that means come in."];
    }
    if (z.room === "hall" && /attic|west/.test(t)) {
      if (z.atticOpen) return ["You knock. The attic door creaks open further. Dramatic."];
      return ["You knock. Something knocks back — once — from inside."];
    }
    if (z.room === "garden" && /gate/.test(t)) {
      if (zorkCanEscape(z)) return ["You knock the gate. It swings north. You may leave."];
      return ["You knock. The gate does not budge. The house is not done with you."];
    }
    if (/door|gate|wall/.test(t)) {
      return ["You knock. The house considers it."];
    }
    return ["Knock on what?"];
  };

  const zorkThink = (z) => {
    const thoughts = [
      "You think about doors. How most of them are just walls pretending to be polite.",
      "You think about the note. WAKE UP. Too late. Too early. Hard to tell.",
      "You think about the shop. One surface. Maybe you are too.",
      "You think about Joedotwhy on the tape. A voice can be a room if it is loud enough.",
      "You think about the wings. They did not move. That is somehow worse.",
      "You think about escape. The gate is north of the garden. You are not ready. Or you are. Hard to tell.",
      "You think about the grue. Even monsters have rent to pay.",
      "You think: the house is larger than the room. So is whatever you are running from.",
      "You think about the portrait with no face. Someone wanted privacy even in oil paint.",
      "You think about the tally marks. Someone counted days. Or nights. Same thing here.",
      "You think about Rarenugly behind the lens. You are always in frame, even alone.",
      "You think: FIVEHEARTS is a UK house. You are inside the sigil now.",
      "You think about the street. Freedom is a direction, not a room.",
      "You think about the payphone. Even cut cords carry stories if you dial wrong enough."
    ];
    if (z.escaped) {
      const epilogue = [
        "You think about going back. The gate won't open. That feels correct.",
        "You think: you escaped. The house let you. That might be the scariest part.",
        "You think about Joedotwhy on the tape. You carry his laugh in your pocket now."
      ];
      return [epilogue[z.turns % epilogue.length]];
    }
    return [thoughts[z.turns % thoughts.length]];
  };

  const zorkTalk = (z, target) => {
    const t = zorkNoun(target);
    if (/^(mirror|self|me|reflection)$/.test(t)) {
      if (z.room !== "wake") return ["You mutter at the air. The air is not impressed."];
      zorkFlag(z, "mirror");
      return [
        "You tell the mirror you are fine.",
        "The mirror tells you you are lying.",
        "Fair enough."
      ];
    }
    if (/^(grue|monster|creature)$/.test(t)) {
      if (z.room !== "cellar" || !z.lampOn) return ["Nothing talks back. Small mercy."];
      if (z.flags.give_demo && !z.flags.grue_demo_talk) {
        z.flags.grue_demo_talk = true;
        return [
          "The grue pats its chest where the demo went.",
          "'Unreleased heat. I do not get out much.'",
          "'This will keep me warm until the next witness.'"
        ];
      }
      z.grueTalks = (z.grueTalks || 0) + 1;
      zorkFlag(z, "grue");
      const chats = [
        [
          "The grue shrugs. 'I am contractually obligated to lurk.'",
          "'Bring light, do not step on the tapes, we are cool.'",
          "'Also — nice lamp. Very brass.'"
        ],
        [
          "'People always forget the lamp,' the grue says.",
          "'Then they blame me. Classic projection.'"
        ],
        [
          "'You seem nice,' the grue mutters.",
          "'Do not tell the other grues. I have a reputation.'"
        ],
        [
          "'If you escape, tell them I was helpful.'",
          "'They will not believe you. That is fine.'"
        ],
        [
          "'I collect tape labels,' the grue says.",
          "'Not souls. Labels. People get that wrong.'"
        ],
        [
          "'You are doing well,' it mutters.",
          "'Most people forget the lamp AND the wings. Amateur hour.'"
        ]
      ];
      return chats[Math.min(chats.length - 1, z.grueTalks - 1)];
    }
    if (/^(plant|pot|flower)$/.test(t)) {
      if (z.room !== "garden") return ["The house is not a greenhouse. Not here, anyway."];
      if (z.flags.watered && z.flags.plant_talk) {
        return [
          "The plant rustles. The leaves look better.",
          "It does not thank you."
        ];
      }
      if (z.flags.watered) {
        zorkFlag(z, "plant_talk");
        return [
          "You tell the plant it looks good.",
          "A leaf turns toward you — slowly."
        ];
      }
      return ["The plant does not speak. The leaves are curled. The soil is dry."];
    }
    if (/^(house|wall|walls|ceiling|room)$/.test(t)) {
      return [
        "You whisper to the house.",
        "After a beat, the red line at the ceiling brightens — once."
      ];
    }
    if (/^(wings|seal)$/.test(t)) {
      if (z.room !== "attic" && z.room !== "roof") return ["Nothing holy hears you from here."];
      zorkFlag(z, "wings_talk");
      return [
        "You ask the seal why you are here.",
        "Silence. Then, very quietly, the feeling of being understood without being forgiven."
      ];
    }
    if (/^(joedotwhy|joe|dot|why)$/.test(t)) {
      return ["No answer unless you play the tape in the tape room."];
    }
    if (/^(rarenugly|rare|camera guy)$/.test(t)) {
      return ["Somewhere a lens cap clicks. He is always shooting."];
    }
    if (/^(scumboy|blackwater|artist|artists)$/.test(t)) {
      zorkFlag(z, "art_talk");
      return [
        "No answer in words.",
        "The red line at the ceiling brightens — once."
      ];
    }
    if (/^(operator|switchboard)$/.test(t)) {
      if (!z.flags.answeredCall) return ["The operator only calls when you dial zero first."];
      return [
        "You whisper into the air: 'Are you still there?'",
        "Static. Then: 'Always. Inward only.'",
        "The line goes dead."
      ];
    }
    if (!t) return ["Talk to what?"];
    return ["'" + t + "' does not answer."];
  };

  const zorkFun = (z, clean) => {
    if (/^(dance|groove|vibe|move)$/.test(clean)) {
      zorkFlag(z, "dance");
      if (z.room === "tape" && z.played) {
        return ["You dance badly. Joedotwhy would not judge. The speakers would."];
      }
      return ["You dance alone. The house pretends not to watch. It watches."];
    }
    if (/^(sing|hum|whistle)$/.test(clean)) {
      zorkFlag(z, "sing");
      return ["You sing under your breath. A tape somewhere rewinds in sympathy."];
    }
    if (/^(scream|yell|shout)(?:\s+(.+))?$/.test(clean)) {
      zorkFlag(z, "shout");
      if (z.room === "roof") {
        return [
          "You shout into the night.",
          "The city glow swallows it. A dog that might not exist barks once.",
          "You feel better. Slightly."
        ];
      }
      if (z.room === "wake") {
        return ["You scream into the pillow of silence. The mirror does not flinch."];
      }
      return ["Your voice hits the black walls and comes back smaller."];
    }
    if (/^(cry|weep|sob)$/.test(clean)) {
      return ["You cry. The house gives you space."];
    }
    if (/^(laugh|lol|haha)$/.test(clean)) {
      return ["You laugh once. It sounds wrong. Then right. Then wrong again. Perfect."];
    }
    if (/^(sleep|nap|rest)$/.test(clean)) {
      if (z.room === "wake") return ["Your eyes close for a second. When they open, you are still here. Of course."];
      return ["You lean against the wall. The house does not bill you for the minute."];
    }
    if (/^(panic|freak\s+out)$/.test(clean)) {
      return [
        "You panic. Heart rate: criminal.",
        "Then you breathe. The red line at the ceiling is still there.",
        "Still red. Still a line. Anchor enough."
      ];
    }
    if (/^(kick|punch|hit)\s+(.+)$/.test(clean)) {
      const m = clean.match(/^(kick|punch|hit)\s+(.+)$/);
      const thing = m[2];
      if (/wall|house|door|gate/.test(thing)) {
        return ["You hit the " + thing + ". Your knuckles lose. The house does not."];
      }
      if (/grue/.test(thing) && z.room === "cellar" && z.lampOn) {
        return ["The grue catches your foot. 'Please. I am a union rep.'"];
      }
      return ["Violence does not help. The house has seen worse from better people."];
    }
    if (/^jump(?:\s+(up|around))?$/.test(clean)) {
      return ["You jump. Gravity works. Small win."];
    }
    if (/^(flip|spin)$/.test(clean)) {
      return ["You spin. The room spins back. 1–1."];
    }
    if (/^wave$/.test(clean)) {
      if (z.room === "studio") {
        zorkFlag(z, "wave");
        return ["You wave at the camera. Somewhere, a timeline gains another second of footage."];
      }
      return ["You wave at nothing. Nothing waves back. Friendship."];
    }
    if (/^water(?:\s+(the\s+)?plant)?$/.test(clean) || /^water\s+plant$/.test(clean)) {
      if (z.room !== "garden") return ["Nothing here wants water."];
      if (z.flags.watered) return ["The plant is good. The soil is damp."];
      z.flags.watered = true;
      zorkFlag(z, "water");
      return [
        "You pour imaginary water on the red pot.",
        "The plant straightens. A leaf unfurls.",
        "The garden exhales."
      ];
    }
    if (/^ring(?:\s+(the\s+)?till)?$/.test(clean) || /^ring\s+till$/.test(clean)) {
      if (z.room !== "shop") return ["Nothing to ring here."];
      if (z.flags.rangTill) return ["The till already rang. It is shy now."];
      z.flags.rangTill = true;
      zorkFlag(z, "till");
      return [
        "You ring the till.",
        "Ka-ching — but wrong.",
        "No one comes. The shop was always self-service."
      ];
    }
    if (/^rewind$/.test(clean)) {
      if (z.room !== "tape" && z.room !== "cellar") return ["Nothing to rewind."];
      return ["You rewind air. The gesture feels important anyway."];
    }
    if (/^feed(?:\s+(.+))?$/.test(clean)) {
      const m = clean.match(/^feed(?:\s+(.+))?$/);
      const what = m[1] || "grue";
      if (/grue/.test(what) && z.room === "cellar" && z.lampOn) {
        zorkFlag(z, "feed");
        return ["You offer nothing to the grue. It eats the concept of the gesture. 'Thanks.'"];
      }
      return ["You have nothing to feed anything. Story of the night."];
    }
    if (/^pet(?:\s+(.+))?$/.test(clean)) {
      const m = clean.match(/^pet(?:\s+(.+))?$/);
      const what = m[1] || "grue";
      if (/grue/.test(what) && z.room === "cellar" && z.lampOn) {
        zorkFlag(z, "pet");
        return ["You pet the grue. It purrs."];
      }
      if (z.room === "garden" && /plant|pot/.test(what || "")) {
        return ["You pat the plant. It tolerates you."];
      }
      return ["You reach out. The house is not a pet. It is a landlord."];
    }
    if (/^(tune|turn)(?:\s+(the\s+)?)?(?:radio|dial)$/.test(clean) || /^turn\s+dial$/.test(clean)) {
      if (z.room !== "radio") return ["No dial here."];
      if (z.flags.tuned) {
        return [
          "Static. Then, again, that fragment:",
          "",
          "  '…five hearts in one chest…'",
          "",
          "The radio clicks off, satisfied."
        ];
      }
      z.flags.tuned = true;
      zorkFlag(z, "tuned");
      return [
        "You turn the dial. Static peels away.",
        "",
        "  '…five hearts…'",
        "  '…do not crop…'",
        "",
        "Silence. The red dial dims. You wrote nothing down. You remember anyway."
      ];
    }
    if (/^(smoke|light)(?:\s+(a\s+)?)?cigarette$/.test(clean) || clean === "smoke") {
      if (z.cigaretteLoc !== "inv") return ["You have nothing to smoke."];
      z.cigaretteLoc = "gone";
      zorkFlag(z, "smoke");
      return [
        "You smoke the last cigarette. You feel no healthier. You feel real."
      ];
    }
    if (/^record(?:\s+me)?$/.test(clean) || /^say\s+cheese$/.test(clean)) {
      if (z.room !== "studio") return ["Nothing is recording you here."];
      zorkFlag(z, "record");
      return [
        "You perform for no one.",
        "The camera blinks once — Rarenugly, somewhere, just got the shot.",
        "Cut."
      ];
    }
    if (/^develop(?:\s+(the\s+)?print)?$/.test(clean)) {
      if (z.room !== "darkroom") return ["Nothing to develop here."];
      if (z.flags.developed) return ["The print is fixed. The house stares back, grainy and honest."];
      z.flags.developed = true;
      zorkFlag(z, "developed");
      return [
        "You swish the tray. The image rises — the black house, garden gate, red pot.",
        "Rarenugly's caption in pencil: 2018–2026.",
        "You are inside the photo now. Meta. Uncomfortable. True."
      ];
    }
    if (/^drink(?:\s+.*)?$/.test(clean) || /^sip(?:\s+.*)?$/.test(clean) || /^gulp(?:\s+.*)?$/.test(clean)) {
      if (z.room !== "bathroom") return ["Nothing to drink here."];
      zorkFlag(z, "drink");
      return [
        "You cup cold water in your hands.",
        "It tastes sharp, unwanted, necessary."
      ];
    }
    if (/^(wash|splash|rinse)(?:\s+(your\s+)?(hands|face))?$/.test(clean)) {
      if (z.room !== "bathroom") return ["Nothing to wash here."];
      zorkFlag(z, "wash");
      return [
        "You splash cold water on your face.",
        "The mirror shows someone who forgot the ending of a film.",
        "You feel slightly more real."
      ];
    }
    if (/^flush(?:\s+.*)?$/.test(clean)) {
      if (z.room !== "bathroom") return ["Nothing to flush here."];
      zorkFlag(z, "flush");
      return ["You flush. The sound is obscene in the quiet. The house does not comment."];
    }
    if (/^pray(?:\s+.*)?$/.test(clean) || /^kneel(?:\s+.*)?$/.test(clean) || /^bow(?:\s+.*)?$/.test(clean)) {
      if (z.room !== "attic" && z.room !== "roof") return ["Nothing here accepts that."];
      zorkFlag(z, "pray");
      return [
        "You pray to the seal.",
        "Not religious. Just honest.",
        "The halo does not glow. You feel heard anyway."
      ];
    }
    if (/^give\s+(.+?)\s+to\s+(.+)$/.test(clean)) {
      const m = clean.match(/^give\s+(.+?)\s+to\s+(.+)$/);
      const item = m[1];
      const who = m[2];
      if (/coin|penny/.test(item) && /grue/.test(who) && z.room === "cellar" && z.lampOn) {
        if (z.coinLoc !== "inv") return ["You don't have the coin."];
        z.coinLoc = "grue";
        zorkFlag(z, "give_grue");
        return [
          "You offer the coin. The grue takes it solemnly.",
          "'Finally. Tip culture reaches the cellar.'",
          "It bites the coin. Metallic squeak. 'Worthless. Perfect.'"
        ];
      }
      if (/demo|cassette|unreleased/.test(item) && /grue/.test(who) && z.room === "cellar" && z.lampOn) {
        if (z.demoLoc !== "inv") return ["You don't have the demo."];
        z.demoLoc = "grue";
        zorkFlag(z, "give_demo");
        return [
          "You offer the demo cassette. The grue reads the label.",
          "'JOEDOTWHY · UNRELEASED.' It sighs happily.",
          "'Finally. Something that never dropped. I'll savour it.'",
          "It slots the tape into its chest. Hiss. Contentment."
        ];
      }
      return ["They don't want that."];
    }
    if (/^wear(?:\s+(the\s+)?)?(coat|jacket|wool)$/.test(clean)) {
      if (z.room !== "closet") return ["Nothing to wear here."];
      if (z.flags.wearCoat) return ["You are already wearing it. Moth-eaten. Someone else's winter."];
      z.flags.wearCoat = true;
      zorkFlag(z, "wear_coat");
      return [
        "You put on the black wool coat.",
        "It smells like rain and cigarettes."
      ];
    }
    if (/^(photograph|snap|shoot)(?:\s+(me|self|yourself))?$/i.test(clean)) {
      if (z.room !== "studio") return ["Nothing to shoot here."];
      if (z.polaroidLoc !== "inv") return ["You have nothing to capture yourself with."];
      zorkFlag(z, "selfie");
      return [
        "You hold the polaroid up to the lens. Click — implied.",
        "You are in frame now. Rarenugly, somewhere, just got the shot.",
        "You do not look ready. You look honest."
      ];
    }
    if (/^sketch(?:\s+(the\s+)?)?(seal|wings)?$/.test(clean)) {
      if (z.room !== "attic" || !z.trunkOpen) return ["Nothing to sketch with here."];
      if (z.flags.sketch_seal) return ["You already sketched the seal. The charcoal smudges either way."];
      z.flags.sketch_seal = true;
      zorkFlag(z, "sketch_seal");
      return [
        "You sketch the seal in charcoal — wings, heart, halo.",
        "Ratio 1.447. You do not squash."
      ];
    }
    if (/^(extinguish|unlight|turn off)(?:\s+(the\s+)?)?(lamp|light)?$/.test(clean)) {
      if (!zorkHas(z, "lamp") || !z.lampOn) return ["Nothing lit to put out."];
      z.lampOn = false;
      zorkFlag(z, "unlight");
      return [
        "You kill the lamp.",
        "Dark pools back in. The house does not scold you.",
        "You can light it again when you are ready."
      ];
    }
    if (/^climb(?:\s+(the\s+)?)?(hatch|ladder|stairs|up)?$/.test(clean)) {
      if (z.room === "attic") return ["The hatch is above you. UP."];
      if (z.room === "bin") return ["The draft pulls down. DOWN."];
      if (z.room === "hall" && !z.atticOpen) return ["The attic door is shut. West, and locked."];
      if (z.room === "hall") return ["Stairs climb west to the attic. UP from the desk goes to the hall."];
      return ["Nothing here wants climbing."];
    }
    if (/^wait(?:\s+.*)?$/.test(clean)) {
      return [zorkAmbient(z), "Time passes. The house does not hurry you."];
    }
    if (/^hug(?:\s+(the\s+)?)?(wings|seal)?$/.test(clean)) {
      if (z.room !== "attic" && z.room !== "roof") return ["Nothing here wants a hug."];
      zorkFlag(z, "hug");
      return ["You hug the seal. It does not hug back. It does not pull away.", "Enough."];
    }
    if (/^steal(?:\s+.*)?$/.test(clean)) {
      if (z.room !== "shop") return ["Nothing to steal here. Or nothing you will admit to."];
      zorkFlag(z, "steal");
      return ["You steal a glance at the merch. The shop steals a glance back.", "The till stays closed. Transaction: understood."];
    }
    if (/^(remix|eject|fast forward|ffwd)$/.test(clean)) {
      if (z.room !== "tape") return ["Nothing to remix here."];
      zorkFlag(z, "remix");
      if (/eject/.test(clean)) return ["The deck ejects air. Tape spools nowhere. Art anyway."];
      if (/fast|ffwd/.test(clean)) return ["Fast forward through silence. Joedotwhy skips a verse you needed."];
      return ["You remix the hiss. It slaps. Unreleased heat."];
    }
    if (/^ring(?:\s+(the\s+)?)?chime$/.test(clean)) {
      if (z.room !== "porch") return ["No chime here."];
      zorkFlag(z, "chime");
      return ["The chime rings once. The house pauses."];
    }
    if (/^write(?:\s+(.+))?$/.test(clean)) {
      if (z.room !== "bathroom") return ["Nothing to write on here."];
      zorkFlag(z, "write");
      return [
        "You add your own line below the graffiti:",
        "",
        "  I WAS HERE. I AM LEAVING.",
        "",
        "The red marker was not there a second ago. It is now."
      ];
    }
    if (/^boot(?:\s+.*)?$/.test(clean) || /^run(?:\s+(.+))?$/.test(clean)) {
      if (z.room !== "office") return ["Nothing to boot here."];
      const runM = clean.match(/^run\s+(.+)$/);
      if (runM && /zork|wake|adventure/.test(runM[1])) {
        return [
          "C:\\FIVEHEARTS>WAKE",
          "",
          "ERROR: Already running inside WAKE.",
          "You are the game. The game is you. Recursion achieved."
        ];
      }
      if (z.flags.boot) return ["FIVEHEARTS OS v5.05.0 — already booted.", "Cursor blinks. Waiting."];
      z.flags.boot = true;
      zorkFlag(z, "boot");
      return [
        "FIVEHEARTS OS v5.05.0",
        "Copyright (c) the house",
        "",
        "Loading tape drivers… ok",
        "Loading wing stack… ok",
        "Loading you… ok",
        "",
        "C:\\FIVEHEARTS>_"
      ];
    }
    if (/^about$|^version$/.test(clean)) {
      return [
        "WAKE v2026 — a FIVEHEARTS text escape",
        "UK · ART · MUSIC · VIDEO",
        "Type CREDITS for names."
      ];
    }
    if (/^save$|^load$/.test(clean)) {
      return ["This house saves you the old-fashioned way — by changing you.", "No files. No checkpoints. Just memory."];
    }
    if (/^look\s+back$/.test(clean)) {
      if (z.room !== "outside" && z.room !== "street") return ["Nothing behind you but the house you are still inside."];
      zorkFlag(z, "look_back");
      return [
        "You look back at the black house.",
        "Every window is dark. The chimney sigil dries in the night air.",
        "It does not wave goodbye. It does not need to."
      ];
    }
    if (/^(lean|rest)(?:\s+(on|against)\s+(.+))?$/.test(clean)) {
      zorkFlag(z, "lean");
      if (z.room === "desk") return ["You lean on the desk. Paper shifts. The house pretends not to notice."];
      if (z.room === "garden") return ["You lean on the bench. Gravel white. Soil black. Pot red."];
      return ["You lean on the wall. It is solid. The red line at the ceiling is still there."];
    }
    if (/^(whisper|mumble)(?:\s+(.+))?$/.test(clean)) {
      zorkFlag(z, "whisper");
      if (z.room === "attic" || z.room === "roof") {
        return ["You whisper to the seal.", "Silence. Then the feeling of being understood without being forgiven."];
      }
      return ["You whisper. The house adjusts its hum to match your volume."];
    }
    if (/^(breathe|inhale|exhale)$/.test(clean)) {
      return ["You breathe. In. Out. The red line at the ceiling is still red. Anchor enough."];
    }
    if (/^(stretch|yawn)$/.test(clean)) {
      zorkFlag(z, "stretch");
      return ["You " + (/yawn/.test(clean) ? "yawn" : "stretch") + ". The house does not bill you for the minute."];
    }
    if (/^count(?:\s+(the\s+)?(marks|tally|tally marks))?$/.test(clean)) {
      if (z.room !== "closet") return ["Nothing here to count."];
      zorkFlag(z, "count");
      return [
        "Four groups of five. A sixth group stops at three.",
        "Two hundred and three marks. Or two hundred and three nights.",
        "Someone lost count. Or stopped on purpose."
      ];
    }
    if (/^trace(?:\s+(the\s+)?(line|red line|graffiti|wings))?$/.test(clean)) {
      zorkFlag(z, "trace");
      if (z.room === "bathroom") return ["You trace the graffiti with your finger. Red marker. Fresh enough to smudge."];
      if (z.room === "attic" || z.room === "roof") return ["You trace the seal's outline. Warm paint. Or cold stone. 1.447. Do not squash."];
      return ["You trace the red line where wall meets ceiling. It pulses once under your finger."];
    }
    if (/^tap(?:\s+(on|at)?\s*(.+))?$/.test(clean)) {
      const tm = clean.match(/^tap(?:\s+(?:on|at)?\s*(.+))?$/);
      const what = tm[1] || "wall";
      if (/phone/.test(what) && (z.room === "desk" || z.room === "street")) {
        return ["Tap tap. No dial tone. The keypad still clicks — satisfying, useless."];
      }
      if (/chime/.test(what) && z.room === "porch") {
        zorkFlag(z, "chime");
        return ["You tap the chime. It rings once. The house pauses."];
      }
      if (/deck|tape|button/.test(what) && z.room === "tape") {
        if (z.played) return ["The tape loops. Joedotwhy is still talking."];
        z.played = true;
        zorkAward(z, "tape", 1);
        return [
          "You tap PLAY.",
          "",
          "Tape hiss. Then Joedotwhy — tired, awake, laughing at something you cannot see:",
          "",
          "  '…emptiness, emptiness…'",
          "  '…neon lights in the cut…'",
          "  '…where I'm at…'",
          "",
          "The bass hits."
        ];
      }
      return ["Tap tap. Solid. The house is always solid."];
    }
    if (/^(wink|blink)(?:\s+(at\s+)?(mirror|reflection))?$/.test(clean)) {
      if (z.room !== "wake" && z.room !== "bathroom") return ["Nothing to wink at here."];
      zorkFlag(z, "wink");
      return ["You wink at the mirror.", "Your reflection winks back — half a beat late.", "Rude."];
    }
    if (/^(check|pat)(?:\s+(your\s+)?(pockets|self))?$/.test(clean)) {
      return zorkInv(z).concat(["You are still you. Mostly."]);
    }
    if (/^lie(?:\s+(down|on\s+the\s+bed))?$/.test(clean)) {
      if (z.room !== "wake") return ["Not here."];
      return [
        "You lie on the floor where you woke.",
        "The bed is right there. You do not trust it.",
        "When you sit up, nothing has changed. Of course."
      ];
    }
    if (/^nod(?:\s+.*)?$/.test(clean)) {
      zorkFlag(z, "nod");
      return ["You nod. The house nods back — the red line at the ceiling dips once."];
    }
    if (/^shiver(?:\s+.*)?$/.test(clean)) {
      return ["You shiver. Cold floor memory. The house does not offer a blanket."];
    }
    if (/^lick(?:\s+(.+))?$/.test(clean)) {
      const lm = clean.match(/^lick(?:\s+(.+))?$/);
      const what = lm[1] || "wall";
      if (/coin/.test(what) && z.coinLoc === "inv") return ["Metallic. Regretful. You do not do that again."];
      if (/wall|line|red/.test(what)) return ["Tastes like dust. Do not do that again."];
      return ["You reconsider. Some things are not for licking."];
    }
    if (/^push(?:\s+(the\s+)?)?(button|play|red button)$/.test(clean)) {
      if (z.room !== "tape") return ["Nothing to push here."];
      if (z.played) return ["The tape loops. Joedotwhy is still talking."];
      z.played = true;
      zorkAward(z, "tape", 1);
      return [
        "You push PLAY.",
        "",
        "Tape hiss. Then Joedotwhy — tired, awake, laughing:",
        "",
        "  '…where I'm at…'",
        "",
        "The bass hits."
      ];
    }
    if (/^swish(?:\s+(the\s+)?(tray|print))?$/.test(clean)) {
      if (z.room !== "darkroom") return ["Nothing to swish here."];
      if (z.flags.developed) return ["The print is fixed. The house stares back, grainy and honest."];
      z.flags.developed = true;
      zorkFlag(z, "developed");
      return [
        "You swish the tray. The image rises — the black house, garden gate, red pot.",
        "Rarenugly's caption in pencil: 2018–2026.",
        "You are inside the photo now. Meta. Uncomfortable. True."
      ];
    }
    if (/^type(?:\s+(.+))?$/.test(clean)) {
      if (z.room !== "office") return ["Nothing to type on here."];
      const tyM = clean.match(/^type(?:\s+(.+))?$/);
      const txt = tyM[1] || "";
      if (/zork|wake|adventure/.test(txt)) {
        return [
          "C:\\FIVEHEARTS>WAKE",
          "",
          "ERROR: Already running inside WAKE.",
          "You are the game. The game is you. Recursion achieved."
        ];
      }
      if (z.flags.boot) return ["C:\\FIVEHEARTS>" + (txt || ""), txt ? "Command not found. The OS shrugs." : "Cursor blinks. Waiting."];
      return ["The keyboard clicks. The screen stays dark until you boot the thing."];
    }
    if (/^sit(?:\s+(on|at|in)?\s*(the\s+)?)?(shelter|bench|bus)?$/.test(clean) || /^sit(?:\s+down)?$/.test(clean)) {
      if (z.room === "street") {
        zorkFlag(z, "street_sit");
        return [
          "You sit in the bus shelter. Glass scratched with band names.",
          "JOEDOTWHY in red nail polish. FIVEHEARTS in black.",
          "No bus comes. You didn't need one."
        ];
      }
      if (z.room === "garden") {
        zorkFlag(z, "garden_sit");
        return [
          "You sit on the bench. Gravel white. Soil black. Pot red.",
          "For a minute you are not escaping. You are just here.",
          "Then you remember the gate."
        ];
      }
    }
    if (/^keep\s+walking$|^walk\s+away$/.test(clean)) {
      if (z.room !== "street") return ["Not yet. Find the street first."];
      if (z.flags.epilogueEnd) return ["You already walked. The story moved on without you."];
      z.flags.epilogueEnd = true;
      zorkFlag(z, "epilogue_end");
      return zorkSoftEnding(z);
    }
    if (/^leave$/.test(clean)) {
      if (z.escaped && z.room === "street") {
        if (z.flags.epilogueEnd) return ["You already walked. The story moved on without you."];
        z.flags.epilogueEnd = true;
        zorkFlag(z, "epilogue_end");
        return zorkSoftEnding(z);
      }
      if (z.room === "garden" && zorkCanEscape(z)) return ["The gate is north. You know what to do."];
      return ["Not yet. Not from here."];
    }
    return null;
  };

  const zorkHelp = () => [
    "WAKE — a FIVEHEARTS text escape",
    "",
    "You woke in a room. The house is larger. Find a way out.",
    "",
    "Getting around:",
    "  LOOK  L          room view + ASCII scene",
    "  EXITS  WHERE     which directions lead where",
    "  N S E W UP DOWN  move (or GO NORTH, etc.)",
    "  MAP  JOURNAL  HINT     track what you have seen",
    "",
    "Interacting:",
    "  EXAMINE  READ  LISTEN  THINK  SEARCH",
    "  TAKE  DROP  OPEN  USE  LIGHT  SIT  MOVE",
    "  TALK TO …        people, things, the house",
    "  FOLLOW SOUND     when you are lost",
    "",
    "The house responds to normal verbs and weird ones.",
    "If you can think it — drink, pray, dance, steal a glance — try it.",
    "LISTEN and EXAMINE reveal more than LOOK alone.",
    "",
    "  SCORE  ACHIEVEMENTS  CREDITS  TIME  RESTART  HELP  QUIT",
    "",
    "QUIT leaves the game. CMD stays open."
  ];

  const zorkNoun = (s) => String(s || "").replace(/\b(the|a|an|my|this|that)\b/g, " ").replace(/\s+/g, " ").trim();

  const zorkStart = (ctx) => {
    const form = ctx.form;
    const state = ctx.state;
    if (form && form.hasAttribute("data-cons-form")) return "This program cannot be run in DOS mode.";
    if (state.zork) return "You are already awake in the house.";
    state.zork = zorkNew();
    const intro = [
      "WAKE",
      "A FIVEHEARTS text escape  ·  2026",
      "",
      "Your eyes open before your name does.",
      "Cold floor. Black walls. A red line at the ceiling.",
      "You do not know how you got here. The house does.",
      "",
      "LOOK shows where you are. EXITS shows doors.",
      "The house listens to more verbs than it admits to.",
      ""
    ].concat(zorkLook(state.zork, true, true));
    if (form) syncPrompt(form, state);
    return intro.join("\n");
  };

  const zorkTurn = (state, raw) => {
    const z = state.zork;
    const line = String(raw || "").trim();
    if (!line) return { lines: ["I beg your pardon?"], quit: false };
    z.turns += 1;
    const low = line.toLowerCase().replace(/[.,!?]+/g, " ").replace(/\s+/g, " ").trim();
    const clean = zorkNoun(low);

    const out = (lines, quit) => ({ lines, quit: !!quit });

    if (z.escaped && /^(quit|q|exit)$/.test(clean)) {
      state.zork = null;
      return out(["You close the book on the house.", "[Your score was " + z.score + " out of 10.]"], true);
    }
    if (z.escaped) {
    if (/^(help|\?)$/.test(clean)) return out(zorkHelp());
    if (clean === "score") return out(zorkScoreDetail(z));
    if (/^hint$/i.test(clean)) return out(zorkHint(z));
    if (/^(where|where am i|location)$/.test(clean)) return out(zorkWhere(z));
    if (/^(i|inv|inventory)$/.test(clean)) return out(zorkInv(z));
    if (/^(look|l|look around)$/.test(clean)) return out(zorkLook(z, true, true));
    if (/^(listen|hear)$/.test(clean)) return out(zorkListen(z));
    if (/^think(?:\s+.*)?$/.test(clean)) return out(zorkThink(z));
    if (/^(journal|diary|log)$/.test(clean)) return out(zorkJournal(z));
    if (/^map$/.test(clean)) return out(zorkMap(z));
    if (/^(exits|compass|dir)$/.test(clean)) return out(zorkCompass(z));
    if (/^follow(?:\s+(.+))?$/.test(clean)) return out(zorkFollow(z, clean));
      if (/^(achievements|trophies|badges)$/.test(clean)) return out(zorkAchievements(z));
      if (/^credits$/.test(clean)) return out(zorkCredits());
      if (/^time$/.test(clean)) return out(["Turn " + z.turns + ".", "Outside the house, time feels optional."]);
      const lookM = clean.match(/^(?:look\s+at|look|examine|x|read|inspect)\s+(.+)$/);
      if (lookM) return out(zorkExamine(z, lookM[1]));
      const talkM = clean.match(/^(?:talk(?:\s+to)?|ask|tell)\s+(.+)$/);
      if (talkM) return out(zorkTalk(z, talkM[1]));
      const dialM = clean.match(/^(?:dial|call)\s+(\S.+)$/);
      if (dialM) {
        if (z.room !== "street") return out(["No phone here."]);
        zorkFlag(z, "street_dial");
        return out(zorkDial(z, dialM[1]));
      }
      const fun = zorkFun(z, clean);
      if (fun) return out(fun);
      const goWord = ZORK_DIR[clean];
      if (goWord) return out(zorkEpilogueGo(z, goWord));
      const goM = clean.match(/^go(?:\s+to)?\s+(.+)$/);
      if (goM) {
        const d = ZORK_DIR[goM[1]] || ZORK_DIR[goM[1].replace(/^to\s+/, "")];
        if (!d) return out(["Go where?"]);
        return out(zorkEpilogueGo(z, d));
      }
      if (/^walk(?:\s+(north|south|away))?$/.test(clean)) {
        const wm = clean.match(/^walk(?:\s+(north|south|away))?$/);
        const dir = wm[1] === "south" ? "south" : wm[1] === "north" || !wm[1] ? "north" : null;
        if (dir === "away" || (z.room === "street" && dir === "north")) {
          if (z.flags.epilogueEnd) return out(["You already walked away. Type QUIT."]);
          z.flags.epilogueEnd = true;
          zorkFlag(z, "epilogue_end");
          return out(zorkSoftEnding(z));
        }
        if (dir) return out(zorkEpilogueGo(z, dir));
        return out(["Walk where?"]);
      }
      return out(["The house is behind you.", ...zorkWhere(z), "", "LOOK. WALK NORTH. QUIT when done."]);
    }

    if (/^(quit|q)$/.test(clean) || clean === "exit") {
      const score = "[Your score is " + z.score + " out of 10.]";
      state.zork = null;
      return out([
        "You give up on the gate and let the house take you back into the blur.",
        "Maybe next time you will stay awake long enough to leave.",
        score
      ], true);
    }
    if (/^(restart|reset|wake again|play again|new game)$/.test(clean)) {
      state.zork = zorkNew();
      return out([
        "",
        "You close your eyes. Open them.",
        "Cold floor. Black walls. The house forgot you. You didn't forget the house.",
        ""
      ].concat(zorkLook(state.zork, true, true)));
    }
    if (/^(help|\?)$/.test(clean)) return out(zorkHelp());
    if (clean === "score") return out(zorkScoreDetail(z));
    if (/^hint$/i.test(clean)) return out(zorkHint(z));
    if (/^(where|where am i|location)$/.test(clean)) return out(zorkWhere(z));
    if (/^(i|inv|inventory)$/.test(clean)) return out(zorkInv(z));
    if (/^(look|l|look around)$/.test(clean)) return out(zorkLook(z, true, true));
    if (/^(listen|hear)$/.test(clean)) return out(zorkListen(z));
    if (/^think(?:\s+.*)?$/.test(clean)) return out(zorkThink(z));
    if (/^(journal|diary|log)$/.test(clean)) return out(zorkJournal(z));
    if (/^map$/.test(clean)) return out(zorkMap(z));
    if (/^(exits|compass|dir)$/.test(clean)) return out(zorkCompass(z));
    if (/^follow(?:\s+(.+))?$/.test(clean)) return out(zorkFollow(z, clean));
    if (/^time$/.test(clean)) {
      return out([
        "Turn " + z.turns + ".",
        "The house does not keep clocks. It keeps people until they understand."
      ]);
    }
    if (/^(achievements|trophies|badges)$/.test(clean)) return out(zorkAchievements(z));
    if (/^credits$/.test(clean)) return out(zorkCredits());
    if (/^about$|^version$/.test(clean)) {
      const fun = zorkFun(z, clean);
      if (fun) return out(fun);
    }

    if (/^answer(?:\s+(the\s+)?phone)?$/.test(clean)) {
      if (z.room !== "desk" && z.room !== "office") return out(["No phone ringing here."]);
      if (!z.flags.operatorCall) return out(["The phone is silent. The 0 on the keypad is worn white."]);
      if (z.flags.answeredCall) return out(["The line is dead. The operator got what they needed."]);
      z.flags.answeredCall = true;
      z.flags.operatorCall = false;
      zorkFlag(z, "answeredCall");
      return out([
        "You answer.",
        "",
        "OPERATOR: 'Good. You are still inside.'",
        "'The house is larger than the room. You know that now.'",
        "'When the gate opens — do not look back at the wings.'",
        "Click."
      ]);
    }

    const knockM = clean.match(/^knock(?:\s+(?:on\s+)?(.+))?$/);
    if (knockM) return out(zorkKnock(z, knockM[1]));

    const dialM = clean.match(/^(?:dial|call)\s+(\S.+)$/);
    if (dialM) {
      if (z.room !== "desk" && z.room !== "street") return out(["You need a phone."]);
      if (z.room === "street") zorkFlag(z, "street_dial");
      return out(zorkDial(z, dialM[1]));
    }
    if (/^(dial|call)$/.test(clean)) {
      if (z.room !== "desk" && z.room !== "street") return out(["No phone here."]);
      return out(["Dial what? The 0 is the most worn key."]);
    }

    const talkM = clean.match(/^(?:talk(?:\s+to)?|ask|tell)\s+(.+)$/);
    if (talkM) return out(zorkTalk(z, talkM[1]));

    const fun = zorkFun(z, clean);
    if (fun) return out(fun);

    if (/^(who am i|where am i|what happened|how did i get here|why am i here)$/.test(clean)) {
      return out([
        "You do not know.",
        "Your name feels like a file you do not have permission to open.",
        "The house knows. It is not telling."
      ]);
    }
    if (/^(hello|hi|hey|anyone there|is anyone there)$/.test(clean)) {
      return out(["No answer — unless you count the house adjusting its hum to acknowledge you."]);
    }
    if (/^five\s*hearts$|^fivehearts$/i.test(clean)) {
      zorkFlag(z, "fh");
      return out([
        "UK · ART · MUSIC · VIDEO",
        "The red line at the ceiling brightens once.",
        "Scumboy / Blackwater · Joedotwhy · Rarenugly.",
        "You are inside the sigil."
      ]);
    }
    if (/^wings$/i.test(clean) && z.room !== "attic" && z.room !== "roof") {
      return out(["Somewhere above, something spreads. You have not stood in front of it yet. Or you have. Hard to tell."]);
    }
    if (/^uk$/i.test(clean)) {
      zorkFlag(z, "uk");
      return out(["Chalk on a kerb you haven't seen yet. Or have. FIVEHEARTS · UK."]);
    }
    if (/^(escape|leave|run|get out)$/.test(clean)) {
      if (z.room === "garden" && zorkCanEscape(z)) return out(zorkGo(z, "north"));
      if (z.room === "outside" && !z.escaped) return out(zorkWin(z));
      return out(["Not yet. Find the garden gate north of the hall — if the house lets you go."]);
    }
    if (/^wake(?:\s+up)?$/.test(clean)) {
      return out(["You are already awake. That is the problem."]);
    }

    const goWord = ZORK_DIR[clean];
    if (goWord) return out(zorkGo(z, goWord));
    const goM = clean.match(/^go(?:\s+to)?\s+(.+)$/);
    if (goM) {
      const d = ZORK_DIR[goM[1]] || ZORK_DIR[goM[1].replace(/^to\s+/, "")];
      if (!d) return out(["Go where?"]);
      return out(zorkGo(z, d));
    }

    const lookM = clean.match(/^(?:look\s+at|look|examine|x|inspect)\s+(.+)$/);
    if (lookM) return out(zorkExamine(z, lookM[1]));
    if (/^read(?:\s+(the\s+)?(.+))?$/.test(clean)) {
      const rm = clean.match(/^read(?:\s+(the\s+)?(.+))?$/);
      const what = (rm[2] || "").trim();
      if (/tape|reel|lyrics|label/.test(what) || (!what && z.room === "tape")) return out(zorkLyrics(z));
      if (/graffiti/.test(what) && z.room === "bathroom") return out(zorkExamine(z, "graffiti"));
      if (/zine|magazine/.test(what)) return out(zorkExamine(z, "zine"));
      if (/note|paper/.test(what) && z.room === "wake") return out(zorkExamine(z, "note"));
      if (/papers?|documents?/.test(what) && z.room === "desk") return out(zorkExamine(z, "papers"));
      if (/mail|letter/.test(what) && z.room === "porch") return out(zorkExamine(z, "mail"));
      if (/plaque/.test(what) && z.room === "vault") return out(zorkExamine(z, "plaque"));
      if (/shelter|graffiti|glass/.test(what) && z.room === "street") return out(zorkExamine(z, "shelter"));
      if (/lyrics|writing/.test(what) && z.room === "crawlspace") return out(zorkExamine(z, "lyrics"));
      if (z.room === "desk") return out(zorkExamine(z, "papers"));
      if (z.room === "wake") return out(zorkExamine(z, "note"));
      return out(["Nothing legible here."]);
    }

    const takeM = clean.match(/^(?:take|get|grab|pick\s+up)\s+(.+)$/);
    if (takeM) {
      const n = takeM[1];
      if (/^(lamp|lantern|light)$/.test(n)) {
        const here = zorkHere(z, "lamp");
        if (!here) return out(["You don't see that here."]);
        if (here === "inv") return out(["You already have it."]);
        z.lampLoc = "inv";
        zorkAward(z, "lamp", 1);
        return out(["You pick up the brass lamp. It is heavier than it looks, and warmer than it should be."]);
      }
      if (/^key$/.test(n)) {
        const here = zorkHere(z, "key");
        if (!here) return out(["You don't see that here."]);
        if (here === "inv") return out(["You already have it."]);
        z.keyLoc = "inv";
        zorkAward(z, "key", 1);
        return out(["You pocket the iron key. The teeth are worn smooth — this lock has been opened before."]);
      }
      if (/^(coin|penny)$/.test(n)) {
        if (z.coinLoc !== "desk" && z.coinLoc !== z.room) return out(["You don't see that here."]);
        if (z.coinLoc === "inv") return out(["You already have it."]);
        z.coinLoc = "inv";
        zorkFlag(z, "coin");
        return out(["You take the coin. It is warm. FIVEHEARTS on one side, blank on the other."]);
      }
      if (/^(polaroid|photo|picture)$/.test(n)) {
        if (z.polaroidLoc !== "bin" && z.polaroidLoc !== z.room) return out(["You don't see that here."]);
        if (z.polaroidLoc === "inv") return out(["You already have it."]);
        z.polaroidLoc = "inv";
        zorkFlag(z, "polaroid");
        return out(["You pick up the polaroid. Joedotwhy laughs forever in chemical ink."]);
      }
      if (/^(cigarette|cigarettes|pack|smoke)$/.test(n)) {
        if (z.cigaretteLoc !== "closet" && z.cigaretteLoc !== z.room) return out(["You don't see that here."]);
        if (z.cigaretteLoc === "inv") return out(["You already have it."]);
        z.cigaretteLoc = "inv";
        zorkFlag(z, "cigarette");
        return out(["You take the pack. One cigarette left. The closet feels less inhabited."]);
      }
      if (/^(zine|magazine|booklet)$/.test(n)) {
        if (z.zineLoc !== "stockroom" && z.zineLoc !== z.room) return out(["You don't see that here."]);
        if (z.zineLoc === "inv") return out(["You already have it."]);
        z.zineLoc = "inv";
        zorkFlag(z, "zine");
        return out(["You pocket the zine. Paper warm from the fan. Canon in your jacket."]);
      }
      if (/^(sticker|slap)$/.test(n)) {
        if (!z.miscOpen || z.stickerLoc !== "misc") return out(["You don't see that here."]);
        if (z.stickerLoc === "inv") return out(["You already have it."]);
        z.stickerLoc = "inv";
        zorkFlag(z, "sticker_take");
        return out(["You peel the sticker free. It sticks to your fingers."]);
      }
      if (/^(demo|demo tape|demo cassette|cassette|unreleased)$/.test(n)) {
        if (z.demoLoc !== "crawlspace" || z.room !== "crawlspace") return out(["You don't see that here."]);
        if (z.demoLoc === "inv") return out(["You already have it."]);
        z.demoLoc = "inv";
        zorkFlag(z, "demo");
        return out(["You pocket the demo cassette. It is warm. Unreleased heat in your jacket."]);
      }
      if (/^(note|paper)$/.test(n)) {
        if (z.room !== "wake") return out(["You don't see that here."]);
        return out(["The note is pinned to the wall. It will not fit in your pocket."]);
      }
      if (/^(wings|seal)$/.test(n)) {
        if (z.room !== "attic") return out(["You don't see that here."]);
        return out(["The seal stays on the wall. Some things are not souvenirs."]);
      }
      if (/^(till|counter)$/.test(n)) {
        if (z.room !== "shop") return out(["You don't see that here."]);
        return out(["The till stays. The shop is one surface."]);
      }
      if (/^(camera|lens)$/.test(n)) {
        if (z.room !== "studio") return out(["You don't see that here."]);
        return out(["Look only. The camera is not yours."]);
      }
      if (/^(chair|desk|drawer|tape|deck|still|draft|door|house|plants?|bed|mirror|gate)$/.test(n)) {
        return out(["You can't take that — or the house won't let you."]);
      }
      if (!n) return out(["Take what?"]);
      return out(["You don't see that here."]);
    }
    if (/^(take|get|grab|pick\s+up)$/.test(clean)) return out(["Take what?"]);

    const dropM = clean.match(/^drop\s+(.+)$/);
    if (dropM) {
      const n = dropM[1];
      if (/^(lamp|lantern|light)$/.test(n)) {
        if (!zorkHas(z, "lamp")) return out(["You don't have that."]);
        z.lampLoc = z.room;
        return out(["You set the lamp down. The shadows move in to fill the space."]);
      }
      if (/^key$/.test(n)) {
        if (!zorkHas(z, "key")) return out(["You don't have that."]);
        z.keyLoc = z.room;
        return out(["You drop the key. It makes almost no sound."]);
      }
      if (/^(coin|penny)$/.test(n)) {
        if (z.coinLoc !== "inv") return out(["You don't have that."]);
        z.coinLoc = z.room;
        return out(["You drop the coin. It spins, then lies still. Heads: wings. Tails: wings."]);
      }
      if (/^(polaroid|photo)$/.test(n)) {
        if (z.polaroidLoc !== "inv") return out(["You don't have that."]);
        z.polaroidLoc = z.room;
        return out(["You set the polaroid down. The laugh stays in the room."]);
      }
      if (/^(zine|magazine)$/.test(n)) {
        if (z.zineLoc !== "inv") return out(["You don't have that."]);
        z.zineLoc = z.room;
        return out(["You drop the zine. It lands open to: The shop is one surface."]);
      }
      if (/^(sticker|slap)$/.test(n)) {
        if (z.stickerLoc !== "inv") return out(["You don't have that."]);
        z.stickerLoc = z.room;
        return out(["You drop the sticker. It lands sticky-side up. Optimistic."]);
      }
      return out(["You don't have that."]);
    }
    if (clean === "drop") return out(["Drop what?"]);

    const openM = clean.match(/^(?:open|unlock)\s+(.+)$/);
    if (openM) {
      const n = openM[1];
      if (/^drawer$/.test(n)) {
        if (z.room !== "desk") return out(["You don't see that here."]);
        if (z.drawer) return out(["It's already open."]);
        z.drawer = true;
        return out([z.lampLoc === "drawer"
          ? "The drawer slides open with a soft scrape. A brass lamp sits inside, as if someone left it for you."
          : "The drawer opens. Empty — except for the feeling that you were expected."]);
      }
      if (/^(door|attic)$/.test(n)) {
        if (z.room !== "hall" && z.room !== "attic") return out(["You don't see that here."]);
        if (z.atticOpen) return out(["It's already open."]);
        if (!zorkHas(z, "key")) return out(["Locked. The key you need is somewhere in the house, hiding in plain sight."]);
        z.atticOpen = true;
        zorkAward(z, "attic", 1);
        return out(["The key turns. The attic door exhales dust and old heat. West is open."]);
      }
      if (/^(gate|fence)$/.test(n)) {
        if (z.room !== "garden") return out(["You don't see that here."]);
        if (!zorkCanEscape(z)) return out(["The gate will not budge. The house is not finished with you."]);
        return out(zorkGo(z, "north"));
      }
      if (/^(trunk|chest)$/.test(n)) {
        if (z.room !== "attic") return out(["You don't see that here."]);
        if (z.trunkOpen) return out(["It's already open."]);
        z.trunkOpen = true;
        zorkFlag(z, "trunk");
        return out([
          "The clasp pops. The trunk opens on charcoal dust and old canvas.",
          "Inside: broken halo prop, charcoal sticks, a note —",
          "Art is Scumboy / Blackwater. You are a guest in their archive."
        ]);
      }
      if (/^(box|crate)\s+misc$|^misc(\s+box)?$/.test(n)) {
        if (z.room !== "stockroom") return out(["You don't see that here."]);
        if (z.miscOpen) return out(["It's already open."]);
        z.miscOpen = true;
        zorkFlag(z, "misc");
        return out([
          "You cut the tape. The MISC box sighs open.",
          "Inside: a winged-heart sticker and the smell of old cardboard.",
          "TAKE STICKER."
        ]);
      }
      if (/^mail$|^mailbox$|^letter$/.test(n)) {
        if (z.room !== "porch") return out(["You don't see that here."]);
        if (z.flags.mail) return out(["The mailbox is empty."]);
        z.flags.mail = true;
        zorkFlag(z, "mail");
        return out([
          "You open the mailbox.",
          "",
          "No stamp. No postmark. One sheet:",
          "",
          "  You woke because the house needed a witness.",
          "  Walk every room. Listen. Then leave.",
          "",
          "Signed: —"
        ]);
      }
      return out(["You can't open that."]);
    }
    if (/^(open|unlock)$/.test(clean)) return out(["Open what?"]);

    const useOnM = clean.match(/^use\s+(.+?)\s+on\s+(.+)$/);
    if (useOnM) {
      const item = useOnM[1];
      const target = useOnM[2];
      if (/polaroid|photo/.test(item) && /print|photo|tray/.test(target) && z.room === "darkroom") {
        if (z.polaroidLoc !== "inv") return out(["You don't have the polaroid."]);
        zorkFlag(z, "combo_polaroid");
        return out([
          "You hold the polaroid beside the dripping print.",
          "Joedotwhy laughing next to the house at night — same world, different rooms.",
          "Rarenugly would call this a sequence. You call it proof."
        ]);
      }
      if (/polaroid|photo/.test(item) && /wings|seal/.test(target) && z.room === "attic") {
        if (z.polaroidLoc !== "inv") return out(["You don't have the polaroid."]);
        zorkFlag(z, "combo_wings_photo");
        return out([
          "You hold the polaroid up to the seal.",
          "Laughing face over the heart. Absurd. True.",
          "The wings do not photobomb. They were already in frame."
        ]);
      }
      if (/zine|magazine/.test(item) && /desk|papers/.test(target) && z.room === "desk") {
        if (z.zineLoc !== "inv") return out(["You don't have the zine."]);
        zorkFlag(z, "combo_zine");
        return out([
          "You lay the zine on the desk beside the scattered papers.",
          "Canon meets index. The house hums approval — or indigestion."
        ]);
      }
      if (/coin|penny/.test(item) && /till|counter/.test(target) && z.room === "shop") {
        if (z.coinLoc !== "inv") return out(["You don't have the coin."]);
        z.coinLoc = "till";
        zorkFlag(z, "coin_till");
        return out([
          "You drop the coin in the till.",
          "Ka-ching — this time correct.",
          "The shop accepts nothing. It accepts the gesture."
        ]);
      }
      if (/sticker|slap/.test(item) && /seal|wings/.test(target) && z.room === "attic") {
        if (z.stickerLoc !== "inv") return out(["You don't have the sticker."]);
        z.stickerLoc = "seal";
        zorkFlag(z, "sticker_seal");
        return out([
          "You press the sticker to the seal's heart.",
          "Small tag on something huge.",
          "The wings do not mind. Or they mind quietly."
        ]);
      }
      if (/lamp|lantern/.test(item) && /grue|monster/.test(target) && z.room === "cellar" && z.lampOn) {
        zorkFlag(z, "combo_lamp_grue");
        return out([
          "You tilt the lamp toward the grue.",
          "'Finally,' it says. 'Spotlight. I always wanted an audience.'"
        ]);
      }
      if (/cigarette|pack/.test(item) && /grue/.test(target) && z.room === "cellar" && z.lampOn) {
        if (z.cigaretteLoc !== "inv") return out(["You don't have cigarettes."]);
        return out(["The grue sniffs. 'I don't smoke. Union rules.'"]);
      }
      return out(["That combination does nothing. Yet."]);
    }

    const putM = clean.match(/^put\s+(.+?)\s+(?:in|on|into)\s+(.+)$/);
    if (putM) {
      const item = putM[1];
      const place = putM[2];
      if (/coin|penny/.test(item) && /till|counter/.test(place)) {
        if (z.room !== "shop") return out(["Not here."]);
        if (z.coinLoc !== "inv") return out(["You don't have the coin."]);
        z.coinLoc = "till";
        zorkFlag(z, "coin_till");
        return out([
          "You drop the coin in the till.",
          "Ka-ching — this time correct.",
          "The shop accepts nothing. It accepts the gesture."
        ]);
      }
      if (/sticker|slap/.test(item) && /seal|wings/.test(place)) {
        if (z.room !== "attic") return out(["Not here."]);
        if (z.stickerLoc !== "inv") return out(["You don't have the sticker."]);
        z.stickerLoc = "seal";
        zorkFlag(z, "sticker_seal");
        return out([
          "You press the sticker to the seal's heart.",
          "Small tag on something huge.",
          "The wings do not mind. Or they mind quietly."
        ]);
      }
      return out(["That won't fit there."]);
    }

    if (/^(light|turn\s+on|switch\s+on)(?:\s+(.+))?$/.test(clean) || /^turn\s+.+\s+on$/.test(clean)) {
      const m = clean.match(/^(?:light|turn\s+on|switch\s+on)\s*(.*)$/) || [];
      const n = (m[1] || "lamp").replace(/\bon\b/g, "").trim() || "lamp";
      if (n && !/^(lamp|lantern|light)?$/.test(n)) return out(["You can't light that."]);
      if (!zorkHas(z, "lamp")) return out(["You don't have a lamp. Check the desk drawer downstairs."]);
      if (z.lampOn) return out(["The lamp is already on. Your shadow jumps when you breathe."]);
      z.lampOn = true;
      zorkAward(z, "light", 1);
      return out(["You strike the lamp alive. Warm light pools at your feet. The dark looks offended."]);
    }

    if (/^play(?:\s+(.+))?$/.test(clean)) {
      const pm = clean.match(/^play(?:\s+(.+))?$/);
      const playWhat = (pm[1] || "").trim();
      if (/demo|unreleased|cassette/.test(playWhat)) {
        if (z.room !== "tape") return out(["The deck is in the tape room — east from the desk."]);
        if (z.demoLoc !== "inv") return out(["You don't have the demo cassette."]);
        if (z.flags.demo_played) return out(["The demo loops. Rawer than the reel. Joedotwhy laughs mid-bar.", "Unreleased. Perfect."]);
        z.flags.demo_played = true;
        z.demoLoc = "deck";
        zorkFlag(z, "demo_played");
        if (!z.played) {
          z.played = true;
          zorkAward(z, "tape", 1);
        }
        return out([
          "You slot the demo into the deck. Different hiss — rougher, closer to the source.",
          "",
          "Joedotwhy — unfinished, laughing at his own bar:",
          "",
          "  '…five hearts in one chest…'",
          "  '…do not crop the feeling…'",
          "  '…where I'm at…'",
          "",
          "It ends before the drop lands. You feel cheated and blessed."
        ]);
      }
      if (z.room === "cellar") {
        zorkFlag(z, "cellar_play");
        return out([
          "You slot a blank tape into a player that was not there a second ago.",
          "Hiss. Then — a demo, unfinished, perfect:",
          "",
          "  '…where I'm at, where I'm at…'",
          "",
          "It ends mid-bar. The cellar applauds in dust."
        ]);
      }
      if (z.room !== "tape") return out(["There is nothing to play here."]);
      if (z.played) return out(["The tape loops. Joedotwhy is still talking over the beat. You listen anyway."]);
      z.played = true;
      zorkAward(z, "tape", 1);
      return out([
        "You press PLAY.",
        "",
        "Tape hiss. Then Joedotwhy — tired, awake, laughing at something you cannot see:",
        "",
        "  '…emptiness, emptiness…'",
        "  '…neon lights in the cut…'",
        "  '…where I'm at…'",
        "",
        "The bass hits.",
        "When it ends, the silence is a different colour."
      ]);
    }

    if (/^sit(?:\s+.*)?$/.test(clean)) {
      if (z.room === "garden") {
        zorkFlag(z, "garden_sit");
        return out([
          "You sit on the bench. Gravel white. Soil black. Pot red.",
          "For a minute you are not escaping. You are just here.",
          "Then you remember the gate."
        ]);
      }
      if (z.room !== "desk") return out(["There is nowhere to sit that matters."]);
      if (z.sat) {
        if (z.seenWings) return out(["You are already sitting.", "You understand the house. The gate may let you go."]);
        return out(["You are already sitting. The chair knows your weight."]);
      }
      z.sat = true;
      zorkAward(z, "sit", z.seenWings ? 2 : 1);
      if (z.seenWings) {
        return out([
          "You sit. The desk is the index of everything you saw upstairs.",
          "Wings. Seal. Red line. The house is larger than the room — you know that now.",
          "The garden gate might open, if you have done the rest."
        ]);
      }
      return out(["You sit at the desk. The chair is harder than you expected.", "The house feels larger than it did when you woke up."]);
    }

    const moveM = clean.match(/^(?:move|lift|push|pull|shift)\s+(.+)$/);
    if (moveM) {
      const n = moveM[1];
      if (z.room === "hall" && /portrait|painting|frame/.test(n)) {
        if (z.flags.portraitMoved) return out(["It's already aside. A narrow gap leads in."]);
        z.flags.portraitMoved = true;
        zorkFlag(z, "crawlspace_found");
        return out([
          "You push the portrait. It swings on a hidden hinge.",
          "Behind it: a crawlspace — low, dusty, smelling of tape oxide.",
          "A gap leads in."
        ]);
      }
      if (z.room === "bin" && /^(still|draft)$/.test(n)) {
        if (z.stillMoved) return out(["It's already aside."]);
        z.stillMoved = true;
        return out([z.keyLoc === "under"
          ? "You shove the still aside. Something glints in the dust — a small iron key, waiting."
          : "You shove the still aside. Dust rises. Nothing else."]);
      }
      return out(["You can't move that."]);
    }

    const useM = clean.match(/^use\s+(.+)$/);
    if (useM) {
      const n = useM[1];
      if (/^key$/.test(n)) {
        if (!zorkHas(z, "key")) return out(["You don't have that."]);
        if (z.room !== "hall") return out(["Not here. The attic door is in the hall — west, upstairs."]);
        if (z.atticOpen) return out(["It's already open."]);
        z.atticOpen = true;
        zorkAward(z, "attic", 1);
        return out(["The key turns. The attic door exhales dust and old heat. West is open."]);
      }
      if (/^(lamp|lantern)$/.test(n)) {
        if (!zorkHas(z, "lamp")) return out(["You don't have that."]);
        if (z.lampOn) return out(["The lamp is already on."]);
        z.lampOn = true;
        zorkAward(z, "light", 1);
        return out(["The lamp flares. The dark steps back."]);
      }
      return out(["You can't use that here."]);
    }

    if (/^(touch|feel)(?:\s+(.+))?$/.test(clean)) {
      const m = clean.match(/^(touch|feel)(?:\s+(.+))?$/);
      const thing = m[2] || "";
      if (/wings|seal/.test(thing) && (z.room === "attic" || z.room === "roof")) {
        zorkFlag(z, "touch_wings");
        return out(["You touch the seal. Warm paint. Or cold stone. Your hand cannot decide.", "Do not crop. Do not squash. You won't."]);
      }
      if (/mirror/.test(thing) && z.room === "wake") {
        return out(["Cold glass. For a second your reflection waves — you did not."]);
      }
      return out(["Cold wall. Warm air from somewhere north. The house has a pulse if you press long enough."]);
    }
    if (/^(smell|sniff)(?:\s+.*)?$/.test(clean)) {
      if (z.room === "garden") return out(["Soil, night-bloom, red clay. No perfume. The garden is honest."]);
      if (z.room === "tape") return out(["Tape oxide and hot electronics. Nostalgia with a fuse smell."]);
      return out(["Dust, tape oxide, and something metallic."]);
    }

    if (/^(search|rummage|look\s+under)(?:\s+(.+))?$/.test(clean)) {
      const sm = clean.match(/^(?:search|rummage|look\s+under)(?:\s+(.+))?$/);
      const what = sm[1] || "";
      if ((z.room === "wake" && /bed/.test(what)) || (z.room === "wake" && !what && !z.flags.ticket)) {
        if (z.flags.ticket) return out(["Nothing else under the bed except dust and a sense of anticlimax."]);
        z.flags.ticket = true;
        zorkFlag(z, "ticket");
        return out([
          "You reach under the bed.",
          "A gig ticket stub — ink smudged, date unreadable.",
          "Venue: somewhere in the UK. Act: probably Joedotwhy.",
          "You were meant to be there. Maybe you were."
        ]);
      }
      if (z.room === "bin" && !z.stillMoved) return out(["Something heavy sits behind the still — leaning, in the way."]);
      if (z.room === "desk" && !z.drawer) return out(["The drawer is shut. The handle is warm."]);
      if (z.room === "wake" && !what) return out(["The bed is untouched. The floor remembers you. Something might be under the bed."]);
      return out(["You search. Mostly dust. Mostly history."]);
    }

    if (/^flip(?:\s+coin)?$/.test(clean)) {
      if (z.coinLoc !== "inv") return out(["You have no coin to flip."]);
      zorkFlag(z, "flip");
      return out(["Heads. Wings. You flip again. Wings. The house does not gamble fair."]);
    }

    const nudge = zorkRoomNudge(z);
    const lost = z.turns > 12 && Object.keys(z.seen).length < 4;
    if (nudge && (lost || z.turns % 17 === 0)) {
      return out([
        "I don't understand that — but the house appreciates the effort.",
        nudge,
        ...zorkExitLine(z)
      ]);
    }
    return out([
      "I don't understand that — but the house appreciates the effort.",
      "LOOK and EXITS show where you are. LISTEN and EXAMINE reveal more.",
      ...zorkExitLine(z)
    ]);
  };

  const wantedHelp = (args) => args[0] === "/?" || args[0] === "-?" || args[0] === "/help";

  const APPS = {
    calc: "calc",
    "calc.exe": "calc",
    calculator: "calc",
    notepad: "info",
    "notepad.exe": "info",
    write: "info",
    explorer: "photos",
    "explorer.exe": "photos",
    iexplore: "browser",
    "iexplore.exe": "browser",
    browser: "browser",
    mspaint: "photos",
    "mspaint.exe": "photos",
    info: "info",
    "info.txt": "info",
    shop: "shop",
    photos: "photos",
    wmplayer: "play",
    "wmplayer.exe": "play",
    play: "play",
    winamp: "play",
    "winamp.exe": "play",
    videos: "videos",
    "videos.exe": "videos",
    photos: "photos",
    bin: "bin",
    recycle: "bin",
    sys: "sys",
    winver: "sys",
    "winver.exe": "sys",
    cmd: "cmd",
    "cmd.exe": "cmd",
    command: "cmd",
    "command.com": "cmd"
  };

  const openApp = (name) => {
    if (name === "shop" || name === "info") {
      const api = window.FH && window.FH.os;
      if (api && typeof api.openDoc === "function") {
        api.openDoc(name);
        return "";
      }
      if (name === "shop") {
        const href = window.FH && window.FH.routes && window.FH.routes.shop;
        if (href) {
          location.href = href;
          return "";
        }
      }
      return "Unable to start the specified program.";
    }
    const api = window.FH && window.FH.os;
    if (!api || !api.openWin) return "Unable to start the specified program.";
    api.openWin(name);
    return "";
  };

  const runningTasks = () => {
    const rows = [
      { name: "CMD.EXE", pid: 505, mem: "1,024 K" },
      { name: "KERNEL.SYS", pid: 5, mem: "2,048 K" }
    ];
    document.querySelectorAll(".os-win:not([hidden])").forEach((w, i) => {
      const id = w.getAttribute("data-win") || "app";
      const title = (w.querySelector(".os-win__bar span") || {}).textContent || id;
      rows.push({ name: title.replace(/\s+/g, "_").toUpperCase() + ".EXE", pid: 1000 + i, mem: "512 K", win: id });
    });
    return rows;
  };

  const dirListing = (state, spec, flags) => {
    const target = spec || ".";
    const parsed = parsePath(target, state.cwd);
    if (!parsed.ok) return parsed.err;
    let parts = parsed.parts;
    let filter = "*";
    let hit = walk(state.root, parts);
    if (!hit.node && parts.length) {
      filter = parts[parts.length - 1];
      parts = parts.slice(0, -1);
      hit = walk(state.root, parts);
    }
    if (!hit.node || hit.node.kind !== "dir") {
      const fileHit = walk(state.root, parsed.parts);
      if (fileHit.node && fileHit.node.kind === "file") {
        const n = fileHit.trail[fileHit.trail.length - 1];
        if (flags.b) return n;
        const sz = String(sizeOf(fileHit.node)).padStart(12);
        return `${fileHit.node.stamp.date}  ${fileHit.node.stamp.time}    ${sz} ${n}`;
      }
      return "File Not Found";
    }
    const re = globRe(isGlob(filter) ? filter : (filter === "*" ? "*" : filter));
    const names = Object.keys(hit.node.children).filter((k) => {
      const n = hit.node.children[k];
      if (n.hidden && !flags.a) return false;
      return filter === "*" || isGlob(filter) ? re.test(k) : k.toLowerCase() === filter.toLowerCase();
    }).sort((a, b) => {
      const da = hit.node.children[a].kind === "dir";
      const db = hit.node.children[b].kind === "dir";
      if (da !== db) return da ? -1 : 1;
      return a.localeCompare(b);
    });

    const lines = [];
    const pathLabel = showPath(hit.trail);
    if (!flags.b) {
      lines.push(" Volume in drive " + DRIVE + " is " + VOLUME);
      lines.push(" Volume Serial Number is " + SERIAL);
      lines.push("");
      lines.push(" Directory of " + pathLabel);
      lines.push("");
    }

    let files = 0;
    let dirs = 0;
    let bytes = 0;

    const emit = (name, node, prefix) => {
      if (node.kind === "dir") dirs += 1;
      else {
        files += 1;
        bytes += sizeOf(node);
      }
      if (flags.b) {
        lines.push((prefix ? prefix + "\\" : "") + name);
        return;
      }
      const st = node.stamp || BORN;
      if (node.kind === "dir") lines.push(`${st.date}  ${st.time}    <DIR>          ${name}`);
      else lines.push(`${st.date}  ${st.time}    ${String(sizeOf(node)).padStart(12)} ${name}`);
    };

    if (flags.s) {
      const rec = (node, trail) => {
        if (!flags.b) {
          lines.push("");
          lines.push(" Directory of " + showPath(trail));
          lines.push("");
        }
        Object.keys(node.children).sort().forEach((k) => {
          const n = node.children[k];
          if (n.hidden && !flags.a) return;
          emit(k, n);
        });
        Object.keys(node.children).forEach((k) => {
          const n = node.children[k];
          if (n.kind === "dir" && !(n.hidden && !flags.a)) rec(n, trail.concat(k));
        });
      };
      rec(hit.node, hit.trail);
    } else if (flags.w && !flags.b) {
      const cols = names.map((n) => (hit.node.children[n].kind === "dir" ? "[" + n + "]" : n));
      for (let i = 0; i < cols.length; i += 4) lines.push("  " + cols.slice(i, i + 4).map((s) => s.padEnd(18)).join(""));
      names.forEach((n) => {
        const node = hit.node.children[n];
        if (node.kind === "dir") dirs += 1;
        else {
          files += 1;
          bytes += sizeOf(node);
        }
      });
    } else {
      names.forEach((n) => emit(n, hit.node.children[n]));
    }

    if (!flags.b) {
      lines.push(`              ${String(files).padStart(3)} File(s)  ${String(bytes).padStart(14)} bytes`);
      lines.push(`              ${String(dirs).padStart(3)} Dir(s)   ${String(32768000 - bytes).padStart(14)} bytes free`);
    }
    return lines.join("\n");
  };

  const treeText = (state, spec, showFiles, ascii) => {
    const parsed = parsePath(spec || ".", state.cwd);
    if (!parsed.ok) return parsed.err;
    const hit = walk(state.root, parsed.parts);
    if (!hit.node || hit.node.kind !== "dir") return "Invalid path.";
    const br = ascii
      ? { pipe: "|   ", tee: "+---", last: "\\---", blank: "    " }
      : { pipe: "│   ", tee: "├───", last: "└───", blank: "    " };
    const lines = [
      "Folder PATH listing for volume " + VOLUME,
      "Volume serial number is " + SERIAL,
      showPath(hit.trail)
    ];
    const walkTree = (node, prefix) => {
      const names = Object.keys(node.children).filter((k) => {
        const n = node.children[k];
        if (n.hidden) return false;
        return showFiles || n.kind === "dir";
      }).sort((a, b) => {
        const da = node.children[a].kind === "dir";
        const db = node.children[b].kind === "dir";
        if (da !== db) return da ? -1 : 1;
        return a.localeCompare(b);
      });
      names.forEach((name, i) => {
        const last = i === names.length - 1;
        const n = node.children[name];
        lines.push(prefix + (last ? br.last : br.tee) + name);
        if (n.kind === "dir") walkTree(n, prefix + (last ? br.blank : br.pipe));
      });
    };
    walkTree(hit.node, "");
    return lines.join("\n");
  };

  const readText = (node, name) => {
    if (!node) return "The system cannot find the file specified.";
    if (node.kind === "dir") return "Access is denied.";
    if (node.bin || BINARIES.test(name || "")) return "This file is not a text file.";
    return node.body || "";
  };

  const writeFile = (state, spec, body, append) => {
    const parsed = parsePath(spec, state.cwd);
    if (!parsed.ok) return parsed.err;
    const parts = parsed.parts;
    if (!parts.length) return "Access is denied.";
    const par = parentOf(state, parts);
    if (!par.ok) return par.err;
    if (!par.key) {
      const name = parts[parts.length - 1];
      par.parent.children[name] = file(body, { stamp: stampNow() });
      return "";
    }
    const node = par.parent.children[par.key];
    if (node.kind === "dir") return "Access is denied.";
    if (node.ro) return "Access is denied.";
    node.body = append ? (node.body || "") + body : body;
    node.bin = false;
    node.bytes = undefined;
    node.stamp = stampNow();
    return "";
  };

  const copyOne = (state, srcSpec, destSpec) => {
    const src = resolve(state, srcSpec);
    if (!src.ok) return { err: "The system cannot find the file specified.", n: 0 };
    if (src.node.kind === "dir") return { err: "The directory cannot be copied.", n: 0 };
    let destParsed = parsePath(destSpec, state.cwd);
    if (!destParsed.ok) return { err: destParsed.err, n: 0 };
    let destHit = walk(state.root, destParsed.parts);
    let destName;
    let parent;
    if (destHit.node && destHit.node.kind === "dir") {
      parent = destHit.node;
      destName = src.parts[src.parts.length - 1];
    } else {
      const par = parentOf(state, destParsed.parts);
      if (!par.ok) return { err: par.err, n: 0 };
      parent = par.parent;
      destName = destParsed.parts[destParsed.parts.length - 1];
      if (par.key && parent.children[par.key].kind === "dir") {
        parent = parent.children[par.key];
        destName = src.parts[src.parts.length - 1];
      }
    }
    const existing = Object.keys(parent.children).find((k) => k.toLowerCase() === destName.toLowerCase());
    const cloned = clone(src.node);
    cloned.stamp = stampNow();
    cloned.ro = false;
    parent.children[existing || destName] = cloned;
    return { n: 1 };
  };

  const pingHost = (host, count) => {
    const n = Math.min(10, Math.max(1, count || 4));
    const name = host || "fivehearts.uk";
    const ip = "127.0.0.5";
    const lines = [`Pinging ${name} [${ip}] with 32 bytes of data:`];
    for (let i = 0; i < n; i++) lines.push(`Reply from ${ip}: bytes=32 time<1ms TTL=128`);
    lines.push("");
    lines.push(`Ping statistics for ${ip}:`);
    lines.push(`    Packets: Sent = ${n}, Received = ${n}, Lost = 0 (0% loss),`);
    lines.push("Approximate round trip times in milli-seconds:");
    lines.push("    Minimum = 0ms, Maximum = 0ms, Average = 0ms");
    return lines.join("\n");
  };

  const SERVICES = [
    { name: "Desk", display: "FIVEHEARTS Desk", state: "RUNNING" },
    { name: "Tape", display: "House Tape", state: "RUNNING" },
    { name: "ShopTill", display: "Shopify Till", state: "RUNNING" },
    { name: "Wings", display: "Seal", state: "RUNNING" },
    { name: "Kernel", display: "HOUSE Kernel", state: "RUNNING" },
    { name: "Spooler", display: "Print Spooler", state: "STOPPED" }
  ];

  const hexDump = (text) => {
    const bytes = [...String(text)].map((c) => c.charCodeAt(0) & 255).slice(0, 256);
    const lines = [];
    for (let i = 0; i < bytes.length; i += 16) {
      const slice = bytes.slice(i, i + 16);
      const hex = slice.map((b) => b.toString(16).padStart(2, "0")).join(" ").padEnd(47);
      const ascii = slice.map((b) => (b >= 32 && b < 127 ? String.fromCharCode(b) : ".")).join("");
      lines.push(i.toString(16).padStart(4, "0") + "  " + hex + "  " + ascii);
    }
    return lines.join("\n") || "File is empty.";
  };

  const splitChain = (line) => {
    const parts = [];
    let cur = "";
    let q = null;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (q) {
        if (c === q) q = null;
        cur += c;
        continue;
      }
      if (c === '"' || c === "'") {
        q = c;
        cur += c;
        continue;
      }
      if (c === "&") {
        if (line[i + 1] === "&") i += 1;
        parts.push(cur.trim());
        cur = "";
        continue;
      }
      cur += c;
    }
    if (cur.trim()) parts.push(cur.trim());
    return parts.length ? parts : [line];
  };

  const runBat = (state, text, ctx) => {
    const out = [];
    String(text || "").split(/\r?\n/).forEach((raw) => {
      let line = raw.replace(/^\s+/, "").replace(/^@/, "");
      if (!line || /^rem\b/i.test(line) || line.startsWith("::")) return;
      if (/^echo\s+off$/i.test(line)) return;
      splitChain(line).forEach((seg) => {
        const r = dispatch(state, seg, ctx);
        if (r && r.text) out.push(r.text);
      });
    });
    return out.join("\n");
  };

  const runFind = (state, args, flags, stdin) => {
    let needle = "";
    const files = [];
    args.forEach((a) => {
      if (!needle) needle = a;
      else files.push(a);
    });
    if (!needle) return "FIND: Parameter format not correct";
    const test = (line, i) => {
      const hay = flags.i ? line.toLowerCase() : line;
      const n = flags.i ? needle.toLowerCase() : needle;
      const hit = hay.indexOf(n) >= 0;
      return flags.v ? !hit : hit;
    };
    const scan = (text, label) => {
      const rows = String(text).split(/\r?\n/);
      const out = [];
      let c = 0;
      rows.forEach((line, i) => {
        if (test(line, i)) {
          c += 1;
          if (!flags.c) out.push((flags.n ? (i + 1) + ":" : "") + line);
        }
      });
      if (flags.c) return (label ? label + ": " : "") + c;
      return (label && files.length ? label.toUpperCase() + "\n" : "") + out.join("\n");
    };
    if (stdin != null) return scan(stdin, "");
    if (!files.length) return "FIND: Parameter format not correct";
    return files.map((f) => {
      const hit = resolve(state, f);
      if (!hit.ok || hit.node.kind !== "file") return "File not found - " + f;
      return scan(readText(hit.node, f), f);
    }).join("\n");
  };

  const cmds = {};
  const def = (names, fn) => names.forEach((n) => { cmds[n] = fn; });

  def(["help", "?"], (args) => {
    if (!args.length) return helpAll();
    const k = args[0].toLowerCase().replace(/^\//, "");
    return HELP[k] || "This command is not supported by the help utility.";
  });
  def(["zork", "zork.exe", "adventure"], (args, ctx) => zorkStart(ctx));
  def(["cls", "clear"], () => ({ clear: true }));
  def(["cmd", "command"], () => bootText());
  def(["ver", "winver"], () => [
    "FIVEHEARTS OS [Version 5.05.0]",
    "FIVEHEARTS CMD  5.05  (C:\\FIVEHEARTS\\SYSTEM\\CMD.EXE)"
  ].join("\n"));
  def(["vol"], () => ` Volume in drive ${DRIVE} is ${VOLUME}\n Volume Serial Number is ${SERIAL}`);
  def(["label"], (args) => {
    if (!args.length) return `Volume in drive ${DRIVE} is ${VOLUME}\nVolume Serial Number is ${SERIAL}`;
    return "Access denied - " + DRIVE + ":\\" + " is write-protected.";
  });
  def(["hostname"], () => "FIVEHEARTS");
  def(["whoami"], () => "FIVEHEARTS\\GUEST");
  def(["mem"], (args) => {
    const base = [
      "655360 bytes total conventional memory",
      "655360 bytes available to FIVEHEARTS OS",
      "598016 bytes largest executable program size",
      "",
      "1048576 bytes total EMS memory",
      "1048576 bytes free EMS memory",
      "",
      "32768000 bytes total contiguous extended memory",
      "0 bytes available contiguous extended memory",
      "32768000 bytes available XMS memory",
      "        FIVEHEARTS OS resident in High Memory Area"
    ];
    if (args.some((a) => /^\/c$/i.test(a) || a.toLowerCase() === "-c")) {
      return [
        "Conventional Memory Detail:",
        "",
        "  Name            Size     Type",
        "  ----------      -------  -----------",
        "  IO             16,384    System",
        "  HIMEM           3,072    Device",
        "  KERNEL        220,440    System",
        "  CMD            28,672    Program",
        "  Desk           51,200    Program",
        "  FREE          335,872    <free>"
      ].join("\n");
    }
    return base.join("\n");
  });
  def(["systeminfo"], () => {
    const d = new Date();
    return [
      "Host Name:                 FIVEHEARTS",
      "OS Name:                   FIVEHEARTS OS",
      "OS Version:                5.05.0 Build 505",
      "OS Manufacturer:           HOUSE",
      "OS Configuration:          Standalone Workstation",
      "OS Build Type:             Uniprocessor Free",
      "Registered Owner:          GUEST",
      "Product ID:                00505-OEM-0000000-00005",
      "Original Install Date:     05/05/2018, 05:05:05",
      "System Boot Time:          " + d.toLocaleString(),
      "System Manufacturer:       UNKNOWN",
      "System Model:              DESK",
      "Processor(s):              1 Processor(s) Installed.",
      "                           [01]: x86 unknown",
      "BIOS Version:              HOUSE 5.05, 05/05/2018",
      "Windows Directory:         C:\\FIVEHEARTS\\WINDOWS",
      "System Directory:          C:\\FIVEHEARTS\\SYSTEM",
      "Boot Device:               \\Device\\HarddiskVolume5",
      "System Locale:             en-gb",
      "Time Zone:                 " + Intl.DateTimeFormat().resolvedOptions().timeZone,
      "Total Physical Memory:     32 MB",
      "Available Physical Memory: 18 MB",
      "Virtual Memory: Max Size:  64 MB",
      "Virtual Memory: Available: 40 MB",
      "Page File Location(s):     C:\\FIVEHEARTS\\WINDOWS\\WIN386.SWP"
    ].join("\n");
  });
  def(["date"], (args, ctx) => {
    const d = new Date();
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const shown = `The current date is: ${days[d.getDay()]} ${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
    if (!args.length) return shown + "\nEnter the new date: (mm-dd-yy)";
    return shown;
  });
  def(["time"], (args) => {
    const d = new Date();
    const shown = `The current time is: ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())},${pad(Math.floor(d.getMilliseconds() / 10))}`;
    if (!args.length) return shown + "\nEnter the new time:";
    return shown;
  });
  def(["dir", "ls"], (args, ctx) => {
    const { flags, rest } = switches(args);
    return dirListing(ctx.state, rest[0], flags);
  });
  def(["cd", "chdir"], (args, ctx) => {
    if (!args.length) return showPath(ctx.state.cwd);
    const parsed = parsePath(args[0], ctx.state.cwd);
    if (!parsed.ok) return parsed.err;
    const hit = walk(ctx.state.root, parsed.parts);
    if (!hit.node) return "The system cannot find the path specified.";
    if (hit.node.kind !== "dir") return "The directory name is invalid.";
    ctx.state.cwd = hit.trail;
    syncPrompt(ctx.form, ctx.state);
    return "";
  });
  def(["pushd"], (args, ctx) => {
    ctx.state.dstack.push(ctx.state.cwd.slice());
    if (!args.length) return "";
    return cmds.cd(args, ctx);
  });
  def(["popd"], (args, ctx) => {
    const prev = ctx.state.dstack.pop();
    if (!prev) return "";
    ctx.state.cwd = prev;
    syncPrompt(ctx.form, ctx.state);
    return "";
  });
  def(["md", "mkdir"], (args, ctx) => {
    if (!args.length) return "The syntax of the command is incorrect.";
    const parsed = parsePath(args[0], ctx.state.cwd);
    if (!parsed.ok) return parsed.err;
    if (!parsed.parts.length) return "Access is denied.";
    const par = parentOf(ctx.state, parsed.parts);
    if (!par.ok) return par.err;
    const name = parsed.parts[parsed.parts.length - 1];
    if (par.key) return "A subdirectory or file " + name + " already exists.";
    par.parent.children[name] = dir({}, { stamp: stampNow() });
    return "";
  });
  def(["rd", "rmdir"], (args, ctx) => {
    const { flags, rest } = switches(args);
    if (!rest.length) return "The syntax of the command is incorrect.";
    const parsed = parsePath(rest[0], ctx.state.cwd);
    if (!parsed.ok) return parsed.err;
    const par = parentOf(ctx.state, parsed.parts);
    if (!par.ok || !par.key) return "The system cannot find the file specified.";
    const node = par.parent.children[par.key];
    if (node.kind !== "dir") return "The directory name is invalid.";
    const names = Object.keys(node.children);
    if (names.length && !flags.s) return "The directory is not empty.";
    if (node.ro) return "Access is denied.";
    delete par.parent.children[par.key];
    return "";
  });
  def(["type", "cat"], (args, ctx) => {
    if (!args.length) return "The syntax of the command is incorrect.";
    return args.map((f) => {
      const hit = resolve(ctx.state, f);
      if (!hit.ok) return "The system cannot find the file specified.";
      return readText(hit.node, hit.parts[hit.parts.length - 1]);
    }).join("\n");
  });
  def(["more"], (args, ctx) => {
    if (!args.length) return ctx.stdin != null ? ctx.stdin : "";
    return cmds.type(args, ctx);
  });
  def(["echo"], (args, ctx) => {
    if (!args.length) return "ECHO is " + (ctx.state.echo !== false ? "on" : "off") + ".";
    const a = args[0].toLowerCase();
    if (a === "on") {
      ctx.state.echo = true;
      return "";
    }
    if (a === "off") {
      ctx.state.echo = false;
      return "";
    }
    return args.join(" ");
  });
  def(["set"], (args, ctx) => {
    if (!args.length) {
      return Object.keys(ctx.state.env).sort().map((k) => k + "=" + ctx.state.env[k]).join("\n");
    }
    const raw = args.join(" ");
    const eq = raw.indexOf("=");
    if (eq < 0) {
      const k = raw.toUpperCase();
      return Object.keys(ctx.state.env)
        .filter((n) => n.toUpperCase().startsWith(k))
        .sort()
        .map((n) => n + "=" + ctx.state.env[n])
        .join("\n") || "";
    }
    const key = raw.slice(0, eq);
    const val = raw.slice(eq + 1);
    if (!key) return "The syntax of the command is incorrect.";
    const name = key.toUpperCase();
    if (val === "") delete ctx.state.env[name];
    else ctx.state.env[name] = val;
    if (name === "PROMPT") {
      ctx.state.env.PROMPT = val || (ctx.form && ctx.form.hasAttribute("data-cons-form") ? "$G" : "$P$G");
      syncPrompt(ctx.form, ctx.state);
    }
    return "";
  });
  def(["path"], (args, ctx) => {
    if (!args.length) return "PATH=" + (ctx.state.env.PATH || "");
    if (args[0] === ";") {
      ctx.state.env.PATH = "";
      return "";
    }
    ctx.state.env.PATH = expandEnv(ctx.state, args.join(" "));
    return "";
  });
  def(["prompt"], (args, ctx) => {
    const next = args.length ? args.join(" ") : (ctx.form && ctx.form.hasAttribute("data-cons-form") ? "$G" : "$P$G");
    ctx.state.env.PROMPT = next;
    syncPrompt(ctx.form, ctx.state);
    return "";
  });
  def(["tree"], (args, ctx) => {
    const { flags, rest } = switches(args);
    return treeText(ctx.state, rest[0], flags.f, flags.a);
  });
  def(["copy", "xcopy"], (args, ctx) => {
    const { flags, rest } = switches(args);
    if (!rest.length) return "The syntax of the command is incorrect.";
    const src = rest[0];
    const dest = rest[1] || ".";
    if (isGlob(src)) {
      const exp = expand(ctx.state, src);
      if (!exp.ok) return exp.err;
      let n = 0;
      exp.names.forEach((name) => {
        if (exp.parent.children[name].kind !== "file") return;
        const r = copyOne(ctx.state, showPath(exp.parts.concat(name)), dest);
        if (!r.err) n += r.n;
      });
      return `        ${n} file(s) copied.`;
    }
    const r = copyOne(ctx.state, src, dest);
    if (r.err) return r.err;
    return `        ${r.n} file(s) copied.`;
  });
  def(["del", "erase"], (args, ctx) => {
    const { flags, rest } = switches(args);
    if (!rest.length) return "The syntax of the command is incorrect.";
    const spec = rest[0];
    const exp = expand(ctx.state, spec);
    if (!exp.ok) return exp.err;
    const files = exp.names.filter((n) => exp.parent.children[n].kind === "file");
    if (!files.length) return "Could Not Find " + spec;
    if ((exp.pattern === "*" || exp.pattern === "*.*") && !flags.q && !flags.y) {
      ctx.state.wait = { type: "del", parent: exp.parent, files, flags };
      return spec + ", Are you sure (Y/N)?";
    }
    const lines = [];
    files.forEach((n) => {
      const node = exp.parent.children[n];
      if (node.ro) lines.push("Access is denied. " + n);
      else delete exp.parent.children[n];
    });
    return lines.join("\n");
  });
  def(["ren", "rename"], (args, ctx) => {
    if (args.length < 2) return "The syntax of the command is incorrect.";
    const src = resolve(ctx.state, args[0]);
    if (!src.ok) return "The system cannot find the file specified.";
    if (src.node.ro) return "Access is denied.";
    const par = parentOf(ctx.state, src.parts);
    const destName = args[1].split(/[/\\]/).pop();
    if (Object.keys(par.parent.children).some((k) => k.toLowerCase() === destName.toLowerCase())) {
      return "A duplicate file name exists, or the file cannot be found.";
    }
    par.parent.children[destName] = src.node;
    delete par.parent.children[par.key];
    src.node.stamp = stampNow();
    return "";
  });
  def(["move"], (args, ctx) => {
    if (args.length < 2) return "The syntax of the command is incorrect.";
    const r = copyOne(ctx.state, args[0], args[1]);
    if (r.err) return r.err;
    const src = resolve(ctx.state, args[0]);
    if (src.ok && !src.node.ro) {
      const par = parentOf(ctx.state, src.parts);
      if (par.ok && par.key) delete par.parent.children[par.key];
    }
    return `        ${r.n} file(s) moved.`;
  });
  def(["attrib"], (args, ctx) => {
    const rest = [];
    let add = "";
    let sub = "";
    args.forEach((a) => {
      if (/^[+-][RHrh]+$/.test(a) || /^[+-][RH]$/i.test(a)) {
        if (a[0] === "+") add += a.slice(1).toUpperCase();
        else sub += a.slice(1).toUpperCase();
      } else rest.push(a);
    });
    const spec = rest[0] || "*";
    const exp = expand(ctx.state, spec);
    if (!exp.ok) return exp.err;
    const lines = [];
    exp.names.forEach((n) => {
      const node = exp.parent.children[n];
      if (add.indexOf("R") >= 0) node.ro = true;
      if (sub.indexOf("R") >= 0) node.ro = false;
      if (add.indexOf("H") >= 0) node.hidden = true;
      if (sub.indexOf("H") >= 0) node.hidden = false;
      lines.push(`${node.ro ? "R" : " "} ${node.hidden ? "H" : " "}           ${showPath(exp.parts.concat(n))}`);
    });
    return lines.join("\n") || "File not found";
  });
  def(["find", "findstr"], (args, ctx) => {
    const { flags, rest } = switches(args);
    return runFind(ctx.state, rest, flags, ctx.stdin);
  });
  def(["sort"], (args, ctx) => {
    const text = args.length ? cmds.type(args, ctx) : (ctx.stdin || "");
    return String(text).split(/\r?\n/).sort((a, b) => a.localeCompare(b)).join("\n");
  });
  def(["fc", "comp"], (args, ctx) => {
    if (args.length < 2) return "The syntax of the command is incorrect.";
    const a = resolve(ctx.state, args[0]);
    const b = resolve(ctx.state, args[1]);
    if (!a.ok || !b.ok) return "FC: cannot open file";
    const ta = readText(a.node, args[0]);
    const tb = readText(b.node, args[1]);
    if (ta === tb) return `Comparing files ${args[0]} and ${args[1]}\nFC: no differences encountered`;
    return `Comparing files ${args[0]} and ${args[1]}\n***** ${args[0]}\n${ta}\n***** ${args[1]}\n${tb}\n*****`;
  });
  def(["assoc"], (args, ctx) => {
    if (!args.length) {
      return Object.keys(ctx.state.assoc).sort().map((k) => k + "=" + ctx.state.assoc[k]).join("\n");
    }
    const raw = args[0];
    const eq = raw.indexOf("=");
    if (eq < 0) {
      const k = raw.toLowerCase().startsWith(".") ? raw.toLowerCase() : "." + raw.toLowerCase();
      return ctx.state.assoc[k] ? k + "=" + ctx.state.assoc[k] : "File association not found for extension " + k;
    }
    const ext = raw.slice(0, eq).toLowerCase();
    const val = raw.slice(eq + 1);
    if (!val) delete ctx.state.assoc[ext];
    else ctx.state.assoc[ext] = val;
    return val ? ext + "=" + val : "";
  });
  def(["ftype"], () => "File types are locked by the house.");
  def(["where"], (args, ctx) => {
    const { flags, rest } = switches(args);
    if (!rest.length) return "The syntax of the command is incorrect.";
    const pattern = rest[0];
    const start = flags.r && rest[1] ? rest[1] : showPath(ctx.state.cwd);
    const parsed = parsePath(start, ctx.state.cwd);
    if (!parsed.ok) return parsed.err;
    const hit = walk(ctx.state.root, parsed.parts);
    if (!hit.node || hit.node.kind !== "dir") return "The system cannot find the path specified.";
    const re = globRe(pattern);
    const found = [];
    const rec = (node, trail) => {
      Object.keys(node.children).forEach((k) => {
        const n = node.children[k];
        const p = trail.concat(k);
        if (re.test(k)) found.push(showPath(p));
        if (n.kind === "dir") rec(n, p);
      });
    };
    rec(hit.node, hit.trail);
    return found.join("\n") || "INFO: Could not find files for the given pattern(s).";
  });
  def(["ipconfig"], (args) => {
    const all = args.some((a) => a.toLowerCase() === "/all");
    const lines = [
      "Windows IP Configuration",
      "",
      "Ethernet adapter Local Area Connection:",
      "",
      "   Connection-specific DNS Suffix  . : house.local",
      "   IP Address. . . . . . . . . . . . : 192.168.5.5",
      "   Subnet Mask . . . . . . . . . . . : 255.255.255.0",
      "   Default Gateway . . . . . . . . . : 192.168.5.1"
    ];
    if (all) {
      lines.splice(5, 0,
        "   Description . . . . . . . . . . . : FIVEHEARTS Desk NIC",
        "   Physical Address. . . . . . . . . : 05-05-05-05-05-05",
        "   DHCP Enabled. . . . . . . . . . . : No"
      );
    }
    return lines.join("\n");
  });
  def(["ping"], (args) => {
    const { rest } = switches(args);
    let count = 4;
    const nFlag = args.findIndex((a) => a.toLowerCase() === "-n" || a.toLowerCase() === "/n");
    if (nFlag >= 0 && args[nFlag + 1]) count = parseInt(args[nFlag + 1], 10) || 4;
    const host = rest.filter((a) => !/^\d+$/.test(a))[0] || rest[0];
    return pingHost(host, count);
  });
  def(["tracert", "traceroute"], (args) => {
    const host = args.filter((a) => !a.startsWith("-") && !a.startsWith("/"))[0] || "fivehearts.uk";
    return [
      `Tracing route to ${host} [127.0.0.5]`,
      "over a maximum of 30 hops:",
      "",
      "  1    <1 ms    <1 ms    <1 ms  192.168.5.1",
      "  2    <1 ms    <1 ms    <1 ms  127.0.0.5",
      "",
      "Trace complete."
    ].join("\n");
  });
  def(["nslookup"], (args) => {
    const host = args[0] || "fivehearts.uk";
    return [
      "Server:  house.local",
      "Address:  192.168.5.1",
      "",
      "Name:    " + host,
      "Address:  127.0.0.5"
    ].join("\n");
  });
  def(["netstat"], () => [
    "Active Connections",
    "",
    "  Proto  Local Address          Foreign Address        State",
    "  TCP    192.168.5.5:505        127.0.0.5:80           ESTABLISHED",
    "  TCP    192.168.5.5:1080       192.168.5.1:53         CLOSE_WAIT"
  ].join("\n"));
  def(["arp"], () => "Interface: 192.168.5.5 --- 0x5\n  Internet Address      Physical Address      Type\n  192.168.5.1           05-05-05-00-00-01     dynamic");
  def(["getmac"], () => "Physical Address    Transport Name\n=================== ==========================================================\n05-05-05-05-05-05   \\Device\\Tcpip_{0505-2018}");
  def(["route"], (args) => {
    if (!args.length || args[0].toLowerCase() === "print") {
      return [
        "Active Routes:",
        "Network Destination        Netmask          Gateway       Interface  Metric",
        "          0.0.0.0          0.0.0.0      192.168.5.1     192.168.5.5      1",
        "        127.0.0.0        255.0.0.0         127.0.0.1       127.0.0.1      1",
        "      192.168.5.0    255.255.255.0      192.168.5.5     192.168.5.5      1",
        "Default Gateway:       192.168.5.1"
      ].join("\n");
    }
    return "The route addition failed: Access is denied.";
  });
  def(["net"], (args) => {
    const sub = (args[0] || "help").toLowerCase();
    if (sub === "help" || sub === "/?") return HELP.net;
    if (sub === "view") return "Server Name\n---------------\n\\\\FIVEHEARTS\nThe command completed successfully.";
    if (sub === "user") return "User accounts for \\\\FIVEHEARTS\n-------------------------------------------------------------------------------\nGUEST                    ADMINISTRATOR\nThe command completed successfully.";
    if (sub === "use") return "New connections will be remembered.\n\nThere are no entries in the list.";
    if (sub === "share") return "Share name   Resource                        Remark\n-------------------------------------------------------------------------------\nC$           C:\\                             Default share\nIPC$                                         Remote IPC\nThe command completed successfully.";
    if (sub === "start") {
      if (!args[1]) {
        return [
          "These FIVEHEARTS services are started:",
          "",
          ...SERVICES.filter((s) => s.state === "RUNNING").map((s) => "  " + s.display),
          "",
          "The command completed successfully."
        ].join("\n");
      }
      return "The service name is invalid.";
    }
    if (sub === "stop") return "The service name is invalid.";
    return "The syntax of this command is:\n\nNET [ VIEW | USER | USE | SHARE | START | STOP | HELP ]";
  });
  def(["tasklist"], () => {
    const rows = runningTasks();
    const lines = [
      "Image Name                     PID Session Name        Session#    Mem Usage",
      "========================= ======== ================ =========== ============",
    ];
    rows.forEach((r) => {
      lines.push(`${r.name.padEnd(25)} ${String(r.pid).padStart(8)} Console                    1    ${r.mem.padStart(8)}`);
    });
    return lines.join("\n");
  });
  def(["taskkill"], (args, ctx) => {
    const { flags, rest } = switches(args);
    const im = args.find((a, i) => args[i - 1] && args[i - 1].toLowerCase() === "/im") || rest[0];
    if (!im) return "ERROR: Invalid argument/option.";
    const name = im.toLowerCase();
    if (name.indexOf("command") >= 0 || name === "cmd.exe") return "ERROR: The process cannot terminate itself.";
    const map = APPS[name] || APPS[name.replace(/\.exe$/, "")];
    const wins = document.querySelectorAll(".os-win:not([hidden])");
    let killed = false;
    wins.forEach((w) => {
      const id = (w.getAttribute("data-win") || "").toLowerCase();
      const title = ((w.querySelector(".os-win__bar span") || {}).textContent || "").toLowerCase();
      if (map === id || title.indexOf(name.replace(/\.exe$/, "")) >= 0) {
        window.FH && window.FH.os && window.FH.os.closeWin(w);
        killed = true;
      }
    });
    return killed ? "SUCCESS: The process \"" + im + "\" has been terminated." : "ERROR: The process \"" + im + "\" not found.";
  });
  def(["start"], (args, ctx) => {
    if (!args.length) return openApp("cmd") || "";
    const key = args[0].toLowerCase();
    if (key === "zork" || key === "zork.exe" || key === "adventure") return zorkStart(ctx);
    if (APPS[key]) return openApp(APPS[key]);
    if (key === "shop") return openApp("shop");
    const hit = resolve(ctx.state, args[0]);
    if (hit.ok && hit.node.kind === "file") {
      const n = (hit.parts[hit.parts.length - 1] || "").toLowerCase();
      if (n === "calc.exe") return openApp("calc");
      if (n === "notepad.exe") return openApp("info");
      if (n === "winver.exe") return openApp("sys");
      if (BINARIES.test(n)) return "This program cannot be run in DOS mode.";
      return cmds.type([args[0]], ctx);
    }
    return "The system cannot find the file " + args[0] + ".";
  });
  def(["notepad", "edit", "calc", "explorer", "mspaint", "wmplayer", "iexplore"], (args, ctx) => {
    const name = ctx.command;
    if (name === "edit" || name === "notepad") {
      if (args[0]) {
        const f = args[0].toLowerCase();
        if (f.indexOf("info") >= 0) return openApp("info");
      }
      return openApp("info");
    }
    return openApp(APPS[name] || name);
  });
  def(["exit"], (args, ctx) => {
    const win = ctx.form && ctx.form.closest(".os-win");
    if (win && window.FH && window.FH.os) window.FH.os.closeWin(win);
    return "";
  });
  def(["title"], (args, ctx) => {
    const win = ctx.form && ctx.form.closest(".os-win");
    const el = win && win.querySelector(".os-win__bar span");
    if (el) el.textContent = args.length ? args.join(" ") : "C:\\FIVEHEARTS\\CMD.EXE";
    return "";
  });
  def(["color"], (args, ctx) => {
    const box = ctx.form && ctx.form.closest(".os-cmd");
    if (!box) return "";
    const pal = {
      "0": "#000000",
      "4": "#7a1414",
      "6": "#8a7a3a",
      "7": "#cfc8b8",
      "8": "#6e6a62",
      "c": "#cc1e1e",
      "e": "#e8d5a3",
      "f": "#f4f1ec"
    };
    if (!args.length) {
      box.style.removeProperty("--cmd-bg");
      box.style.removeProperty("--cmd-fg");
      return "";
    }
    const a = args[0].replace(/^#/, "").toLowerCase();
    if (a.length === 1 && pal[a]) {
      box.style.setProperty("--cmd-fg", pal[a]);
      return "";
    }
    if (a.length === 2 && pal[a[0]] && pal[a[1]]) {
      box.style.setProperty("--cmd-bg", pal[a[0]]);
      box.style.setProperty("--cmd-fg", pal[a[1]]);
      return "";
    }
    return "Color not available in this build.";
  });
  def(["pause"], (args, ctx) => {
    ctx.state.wait = { type: "pause" };
    return "Press any key to continue . . .";
  });
  def(["rem"], () => "");
  def(["doskey"], (args, ctx) => {
    const { flags } = switches(args);
    if (flags.history || flags.h) return ctx.state.history.join("\n");
    return "DOSKEY loaded.\nUse UP/DOWN to recall. TAB to complete.";
  });
  def(["print"], () => "There is no printer connected to LPT1.");
  def(["chkdsk", "scandisk"], () => [
    "Checking drive C:",
    "Volume HEARTS",
    "",
    "    32,768,000 bytes total disk space",
    "    12,404,224 bytes in 18 hidden files",
    "     8,192,000 bytes in 12 directories",
    "     6,144,000 bytes in 40 user files",
    "     6,027,776 bytes available on disk",
    "",
    "     4,096 bytes in each allocation unit",
    "     8,000 total allocation units on disk",
    "     1,471 available allocation units on disk",
    "",
    "1 lost allocation unit found in 1 chain.",
    "Convert lost chains to files (Y/N)? N",
    "  4,096 bytes disk space would be freed."
  ].join("\n"));
  def(["format"], (args, ctx) => {
    ctx.state.wait = { type: "format" };
    return "WARNING, ALL DATA ON NON-REMOVABLE DISK\nDRIVE C: WILL BE LOST!\nProceed with Format (Y/N)?";
  });
  const kickReboot = (mode) => {
    const api = window.FH && window.FH.os;
    if (!api || !api.reboot) return "The system cannot restart.";
    setTimeout(() => api.reboot(mode), 80);
    return mode === "shutdown"
      ? "FIVEHEARTS OS is shutting down..."
      : "Restarting FIVEHEARTS OS...";
  };
  def(["shutdown"], (args) => {
    const { flags } = switches(args);
    if (flags.a || flags["-a"]) return "Unable to abort. No shutdown in progress.";
    if (wantedHelp(args)) return HELP.shutdown;
    const restart = flags.r || flags["-r"] || flags.restart;
    return kickReboot(restart ? "restart" : "shutdown");
  });
  def(["restart", "reboot"], (args) => {
    if (wantedHelp(args)) return HELP.restart;
    return kickReboot("restart");
  });
  def(["subst"], () => "Invalid parameter - drive letter is reserved.");
  def(["verify"], (args) => {
    if (!args.length) return "VERIFY is off.";
    return "VERIFY is " + (/^on$/i.test(args[0]) ? "on" : "off") + ".";
  });
  def(["break"], () => "BREAK is on.");
  def(["mode"], (args) => {
    if (!args.length) return "CON:  Status for device CON:\n    Lines=25  Columns=80\n    Code page operation not supported on this device";
    return "";
  });
  def(["timeout"], (args) => "Waiting for " + (args[1] || args[0] || "0") + " seconds, press a key to continue ...\n0");

  def(["pwd"], (args, ctx) => showPath(ctx.state.cwd));
  def(["history"], (args, ctx) => ctx.state.history.join("\n") || "The history list is empty.");
  def(["uname"], () => "FIVEHEARTS 5.05.0 i386 GUEST");
  def(["who", "finger", "users"], () => "FIVEHEARTS\\GUEST          console  " + new Date().toTimeString().slice(0, 8));
  def(["logoff", "logout"], () => "The guest cannot log off the desk.");
  def(["shop"], () => openApp("shop"));
  def(["info"], () => openApp("info"));
  def(["play", "winamp", "wmplayer"], () => openApp("play"));
  def(["videos"], () => openApp("videos"));
  def(["photos", "mspaint"], () => openApp("photos"));
  def(["bin", "recycle"], () => openApp("bin"));
  def(["clip"], (args, ctx) => {
    const text = args.length ? args.join(" ") : (ctx.stdin || "");
    if (!text) return "The clipboard is empty.";
    try { navigator.clipboard && navigator.clipboard.writeText(text); } catch (_) { /* */ }
    return "        1 line(s) copied.";
  });
  def(["for"], (args, ctx) => {
    const line = args.join(" ");
    const m = line.match(/^%?(\w)\s+in\s+\(([^)]*)\)\s+do\s+(.+)$/i);
    if (!m) return "The syntax of the command is incorrect.";
    const variable = m[1];
    const set = (m[2].trim() || "*");
    const body = m[3];
    const exp = expand(ctx.state, set);
    if (!exp.ok) return exp.err;
    if (!exp.names.length) return "";
    const out = [];
    exp.names.forEach((name) => {
      const filled = body.replace(new RegExp("%" + variable, "gi"), name);
      const r = dispatch(ctx.state, filled, ctx);
      if (r && r.text) out.push(r.text);
    });
    return out.join("\n");
  });
  def(["if"], (args, ctx) => {
    if (!args.length) return "The syntax of the command is incorrect.";
    const not = /^not$/i.test(args[0]);
    const rest = not ? args.slice(1) : args.slice();
    if (!/^exist$/i.test(rest[0]) || rest.length < 3) return "The syntax of the command is incorrect.";
    const hit = resolve(ctx.state, rest[1]);
    const ok = !!(hit.ok && hit.node);
    if (not ? !ok : ok) {
      const r = dispatch(ctx.state, rest.slice(2).join(" "), ctx);
      return (r && r.text) || "";
    }
    return "";
  });
  def(["call"], (args, ctx) => {
    if (!args.length) return "";
    const hit = resolve(ctx.state, args[0]);
    if (!hit.ok) return "The system cannot find the batch label specified.";
    const n = hit.parts[hit.parts.length - 1] || "";
    if (!/\.(bat|cmd)$/i.test(n)) return cmds.type(args, ctx);
    return runBat(ctx.state, readText(hit.node, n), ctx);
  });
  def(["debug"], (args, ctx) => {
    if (!args.length) return "Cannot run DEBUG. Protected mode is already active.";
    const hit = resolve(ctx.state, args[0]);
    if (!hit.ok) return "File not found";
    const n = hit.parts[hit.parts.length - 1] || args[0];
    const body = hit.node.bin || BINARIES.test(n) ? "MZ" : readText(hit.node, n);
    return "-d\n" + hexDump(body) + "\n-q";
  });
  def(["defrag"], () => [
    "Windows Disk Defragmenter",
    "Copyright (C) FIVEHEARTS 2018–2026",
    "",
    "Analysis Report for Volume HEARTS (C:)",
    "",
    "    Volume size                         =  32 MB",
    "    Cluster size                        =   4 KB",
    "    Used space                          =  26 MB",
    "    Free space                          =   6 MB",
    "    Percent free space                  =  18 %",
    "",
    "    Volume fragmentation                =   3 %",
    "    File fragmentation                  =   1 %",
    "",
    "You do not need to defragment this volume."
  ].join("\n"));
  def(["driverquery"], () => [
    "Module Name          Display Name           Driver Type   Start Mode",
    "==================== ====================== ============= ===========",
    "HIMEM                HIMEM.SYS              Kernel        Boot",
    "KERNEL               HOUSE Kernel           Kernel        Boot",
    "DeskNIC              FIVEHEARTS Desk NIC    Kernel        Auto",
    "Tape                 House Tape             Kernel        Auto",
    "Wings                Seal                   Kernel        Auto",
    "Mouse                MOUSE.COM              Kernel        Manual"
  ].join("\n"));
  def(["sfc"], (args) => {
    if (!args.length || args.some((a) => /scannow/i.test(a))) {
      return [
        "Beginning a system scan. This process will take some time.",
        "",
        "Beginning verification phase of system scan.",
        "Verification 100% complete.",
        "",
        "Windows Resource Protection did not find any integrity violations."
      ].join("\n");
    }
    return "SFC [/SCANNOW]";
  });
  def(["wmic"], (args, ctx) => {
    const q = args.join(" ").toLowerCase();
    if (!q || q === "os" || /os get/.test(q)) {
      return "Caption=FIVEHEARTS OS\nVersion=5.05.0\nManufacturer=HOUSE\nRegisteredUser=GUEST\nBuildNumber=505";
    }
    if (/computersystem/.test(q)) return "Name=FIVEHEARTS\nManufacturer=UNKNOWN\nModel=DESK\nUserName=FIVEHEARTS\\GUEST";
    if (/process/.test(q)) return cmds.tasklist([], ctx);
    if (/logicaldisk/.test(q)) return "DeviceID=C:\nVolumeName=HEARTS\nFileSystem=FAT32\nSize=32768000\nFreeSpace=6027776";
    return "ERROR:\nDescription = Invalid query";
  });
  def(["reg"], (args) => {
    const sub = (args[0] || "").toLowerCase();
    if (sub === "query" || !sub) {
      return [
        "HKEY_LOCAL_MACHINE\\SOFTWARE\\FIVEHEARTS",
        "    House       REG_SZ    FIVEHEARTS",
        "    Version     REG_SZ    5.05",
        "    Seal        REG_SZ    WINGS.PNG",
        "    Shop        REG_SZ    one surface"
      ].join("\n");
    }
    return "ERROR: Access is denied.";
  });
  def(["sc"], (args) => {
    const sub = (args[0] || "query").toLowerCase();
    const want = (args[1] || "").toLowerCase();
    const rows = want ? SERVICES.filter((s) => s.name.toLowerCase() === want || s.display.toLowerCase().indexOf(want) >= 0) : SERVICES;
    if (sub !== "query") return "ERROR:  Access is denied.";
    if (!rows.length) return "[SC] EnumQueryServicesStatus:OpenService FAILED 1060:\nThe specified service does not exist as an installed service.";
    return rows.map((s, i) => [
      "SERVICE_NAME: " + s.name,
      "DISPLAY_NAME: " + s.display,
      "        TYPE               : 10  WIN32_OWN_PROCESS",
      "        STATE              : " + (s.state === "RUNNING" ? "4  RUNNING" : "1  STOPPED"),
      "        WIN32_EXIT_CODE    : 0  (0x0)"
    ].join("\n")).join("\n\n");
  });
  def(["choice"], (args, ctx) => {
    ctx.state.wait = { type: "pause" };
    return "[Y,N]?";
  });

  const STUB = {
    debug: "Cannot run DEBUG. Protected mode is already active.",
    edlin: "EDLIN is not installed.",
    qbasic: "This program cannot be run in DOS mode.",
    gwbasic: "This program cannot be run in DOS mode.",
    fdisk: "This disk cannot be partitioned while the volume is mounted.",
    defrag: "Drive C: does not need defragmentation.",
    diskcopy: "Drive types or diskette types not compatible.",
    diskcomp: "Compare error.\nDrive types or diskette types not compatible.",
    backup: "BACKUP is not available. Use COPY.",
    restore: "No backup sets found.",
    undelete: "No entries found.",
    recover: "RECOVER is disabled on this volume.",
    join: "Invalid parameter.",
    assign: "Invalid drive specification.",
    share: "SHARE already installed.",
    ctty: "Invalid device.",
    keyb: "Unable to load keyboard layout.",
    graphics: "GRAPHICS is already loaded.",
    loadhigh: "This program cannot be loaded high.",
    lh: "This program cannot be loaded high.",
    fastopen: "FASTOPEN already installed.",
    append: "No appended directories.",
    mscdex: "MSCDEX already started.",
    smartdrv: "SMARTDRV is not loaded.",
    emm386: "EMM386 is already installed.",
    himem: "HIMEM is already installed.",
    sys: "Cannot SYS a drive in use.",
    replace: "No files replaced.",
    xms: "XMS driver already installed.",
    memmaker: "MEMMAKER cannot run while CMD.EXE is busy.",
    robocopy: "The syntax of the command is incorrect.\n\nUsage: ROBOCOPY source destination [file [file]...] [options]",
    wmic: "ERROR:\nDescription = Access denied.",
    sfc: "Windows Resource Protection could not start the repair service.",
    gpupdate: "Policy refresh has been completed (no changes).",
    gpresult: "INFO: The user does not have permission to perform this action.",
    sc: "ERROR:  Access is denied.",
    reg: "ERROR: Access is denied.",
    netsh: "The following command was not found: netsh.",
    telnet: "Telnet is not recognized as an internal or external command.",
    ftp: "ftp: connect: Connection refused",
    tftp: "Connect request failed.",
    driverquery: "No signed drivers found.",
    openfiles: "INFO: No files opened remotely.",
    clip: "The command completed successfully.",
    rundll32: "Missing entry.",
    msconfig: "This utility is locked.",
    dxdiag: "DirectX is not installed.",
    cmd: "",
    command: "",
    choice: "CHOICE is not available.",
    call: "The system cannot find the batch label specified.",
    goto: "The system cannot find the batch label specified.",
    shift: "",
    endlocal: "",
    setlocal: "",
    for: "The syntax of the command is incorrect.",
    if: "The syntax of the command is incorrect.",
    exist: "The syntax of the command is incorrect.",
    keys: "KEYS is on."
  };

  const complete = (state, line) => {
    const tokens = tokenize(line);
    const partial = / $/.test(line) ? "" : (tokens[tokens.length - 1] || "");
    const first = tokens.length <= 1 && !/ $/.test(line);
    let names;
    if (first) names = Object.keys(cmds).concat(Object.keys(STUB)).concat(["help"]);
    else {
      const hit = walk(state.root, state.cwd);
      names = hit.node && hit.node.kind === "dir" ? Object.keys(hit.node.children) : [];
    }
    const low = partial.toLowerCase();
    const hits = names.filter((n) => n.toLowerCase().startsWith(low));
    if (hits.length === 1) {
      const rest = first ? "" : line.slice(0, line.length - partial.length);
      return rest + hits[0] + (first ? " " : "");
    }
    return null;
  };

  const dispatch = (state, line, ctxBase) => {
    const meta = splitMeta(line);
    const tokens = tokenize(expandEnv(state, meta.rest)).filter(Boolean);
    if (!tokens.length) return { text: "" };
    if (/^echo\./i.test(tokens[0])) {
      const rest = tokens[0].replace(/^echo\./i, "");
      return { text: [rest].concat(tokens.slice(1)).filter((x) => x !== "").join(" ") };
    }
    const command = tokens[0].toLowerCase().replace(/^\.\.\\?/, "");
    const args = tokens.slice(1);
    const ctx = Object.assign({ state, command, stdin: ctxBase.stdin, form: ctxBase.form }, ctxBase);
    if (wantedHelp(args) && HELP[command]) return { text: HELP[command] };
    const fn = cmds[command];
    if (fn) {
      const out = fn(args, ctx);
      if (out && typeof out === "object" && out.clear) return out;
      return { text: out == null ? "" : String(out) };
    }
    if (STUB[command] != null) {
      return { text: STUB[command] };
    }
    const maybeFile = resolve(state, tokens[0]);
    if (maybeFile.ok && maybeFile.node.kind === "file") {
      const n = maybeFile.parts[maybeFile.parts.length - 1] || "";
      const low = n.toLowerCase();
      if (/\.(bat|cmd)$/i.test(n)) return { text: runBat(state, readText(maybeFile.node, n), ctx) };
      if (low === "virus.exe" || low === "enter.exe") return { text: "This program cannot be run in DOS mode." };
      if (low === "zork.exe") return { text: zorkStart(ctx) };
      const app = APPS[low] || APPS[low.replace(/\.exe$/, "")];
      if (app) return { text: openApp(app) };
      if (BINARIES.test(n) || maybeFile.node.bin) return { text: "This program cannot be run in DOS mode." };
      return { text: readText(maybeFile.node, n) };
    }
    const withExt = [".BAT", ".CMD", ".EXE", ".COM"].map((ext) => resolve(state, tokens[0] + ext)).find((h) => h.ok);
    if (withExt && withExt.node.kind === "file") {
      const n = withExt.parts[withExt.parts.length - 1] || "";
      const low = n.toLowerCase();
      if (/\.(bat|cmd)$/i.test(n)) return { text: runBat(state, readText(withExt.node, n), ctx) };
      if (low === "zork.exe") return { text: zorkStart(ctx) };
      const app = APPS[low] || APPS[low.replace(/\.exe$/, "")];
      if (app) return { text: openApp(app) };
      if (BINARIES.test(n) || withExt.node.bin) return { text: "This program cannot be run in DOS mode." };
    }
    if (APPS[command]) return { text: openApp(APPS[command]) };
    return { text: `'${tokens[0]}' is not recognized as an internal or external command,\noperable program or batch file.` };
  };

  const printJobs = new WeakMap();

  const printSfx = (n) => {
    const play = () => {
      if (window.FH && typeof window.FH.playSfx === "function") window.FH.playSfx("type");
    };
    const count = Math.max(0, Math.min(8, n | 0));
    if (!count) return;
    play();
    for (let i = 1; i < count; i++) setTimeout(play, i * (28 + Math.random() * 18));
  };

  const stopPrint = (log, flush) => {
    const job = printJobs.get(log);
    if (!job) return;
    job.dead = true;
    if (job.timer) clearTimeout(job.timer);
    if (flush && job.rest) log.textContent += job.rest;
    printJobs.delete(log);
    if (log) log.scrollTop = log.scrollHeight;
  };

  const applyOut = (form, log, text, clear) => {
    if (!log) return;
    if (clear) {
      stopPrint(log, false);
      log.textContent = "";
      return;
    }
    if (!text) return;
    const chunk = text.endsWith("\n") ? text : text + "\n";
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    stopPrint(log, true);
    if (reduced) {
      log.textContent += chunk;
      log.scrollTop = log.scrollHeight;
      printSfx(1);
      return;
    }
    const lines = chunk.split("\n");
    if (lines.length && lines[lines.length - 1] === "") lines.pop();
    if (!lines.length) return;
    const job = { i: 0, lines, timer: 0, rest: "", dead: false };
    printJobs.set(log, job);
    const step = () => {
      if (job.dead || printJobs.get(log) !== job) return;
      if (job.i >= lines.length) {
        printJobs.delete(log);
        return;
      }
      const line = lines[job.i++];
      log.textContent += line + "\n";
      job.rest = lines.slice(job.i).map((row) => row + "\n").join("");
      log.scrollTop = log.scrollHeight;
      if (line.length) printSfx(1);
      const long = lines.length > 28;
      const gap = line.length
        ? (long ? 15 + Math.random() * 11 : 24 + Math.min(32, line.length * 0.32) + Math.random() * 16)
        : (long ? 8 : 12 + Math.random() * 10);
      job.timer = setTimeout(step, gap);
    };
    step();
  };

  const exec = (line, ctx) => {
    const form = ctx.form;
    const log = ctx.log;
    const state = stateFor(form);
    ensureDeskFiles(state);
    if (state.wait) {
      const wait = state.wait;
      const ans = String(line || "").trim();
      state.wait = null;
      if (log && wait.type !== "pause") {
        log.textContent = log.textContent.replace(/\s*$/, "") + " " + (ans || "") + "\n";
      }
      if (wait.type === "pause") return true;
      if (wait.type === "format") {
        applyOut(form, log, /^y/i.test(ans)
          ? "Format cannot run because the volume is in use.\nFormat terminated."
          : "Format terminated.");
        return true;
      }
      if (wait.type === "del") {
        if (!/^y/i.test(ans)) return true;
        wait.files.forEach((n) => {
          const node = wait.parent.children[n];
          if (node && !node.ro) delete wait.parent.children[n];
          else if (node && node.ro) applyOut(form, log, "Access is denied. " + n);
        });
        return true;
      }
      return true;
    }
    if (!line) return false;

    state.history.push(line);
    state.histI = state.history.length;

    const runSegment = (segment) => {
      const meta = splitMeta(segment);
      if (meta.pipe) {
        const left = dispatch(state, meta.rest, { form, log, stdin: null });
        if (left.clear) {
          applyOut(form, log, "", true);
          return;
        }
        const right = dispatch(state, meta.pipe, { form, log, stdin: left.text });
        let text = right.text || "";
        if (meta.redir) {
          const err = writeFile(state, meta.redir, text.endsWith("\n") ? text : text + "\n", meta.mode === "append");
          if (err) applyOut(form, log, err);
        } else applyOut(form, log, text);
        return;
      }
      const result = dispatch(state, meta.rest, { form, log, stdin: null });
      if (result.clear) {
        applyOut(form, log, "", true);
        return;
      }
      const text = result.text || "";
      if (meta.redir) {
        const err = writeFile(state, meta.redir, text.endsWith("\n") ? text : text + "\n", meta.mode === "append");
        if (err) applyOut(form, log, err);
        return;
      }
      applyOut(form, log, text);
    };

    splitChain(line).forEach(runSegment);
    return true;
  };

  const waiting = (form) => !!(form && stateFor(form).wait);

  const logOf = (form) => {
    const box = form && form.closest(".os-cmd");
    return (box && box.querySelector("[data-cmd-log], [data-cons-log], .os-cmd__log")) || null;
  };

  const bindInput = (form, input) => {
    if (!form || !input || input._cmdBound) return;
    input._cmdBound = true;
    const state = stateFor(form);
    input.addEventListener("keydown", (e) => {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        if (!state.history.length) return;
        state.histI = Math.max(0, state.histI - 1);
        input.value = state.history[state.histI] || "";
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        state.histI = Math.min(state.history.length, state.histI + 1);
        input.value = state.histI >= state.history.length ? "" : state.history[state.histI];
      } else if (e.key === "Tab") {
        e.preventDefault();
        const next = complete(state, input.value);
        if (next != null) input.value = next;
      }
    });
  };

  const bindForm = (form) => {
    if (!form || form._cmdSubmit) return;
    form._cmdSubmit = true;
    const input = form.querySelector("[data-cmd-in], [data-cons-in], input");
    bindInput(form, input);
    syncPrompt(form, stateFor(form));
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const log = logOf(form);
      const state = stateFor(form);
      const cons = form.hasAttribute("data-cons-form");
      const line = ((input && input.value) || "").trim();
      if (input) input.value = "";
      if (waiting(form)) {
        exec(line, { log, input, form });
        if (log) log.scrollTop = log.scrollHeight;
        return;
      }
      if (!line) {
        if (log) {
          stopPrint(log, true);
          if (state.zork && !cons) applyOut(form, log, ">\nI beg your pardon?");
          else {
            log.textContent += formatPrompt(state) + "\n";
            printSfx(1);
          }
          log.scrollTop = log.scrollHeight;
        }
        return;
      }
      if (log) {
        stopPrint(log, true);
        log.textContent += formatPrompt(state) + line + "\n";
        log.scrollTop = log.scrollHeight;
        printSfx(1);
      }
      const gate = window.FH && window.FH.arg && window.FH.arg.onCmd;
      if (gate && await gate(line, log)) {
        if (log) log.scrollTop = log.scrollHeight;
        return;
      }
      if (state.zork && !cons) {
        state.history.push(line);
        state.histI = state.history.length;
        const turn = zorkTurn(state, line);
        applyOut(form, log, (turn.lines || []).join("\n"));
        if (turn.quit) state.zork = null;
        syncPrompt(form, state);
        if (log) log.scrollTop = log.scrollHeight;
        return;
      }
      exec(line, { log, input, form });
      syncPrompt(form, stateFor(form));
      if (log) log.scrollTop = log.scrollHeight;
    }, true);
  };

  const attach = () => {
    document.querySelectorAll("[data-cmd-form], [data-cons-form]").forEach(bindForm);
  };

  window.FH = window.FH || {};
  window.FH.cmd = { exec, waiting, attach };

  addEventListener("fh:reset", () => {
    document.querySelectorAll("[data-cmd-form], [data-cons-form]").forEach((form) => {
      if (sessions.has(form)) {
        const state = sessions.get(form);
        state.cwd = ["FIVEHEARTS"];
        state.root = makeFs();
        state.env = Object.assign({}, ENV0, form.hasAttribute("data-cons-form") ? { PROMPT: "$G" } : {});
        state.history = [];
        state.histI = 0;
        state.wait = null;
        state.zork = null;
        syncPrompt(form, state);
      }
      const log = logOf(form);
      if (!log) return;
      stopPrint(log, false);
      if (form.hasAttribute("data-cons-form")) log.textContent = "";
      else log.textContent = bootText() + "\n\n";
      const input = form.querySelector("[data-cmd-in], [data-cons-in], input");
      if (input) input.value = "";
    });
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", attach);
  else attach();
})();
